
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hZy36 = parcelRequire("hZy36");

var $3H7QB = parcelRequire("3H7QB");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-1b9f3d24ed";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
(0, $hZy36.configureCastle)();
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: 'ja',
        langRoute: 'ja'
    },
    {
        hrefLang: 'fr',
        langRoute: 'fr'
    },
    {
        hrefLang: 'de',
        langRoute: 'de'
    },
    {
        hrefLang: 'es',
        langRoute: 'es'
    },
    {
        hrefLang: 'pt-BR',
        langRoute: 'br'
    },
    {
        hrefLang: 'zh-Hans',
        langRoute: 'zh'
    },
    {
        hrefLang: 'ko',
        langRoute: 'ko'
    },
    {
        hrefLang: 'ru',
        langRoute: 'ru'
    },
    {
        hrefLang: 'pl',
        langRoute: 'pl'
    },
    {
        hrefLang: 'it',
        langRoute: 'it'
    },
    {
        hrefLang: 'nl',
        langRoute: 'nl'
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== 'undefined' && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== 'undefined') locationData = {
        countryIsoCode: window.countryCode || '',
        regionIsoCode: window.regionIsoCode || ''
    };
    // In Uniform Playground (preview authoring environment), skip OneTrust check
    // and assume performance tracking is enabled — mirrors OneTrustProvider behavior.
    // Cookies are unavailable in the cross-origin iframe context, so the normal
    // cookie-based check always returns false for CPRA users (e.g. California).
    const isPerfOnetrustEnabled = window.isUniformPlayground || (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== 'undefined' ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(async ()=>{
        try {
            await (0, $3H7QB.DynamicConfigClient).getInstance().initialize({
                bootstrapValues: window.featureGateBootstrapValues
            });
        } catch (error) {
            console.error('Failed to initialize DynamicConfigClient', error);
        }
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? '' : pathForCanonical === '' ? '' : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${canonicalBaseUrl}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${canonicalBaseUrl}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    channel: window.channel,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-expect-error type
            const root = (0, $konOj.createRoot)(document.getElementById('wac'));
            root.render(page);
        } else // @ts-expect-error type
        (0, $konOj.hydrateRoot)(document.getElementById('wac-root'), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById('wac-root')?.setAttribute('hydration-error', 'true');
            }
        });
    });
};

});

parcelRegister("dXL3R", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePage", function () { return $9d047481379b0727$export$a6be62ed06c967ea; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $67UrT = parcelRequire("67UrT");

var $9rnwe = parcelRequire("9rnwe");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $1rObi = parcelRequire("1rObi");

var $2WL8B = parcelRequire("2WL8B");

var $bTseT = parcelRequire("bTseT");

var $5JA6e = parcelRequire("5JA6e");

var $2V8Su = parcelRequire("2V8Su");

var $kP8Dm = parcelRequire("kP8Dm");

var $gHXqX = parcelRequire("gHXqX");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $C5M69 = parcelRequire("C5M69");
const $9d047481379b0727$var$JIRA_REDIRECT_DESTINATION_PATH = '/jira/for-you';
const $9d047481379b0727$var$JIRA_REDIRECT_SOURCE_PARAM = 'redirectSource';
const $9d047481379b0727$var$JIRA_REDIRECT_ANALYTICS_SUBJECT = 'loggedInJiraProductRedirect';
const $9d047481379b0727$var$JIRA_REDIRECT_EXPERIMENT_NAME = (0, $4X0dO.experiments).d1d6redirectLoggedInUsers.experimentName;
// Timeout threshold for site resolution — if it takes longer than this, we fire a timeout failure event
const $9d047481379b0727$var$SITE_RESOLUTION_TIMEOUT_MS = 5000;
const $9d047481379b0727$export$7982efb1b32a7873 = (siteUrl)=>{
    if (!siteUrl) return undefined;
    try {
        const jiraForYouUrl = new URL(`${$9d047481379b0727$var$JIRA_REDIRECT_DESTINATION_PATH}?tab=recommendedActions`, siteUrl);
        jiraForYouUrl.searchParams.set($9d047481379b0727$var$JIRA_REDIRECT_SOURCE_PARAM, $9d047481379b0727$var$JIRA_REDIRECT_EXPERIMENT_NAME);
        return jiraForYouUrl.href;
    } catch  {
        return undefined;
    }
};
const $9d047481379b0727$export$a6be62ed06c967ea = ()=>{
    const loggedInHasJira = (0, $2WL8B.useLoggedInHasJira)();
    const isWae = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).dxpMigrationJiraProductTourGate);
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp737EnableIntercomChatJsw);
    const redirectLoggedInUsersExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).d1d6redirectLoggedInUsers);
    const shouldRedirectLoggedInUsers = redirectLoggedInUsersExperiment.type === (0, $gIKKj.EnrollmentType).ENROLLED && redirectLoggedInUsersExperiment.value;
    let template = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gHXqX.LoggedOutOrNoJiraProductTourOverview), {});
    // For logged in, we will either redirect to Jira, show a "Has Jira" experience,
    // or otherwise the Uniform "logged out" page.
    if (loggedInHasJira) template = shouldRedirectLoggedInUsers ? /*#__PURE__*/ (0, $7VQPk.jsx)($9d047481379b0727$var$RedirectingLoggedInJiraPage, {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5JA6e.LoggedInHeroContainer), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2V8Su.OrganicLoggedInJiraProductTourOverview), {})
    });
    else if (isWae) template = /*#__PURE__*/ (0, $7VQPk.jsx)($9d047481379b0727$var$WaeJiraPage, {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "jira-product-tour-overview",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
            appId: "p0ww63i2",
            triggerBoot: isBootIntercom,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rObi.CrossFlowTouchpointProvider), {
                productKeys: [
                    (0, $20OkY.ProductKeys).JIRA_SOFTWARE
                ],
                screenName: "wacJswProductTourPage",
                children: template
            })
        })
    });
};
const $9d047481379b0727$var$RedirectingLoggedInJiraPage = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { siteUrl: siteUrl, isResolvingSite: isResolvingSite } = (0, $kP8Dm.useRecentJiraSite)();
    const [redirectAssignFailed, setRedirectAssignFailed] = (0, $1oC0p.useState)(false);
    const hasTrackedAttemptRef = (0, $1oC0p.useRef)(false);
    const hasTrackedFailureRef = (0, $1oC0p.useRef)(false);
    const loadingStartTimeRef = (0, $1oC0p.useRef)(null);
    const jiraForYouUrl = $9d047481379b0727$export$7982efb1b32a7873(siteUrl);
    const fireRedirectAnalyticsEvent = (0, $1oC0p.useCallback)(({ action: action, failureReason: failureReason, errorMessage: errorMessage, durationMs: durationMs })=>{
        // All events use 'track' so they are forwarded to Statsig/Socrates for experiment analysis
        createAnalyticsEvent({
            eventType: 'track',
            action: action,
            actionSubject: $9d047481379b0727$var$JIRA_REDIRECT_ANALYTICS_SUBJECT,
            actionSubjectId: $9d047481379b0727$var$JIRA_REDIRECT_EXPERIMENT_NAME,
            source: '/software/jira',
            attributes: {
                experimentName: $9d047481379b0727$var$JIRA_REDIRECT_EXPERIMENT_NAME,
                redirectSource: $9d047481379b0727$var$JIRA_REDIRECT_EXPERIMENT_NAME,
                redirectDestinationPath: $9d047481379b0727$var$JIRA_REDIRECT_DESTINATION_PATH,
                failureReason: failureReason,
                errorMessage: errorMessage,
                durationMs: durationMs
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    // Track when loading starts and set up a timeout to detect hangs
    (0, $1oC0p.useEffect)(()=>{
        if (!isResolvingSite) return;
        loadingStartTimeRef.current = Date.now();
        fireRedirectAnalyticsEvent({
            action: 'loading_started'
        });
        const timeoutId = setTimeout(()=>{
            if (!hasTrackedFailureRef.current) {
                hasTrackedFailureRef.current = true;
                // Use actual elapsed time; fall back to the threshold constant if start time was lost
                const elapsed = loadingStartTimeRef.current !== null ? Date.now() - loadingStartTimeRef.current : $9d047481379b0727$var$SITE_RESOLUTION_TIMEOUT_MS;
                fireRedirectAnalyticsEvent({
                    action: 'failed',
                    failureReason: 'site_resolution_timeout',
                    durationMs: elapsed
                });
            }
        }, $9d047481379b0727$var$SITE_RESOLUTION_TIMEOUT_MS);
        return ()=>clearTimeout(timeoutId);
    }, [
        isResolvingSite,
        fireRedirectAnalyticsEvent
    ]);
    // Track when loading completes and how long it took
    (0, $1oC0p.useEffect)(()=>{
        if (isResolvingSite || loadingStartTimeRef.current === null) return;
        const durationMs = Date.now() - loadingStartTimeRef.current;
        loadingStartTimeRef.current = null;
        fireRedirectAnalyticsEvent({
            action: 'loading_completed',
            durationMs: durationMs
        });
    }, [
        isResolvingSite,
        fireRedirectAnalyticsEvent
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!jiraForYouUrl || redirectAssignFailed || hasTrackedAttemptRef.current) return;
        hasTrackedAttemptRef.current = true;
        fireRedirectAnalyticsEvent({
            action: 'initiated'
        });
        try {
            window.location.assign(jiraForYouUrl);
        } catch (error) {
            setRedirectAssignFailed(true);
            if (!hasTrackedFailureRef.current) {
                hasTrackedFailureRef.current = true;
                fireRedirectAnalyticsEvent({
                    action: 'failed',
                    failureReason: 'redirect_assign_failed',
                    errorMessage: error instanceof Error ? error.message : String(error)
                });
            }
        }
    }, [
        jiraForYouUrl,
        redirectAssignFailed,
        fireRedirectAnalyticsEvent
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (isResolvingSite || jiraForYouUrl || hasTrackedFailureRef.current) return;
        hasTrackedFailureRef.current = true;
        fireRedirectAnalyticsEvent({
            action: 'failed',
            failureReason: 'missing_redirect_target'
        });
    }, [
        isResolvingSite,
        jiraForYouUrl,
        fireRedirectAnalyticsEvent
    ]);
    if (isResolvingSite) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $C5M69.JiraSoftwarePageLoadingSpinner), {});
    return jiraForYouUrl && !redirectAssignFailed ? null : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5JA6e.LoggedInHeroContainer), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2V8Su.OrganicLoggedInJiraProductTourOverview), {})
    });
};
const $9d047481379b0727$var$WaeJiraPage = ()=>{
    const { composition: composition } = (0, $9rnwe.useWAEContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $67UrT.UniformEntryPage), {
        composition: composition
    });
};

});
parcelRegister("67UrT", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPage", function () { return $567142e6bd5e85f1$export$f0d4a992b207ed41; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iSeHD = parcelRequire("iSeHD");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");

var $ipRTK = parcelRequire("ipRTK");
const $567142e6bd5e85f1$export$f0d4a992b207ed41 = ({ composition: composition, compositionMetrics: compositionMetrics, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { compositionFetchStart: compositionFetchStart, compositionCacheStatus: compositionCacheStatus, ssrEndTime: ssrEndTime } = compositionMetrics || {};
    const sendPageRenderAnalyticsEvent = (0, $1oC0p.useCallback)((pageRenderTime, ssrEndTime, compositionFetchStart, fcp)=>{
        if (pageRenderTime && analyticsClient) analyticsClient.sendUIEvent({
            action: 'pageRender',
            actionSubject: 'uniformPage',
            source: window.location.pathname,
            attributes: {
                pageRenderTime: pageRenderTime,
                compositionFetchStart: compositionFetchStart,
                ssrEndTime: ssrEndTime,
                compositionCacheStatus: compositionCacheStatus,
                fcp: fcp,
                isUniformPlayground: isUniformPlayground || false
            }
        });
    }, [
        analyticsClient,
        compositionCacheStatus,
        isUniformPlayground
    ]);
    (0, $1oC0p.useEffect)(()=>{
        // @ts-ignore
        const measureFirstContentfulPaint = ()=>{
            try {
                // First, check if FCP is already available
                const paintEntries = performance.getEntriesByType('paint');
                const firstContentfulPaint = paintEntries.find((entry)=>entry.name === 'first-contentful-paint');
                if (firstContentfulPaint && ssrEndTime && compositionFetchStart) {
                    const fcp = firstContentfulPaint.startTime;
                    // Calculate page render time
                    const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                    if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                    return firstContentfulPaint.startTime;
                }
                // If FCP isn't available yet, observe for it
                const observer = new PerformanceObserver((list)=>{
                    const entries = list.getEntries();
                    const fcpEntry = entries.find((entry)=>entry.name === 'first-contentful-paint');
                    if (fcpEntry && compositionFetchStart && ssrEndTime) {
                        const fcp = fcpEntry.startTime;
                        // Calculate page render time
                        const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                        if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                        observer.disconnect();
                    }
                });
                observer.observe({
                    entryTypes: [
                        'paint'
                    ]
                });
                // Cleanup observer after 10 seconds to prevent memory leaks
                setTimeout(()=>{
                    observer.disconnect();
                }, 10000);
                return undefined;
            } catch (error) {
                console.warn('Error measuring Page Render Time:', error);
                return undefined;
            }
        };
        measureFirstContentfulPaint();
    }, [
        compositionFetchStart,
        compositionMetrics,
        sendPageRenderAnalyticsEvent,
        ssrEndTime
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "uniform-entry-page-root",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ipRTK.UniformEntryPageTemplate), {
                    composition: composition,
                    isUniformPlayground: isUniformPlayground,
                    isAllowPostMessage: isAllowPostMessage
                })
            })
        })
    });
};

});
parcelRegister("7WM7y", function(module, exports) {
$parcel$export(module.exports, "FourOhFourPageTemplate", function () { return $b3e0454f7f1f85f3$export$580adf4c24c28053; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $9GLx2 = parcelRequire("9GLx2");

var $bv77X = parcelRequire("bv77X");

var $7GVWk = parcelRequire("7GVWk");

var $5Ntyw = parcelRequire("5Ntyw");

var $iLjCW = parcelRequire("iLjCW");

var $hcVGp = parcelRequire("hcVGp");

var $1ka2O = parcelRequire("1ka2O");

var $4d61Q = parcelRequire("4d61Q");
const $b3e0454f7f1f85f3$export$580adf4c24c28053 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9GLx2.default), {
        locale: "en",
        messages: {},
        defaultLocale: "en",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Ntyw.BxpWebStargateClientProvider), {
            baseUrl: (0, $5Ntyw.getStargateBaseUrl)(),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bv77X.SitesContextProvider), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7GVWk.UserContextProvider), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": "404-page",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1ka2O.LocationProvider), {
                            location: typeof window !== 'undefined' ? window.location : {
                                pathname: '/',
                                href: '/'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
                                        isShowTryNowLink: true,
                                        tryNowLinkCtaButtonColor: "light_grey",
                                        productKey: "404"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4d61Q.MainSection), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
                            ]
                        })
                    })
                })
            })
        })
    });
};

});

parcelRegister("ipRTK", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return $9b881e462c85fa95$export$8328465fb6b6a7d2; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $dNSrU = parcelRequire("dNSrU");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");

var $g7CEg = parcelRequire("g7CEg");

var $9rnwe = parcelRequire("9rnwe");
const $9b881e462c85fa95$export$8328465fb6b6a7d2 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const { uniformContext: uniformContext } = (0, $9rnwe.useWAEContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dNSrU.UniformContext), {
            context: uniformContext,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7CEg.UniformWrapper), {
                composition: composition,
                isUniformPlayground: isUniformPlayground,
                isAllowPostMessage: isAllowPostMessage
            })
        })
    });
};

});


parcelRegister("bTseT", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return $d787a990cb9c57de$export$5091c5023e5c7eba; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $5Ntyw = parcelRequire("5Ntyw");

var $cIXzQ = parcelRequire("cIXzQ");
const $d787a990cb9c57de$var$isWindowExist = typeof window !== 'undefined';
const $d787a990cb9c57de$export$e578ca56db818a8e = /*#__PURE__*/ $1oC0p.createContext(undefined);
const $d787a990cb9c57de$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $1oC0p.useRef(false);
    const isInit = $1oC0p.useRef(false);
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const initIntercomInstance = $1oC0p.useCallback(()=>{
        if (!isInit.current) {
            (0, $cIXzQ.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $1oC0p.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === 'complete') // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener('DOMContentLoaded', handleLoad);
                    window.removeEventListener('load', handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener('DOMContentLoaded', handleLoad);
                window.addEventListener('load', handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error('Intercom: DOM ready timeout reached, proceeding anyway');
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $1oC0p.useCallback(async ()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isInit.current && !isBooted.current) {
            const intercomSettings = window.intercomSettings ?? {
                app_id: appId
            };
            try {
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                window.Intercom?.('boot', {
                    alignment: 'right',
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: '#intercomLauncher',
                    ...intercomSettings
                });
                window.Intercom?.('trackEvent', 'widget-loaded');
            } catch (error) {
                console.warn('Intercom boot failed:', error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $1oC0p.useCallback(()=>{
        if (!isBooted.current) return;
        if ($d787a990cb9c57de$var$isWindowExist) {
            window.Intercom?.('shutdown');
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $1oC0p.useCallback(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) window.Intercom?.('show');
    }, []);
    const hide = $1oC0p.useCallback(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) window.Intercom?.('hide');
    }, []);
    $1oC0p.useEffect(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $6GqRO.default).get('ajs_anonymous_id') || '';
            if (anonId) intercomSettingsObj['anonymousId'] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj['name'] = getwayApiMeGetResponse.name;
                intercomSettingsObj['email'] = getwayApiMeGetResponse.email;
            }
            if ($d787a990cb9c57de$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $1oC0p.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d787a990cb9c57de$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $d787a990cb9c57de$export$28418e623d2470bc = ()=>{
    const context = $1oC0p.useContext($d787a990cb9c57de$export$e578ca56db818a8e);
    if (context === undefined) throw new Error('This hook must be used within IntercomProvider');
    return context;
};

});
parcelRegister("cIXzQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $578d2b441e63143c$export$2e2bcd8739ae039; });
function $578d2b441e63143c$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, 'attachEvent');
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $578d2b441e63143c$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            const s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.intercom.io/widget/' + appId;
            const x = d.getElementsByTagName('script')[0];
            x?.parentNode?.insertBefore(s, x);
        };
        if (document.readyState === 'complete') l();
        else if ($578d2b441e63143c$var$isIELikeWindow(w)) w.attachEvent('onload', l);
        else w.addEventListener('load', l, false);
    }
};
var $578d2b441e63143c$export$2e2bcd8739ae039 = $578d2b441e63143c$var$initializeIntercomInstance;

});


parcelRegister("5JA6e", function(module, exports) {
$parcel$export(module.exports, "LoggedInHeroContainer", function () { return $7dd9a4cf5c1be356$export$c91dc4c235bd2e79; });

var $7VQPk = parcelRequire("7VQPk");

var $3Ccrv = parcelRequire("3Ccrv");

var $7GVWk = parcelRequire("7GVWk");

var $ZCSXq = parcelRequire("ZCSXq");
const $7dd9a4cf5c1be356$export$c91dc4c235bd2e79 = ({ children: children })=>{
    const { profile: { requestInProgress: profileRequestInProgress }, user: { requestInProgress: userRequestInProgress } } = (0, $7GVWk.useUserContext)();
    // Checking for both user and profile request in progress,
    // since profileRequestInProgress is initially defined as 'false' and then gets updated to true when the request is made.
    if (userRequestInProgress || profileRequestInProgress) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3Ccrv.default), {
        name: 'logged-in-hero-loading',
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ZCSXq.LoggedInHeroSkeleton), {})
    });
    return children;
};

});
parcelRegister("ZCSXq", function(module, exports) {
$parcel$export(module.exports, "LoggedInHeroSkeleton", function () { return $136a2b90265c9861$export$84abebbf129cccbc; });
/* logged-in-hero-skeleton.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eUwCn = parcelRequire("eUwCn");
const $136a2b90265c9861$var$headingSectionGap = null;
const $136a2b90265c9861$var$sectionGap = null;
const $136a2b90265c9861$var$contianerStyles = null;
const $136a2b90265c9861$var$mobileDisplay = null;
const $136a2b90265c9861$var$desktopDisplay = null;
const $136a2b90265c9861$export$84abebbf129cccbc = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "logged-in-jira-pt-skeleton",
        className: (0, $2jatx.default)([
            "_1pfh1ejb"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1ule _1mjbglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rth1epz"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "1152px",
                                height: "48px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthxncg _1eglxncg"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "1140px",
                                height: "1140px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _1mjb1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rth1epz"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "480px",
                                height: "48px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthxncg _1eglxncg"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "480px",
                                height: "480px"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});


parcelRegister("2V8Su", function(module, exports) {
$parcel$export(module.exports, "OrganicLoggedInJiraProductTourOverview", function () { return $416013fb4d6c28df$export$49bc6fac881dd811; });

var $7VQPk = parcelRequire("7VQPk");

var $iLjCW = parcelRequire("iLjCW");

var $l4vdU = parcelRequire("l4vdU");

var $izdHQ = parcelRequire("izdHQ");

var $5S2vX = parcelRequire("5S2vX");

var $4afjM = parcelRequire("4afjM");

var $ly0rU = parcelRequire("ly0rU");

var $lTaG1 = parcelRequire("lTaG1");

var $jmYmp = parcelRequire("jmYmp");
const $416013fb4d6c28df$export$49bc6fac881dd811 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: "jfind-1506-after-d7-gubtp-organic",
        group: "jfind-1506-after-d7-gubtp-organic",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
            experimentKey: "jfind-organic-jpt-logged-in-redesign",
            group: "jfind-organic-jpt-logged-in-redesign",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $ly0rU.JiraSitesProvider), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4vdU.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jmYmp.default), {})
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        scrollTrackingEnabled: true,
                        pageId: "jsw",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4afjM.ReturningUserBanner), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTaG1.LoggedInHeroSection), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
                        ]
                    })
                ]
            })
        })
    });
};

});
parcelRegister("l4vdU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $73f92d32d2fa0cb0$export$2e2bcd8739ae039; });
/* sticky-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $73f92d32d2fa0cb0$var$StickyContainer = ({ children: children })=>{
    const isMultipleStickyStart = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacLiftedBannerSticky);
    if (!isMultipleStickyStart) return children;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "banner-nav-combo",
        className: (0, $2jatx.default)([
            "_kqsw1if8 _152tidpf _1pbyqfx8"
        ]),
        children: children
    });
};
const $73f92d32d2fa0cb0$var$sticky = null;
var $73f92d32d2fa0cb0$export$2e2bcd8739ae039 = $73f92d32d2fa0cb0$var$StickyContainer;

});

parcelRegister("5S2vX", function(module, exports) {
$parcel$export(module.exports, "useParentScrollTracking", function () { return $d703c208f3e9c795$export$164ddb76b909974a; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return $d703c208f3e9c795$export$248f1dfc9396e7e4; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $je135 = parcelRequire("je135");
const $d703c208f3e9c795$var$ScrollTrackingContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    pageId: 'wac-web',
    scrollTrackingEnabled: true
});
const $d703c208f3e9c795$export$164ddb76b909974a = ()=>{
    return (0, $1oC0p.useContext)($d703c208f3e9c795$var$ScrollTrackingContext);
};
const $d703c208f3e9c795$export$248f1dfc9396e7e4 = (props)=>{
    const parentContext = $d703c208f3e9c795$export$164ddb76b909974a();
    const arrayChildren = (0, $1oC0p.Children).toArray(props.children);
    const definedName = (child)=>{
        if (/*#__PURE__*/ (0, $1oC0p.isValidElement)(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type;
            return namedComponent.displayName;
        } else return undefined;
    };
    // Determine tracking of parent undefined means true
    const parentTrackScrolling = parentContext.scrollTrackingEnabled === undefined ? true : parentContext.scrollTrackingEnabled;
    // Parent should take precedence if parent tracking is disabled
    const trackScrolling = parentTrackScrolling && (props.scrollTrackingEnabled === undefined ? true : props.scrollTrackingEnabled);
    const pageId = props.pageId ?? parentContext.pageId;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d703c208f3e9c795$var$ScrollTrackingContext.Provider, {
        value: {
            pageId: pageId,
            scrollTrackingEnabled: trackScrolling
        },
        children: (0, $1oC0p.Children).map(arrayChildren, (child, index)=>{
            const name = definedName(child);
            return name ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $je135.ScrollTracking), {
                index: `${index}/${arrayChildren.length}`,
                section: name,
                as: props.as,
                children: child
            }, index) : child;
        })
    });
};

});
parcelRegister("je135", function(module, exports) {
$parcel$export(module.exports, "useScrollTracking", function () { return $0fbf1a9bc3d0315b$export$17700584f55fbc70; });
$parcel$export(module.exports, "ScrollTracking", function () { return $0fbf1a9bc3d0315b$export$1725757b7947b890; });
$parcel$export(module.exports, "withScrollTracking", function () { return $0fbf1a9bc3d0315b$export$391633ede08dabb1; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jKShK = parcelRequire("jKShK");

var $eY3N6 = parcelRequire("eY3N6");

var $5S2vX = parcelRequire("5S2vX");

var $iSeHD = parcelRequire("iSeHD");
const $0fbf1a9bc3d0315b$export$17700584f55fbc70 = (section, props = {})=>{
    const { index: index, observerOptions: observerOptions, dwellTimeEnabled: dwellTimeEnabled, additionalAttributes: additionalAttributes } = props;
    const hasFunctionBeenCalled = (0, $1oC0p.useRef)(false);
    const scrollPercentage = (0, $1oC0p.useRef)(0);
    const { pageId: pageId, scrollTrackingEnabled: scrollTrackingEnabled } = (0, $5S2vX.useParentScrollTracking)();
    const { ref: ref, inView: inView, entry: entry } = (0, $jKShK.useInView)({
        threshold: 0.5,
        triggerOnce: true,
        ...observerOptions,
        skip: observerOptions?.skip || !scrollTrackingEnabled
    });
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleScroll = ()=>{
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;
        scrollPercentage.current = Math.round(currentPosition / (fullHeight - windowHeight) * 100);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (inView && !hasFunctionBeenCalled.current && section) {
            handleScroll();
            const scrollTrackAnalyticsPayload = {
                eventType: 'ui',
                action: 'scrolledTo',
                actionSubject: 'section',
                source: window.location.pathname,
                attributes: {
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId,
                    ...additionalAttributes
                }
            };
            const dwellTimeTrackAnalyticsPayload = {
                eventType: 'ui',
                action: 'dwellTimeTracked',
                actionSubject: 'section',
                source: window.location.pathname,
                attributes: {
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId,
                    ...additionalAttributes
                }
            };
            if (analyticsClient) {
                createAnalyticsEvent({
                    ...scrollTrackAnalyticsPayload
                }).fire();
                hasFunctionBeenCalled.current = true;
            }
            if (dwellTimeEnabled) {
                const activityEvents = [
                    'mousemove',
                    'keydown',
                    'scroll',
                    'touchstart'
                ];
                let intervalId = undefined;
                let activityTimeout = undefined;
                let active = true;
                // stop tracking after 1 minute of inactivity
                const setActive = ()=>{
                    active = true;
                    clearTimeout(activityTimeout);
                    activityTimeout = setTimeout(()=>{
                        active = false;
                    }, 60000);
                };
                activityEvents.forEach((evt)=>{
                    window.addEventListener(evt, setActive);
                });
                // emmit every 5 seconds if the user is active
                intervalId = setInterval(()=>{
                    if (active) {
                        handleScroll();
                        createAnalyticsEvent({
                            ...dwellTimeTrackAnalyticsPayload
                        }).fire();
                    } else {
                        clearInterval(intervalId);
                        clearTimeout(activityTimeout);
                        activityEvents.forEach((evt)=>{
                            window.removeEventListener(evt, setActive);
                        });
                    }
                }, 5000);
            }
        }
    }, [
        additionalAttributes,
        analyticsClient,
        createAnalyticsEvent,
        dwellTimeEnabled,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return {
        ref: ref,
        inView: inView,
        entry: entry
    };
};
const $0fbf1a9bc3d0315b$export$1725757b7947b890 = ({ section: section, index: index, observerOptions: observerOptions, children: children, as: RootElement = 'div' })=>{
    const { ref: ref } = $0fbf1a9bc3d0315b$export$17700584f55fbc70(section, {
        index: index,
        observerOptions: observerOptions
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)(RootElement, {
        ref: ref,
        children: children
    });
};
function $0fbf1a9bc3d0315b$export$391633ede08dabb1(section, InnerComponent, options) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)($0fbf1a9bc3d0315b$export$1725757b7947b890, {
            section: section,
            ...options,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)(InnerComponent, {
                ...props
            })
        });
    };
}

});


parcelRegister("4afjM", function(module, exports) {
$parcel$export(module.exports, "ReturningUserBanner", function () { return $51537c7de9d5df83$export$14e4a778e9c76f32; });
/* returning-user-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $kbpa7 = parcelRequire("kbpa7");
const $51537c7de9d5df83$export$14e4a778e9c76f32 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "returning-user-banner",
        className: (0, $2jatx.default)([
            "_4cvr1h6o _bfhkcafw _1e0c1txw _1n261g80 _zulp1kwk _1bah1h6o _vwz410nf _ca0q1j6v _u5f31j6v _n3td1j6v _19bv1j6v"
        ]),
        style: {
            "--_1bnl49": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue200'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: "\uD83D\uDCE3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraProductTourReturningUserBanner.message",
                defaultMessage: "Introducing agents in Jira <link>Learn more</link>",
                values: {
                    link: $51537c7de9d5df83$var$LearnMoreLink
                }
            })
        ]
    });
const $51537c7de9d5df83$var$LearnMoreLink = (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: "https://www.atlassian.com/blog/announcements/ai-agents-in-jira",
        className: (0, $2jatx.default)([
            "_syazu5k9 _4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1"
        ]),
        style: {
            "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700'))
        },
        children: chunks
    });
const $51537c7de9d5df83$var$bannerCss = null;
const $51537c7de9d5df83$var$linkCss = null;

});

parcelRegister("ly0rU", function(module, exports) {
$parcel$export(module.exports, "useJiraSitesContext", function () { return $007cd6e9556fb39d$export$8095836340dcdac5; });
$parcel$export(module.exports, "JiraSitesProvider", function () { return $007cd6e9556fb39d$export$e5844423e4215335; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $7GVWk = parcelRequire("7GVWk");

var $lmmDf = parcelRequire("lmmDf");
const $007cd6e9556fb39d$var$JiraSitesContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $007cd6e9556fb39d$export$8095836340dcdac5 = ()=>{
    const context = (0, $1oC0p.useContext)($007cd6e9556fb39d$var$JiraSitesContext);
    if (!context) throw new Error('useJiraSitesContext must be used within a JiraSitesProvider');
    return context;
};
const $007cd6e9556fb39d$export$e5844423e4215335 = ({ children: children })=>{
    const [jiraSitesFromAgg, setJiraSitesFromAgg] = (0, $1oC0p.useState)(undefined);
    const { profile: profile } = (0, $7GVWk.useUserContext)();
    const aggClient = (0, $1oC0p.useMemo)(()=>new (0, $lmmDf.LoggedInUserJiraSitesClient)(), []);
    (0, $1oC0p.useEffect)(()=>{
        if (!profile.attributes?.existingSites) return;
        const site = profile.attributes.existingSites[0];
        aggClient.getJiraSites(site?.cloudId ?? '').then((data)=>{
            setJiraSitesFromAgg(data);
        });
    }, [
        aggClient,
        profile.attributes?.existingSites
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($007cd6e9556fb39d$var$JiraSitesContext.Provider, {
        value: {
            jiraSitesFromAgg: jiraSitesFromAgg
        },
        children: children
    });
};

});
parcelRegister("lmmDf", function(module, exports) {
$parcel$export(module.exports, "LoggedInUserJiraSitesClient", function () { return $674243239df732ba$export$4a5a6b3b7497e383; });

var $1dWiR = parcelRequire("1dWiR");

var $1dWiR = parcelRequire("1dWiR");

var $gPKCY = parcelRequire("gPKCY");

var $7bBPn = parcelRequire("7bBPn");

var $4pGs1 = parcelRequire("4pGs1");
class $674243239df732ba$export$4a5a6b3b7497e383 {
    constructor(options){
        this.getJiraSites = async (cloudId)=>{
            (0, $gPKCY.ufoEventGetJiraSitesFromAgg).start();
            if (!cloudId) {
                (0, $gPKCY.ufoEventGetJiraSitesFromAgg).failure({
                    error: 'No Cloud ID provided'
                });
                return undefined;
            }
            const GET_JIRA_SITES_QUERY = (0, $1dWiR.gql)(`
                query getAllJiraProjects {
                    jira {
                        allJiraProjects(
                            cloudId: "${cloudId}"
                            filter: {types: [SOFTWARE], sortBy: {order: DESC, sortBy: LAST_ISSUE_UPDATED_TIME}}
                            first: 10
                        ) {
                            pageInfo {
                                hasNextPage
                            }
                            edges {
                                node {
                                    key
                                    name
                                    projectUrl
                                    webUrl
                                    assignableUsers(first: 5) {
                                        totalCount
                                        edges {
                                            node {
                                                name
                                                picture
                                                accountStatus
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `);
            try {
                const { data: data, error: error } = await this.client.query(GET_JIRA_SITES_QUERY, {
                    cloudId: cloudId
                });
                if (error?.message) {
                    (0, $gPKCY.ufoEventGetJiraSitesFromAgg).failure({
                        error: error
                    });
                    return undefined;
                }
                try {
                    const allJiraSites = (0, $4pGs1.jiraResponseSchema).parse(data);
                    (0, $gPKCY.ufoEventGetJiraSitesFromAgg).success();
                    return allJiraSites;
                } catch (e) {
                    (0, $gPKCY.ufoEventGetJiraSitesFromAgg).failure({
                        error: e
                    });
                    return undefined;
                }
            } catch (e) {
                (0, $gPKCY.ufoEventGetJiraSitesFromAgg).failure({
                    error: e
                });
                return undefined;
            }
        };
        const fetchOptions = options?.slauthToken ? {
            headers: {
                Authorization: `SLAUTH ${options.slauthToken || ''}`
            }
        } : {
            credentials: 'include'
        };
        this.client = new (0, $1dWiR.Client)({
            url: (0, $7bBPn.GATEWAY_URL),
            exchanges: [
                (0, $1dWiR.cacheExchange),
                (0, $1dWiR.fetchExchange)
            ],
            fetchOptions: fetchOptions
        });
    }
}

});
parcelRegister("4pGs1", function(module, exports) {
$parcel$export(module.exports, "jiraResponseSchema", function () { return $576666e3bd5ce27e$export$9006e8d0932b16e7; });

var $5pILu = parcelRequire("5pILu");
const $576666e3bd5ce27e$var$assignableUserNodeSchema = (0, $5pILu.z).object({
    name: (0, $5pILu.z).string(),
    picture: (0, $5pILu.z).string().nullable(),
    accountStatus: (0, $5pILu.z).string()
});
const $576666e3bd5ce27e$var$assignableUserEdgesSchema = (0, $5pILu.z).object({
    node: $576666e3bd5ce27e$var$assignableUserNodeSchema
});
const $576666e3bd5ce27e$var$assignableUsersSchema = (0, $5pILu.z).object({
    totalCount: (0, $5pILu.z).number(),
    edges: (0, $5pILu.z).array($576666e3bd5ce27e$var$assignableUserEdgesSchema)
});
const $576666e3bd5ce27e$var$projectNodeSchema = (0, $5pILu.z).object({
    key: (0, $5pILu.z).string(),
    name: (0, $5pILu.z).string(),
    projectUrl: (0, $5pILu.z).string().nullable(),
    webUrl: (0, $5pILu.z).string(),
    assignableUsers: $576666e3bd5ce27e$var$assignableUsersSchema
});
const $576666e3bd5ce27e$var$projectEdgesSchema = (0, $5pILu.z).object({
    node: $576666e3bd5ce27e$var$projectNodeSchema
});
const $576666e3bd5ce27e$var$pageInfoSchema = (0, $5pILu.z).object({
    hasNextPage: (0, $5pILu.z).boolean()
});
const $576666e3bd5ce27e$var$allJiraProjectsSchema = (0, $5pILu.z).object({
    pageInfo: $576666e3bd5ce27e$var$pageInfoSchema,
    edges: (0, $5pILu.z).array($576666e3bd5ce27e$var$projectEdgesSchema)
});
const $576666e3bd5ce27e$var$jiraSchema = (0, $5pILu.z).object({
    allJiraProjects: $576666e3bd5ce27e$var$allJiraProjectsSchema
});
const $576666e3bd5ce27e$export$9006e8d0932b16e7 = (0, $5pILu.z).object({
    jira: $576666e3bd5ce27e$var$jiraSchema
});

});



parcelRegister("lTaG1", function(module, exports) {
$parcel$export(module.exports, "LoggedInHeroSection", function () { return $27cf35ec8a7f1f0a$export$49c6370202c57ed1; });
/* logged-in-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iSeHD = parcelRequire("iSeHD");

var $lqyi6 = parcelRequire("lqyi6");

var $eY3N6 = parcelRequire("eY3N6");

var $gqkLW = parcelRequire("gqkLW");

var $7GVWk = parcelRequire("7GVWk");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $1OyVz = parcelRequire("1OyVz");

var $aTTHV = parcelRequire("aTTHV");

var $kP8Dm = parcelRequire("kP8Dm");

var $3riD8 = parcelRequire("3riD8");

var $jUgJp = parcelRequire("jUgJp");

var $1YSly = parcelRequire("1YSly");

var $SWJer = parcelRequire("SWJer");

var $ly0rU = parcelRequire("ly0rU");
const $27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES = {
    loggedInHeroProductCtaClicked: 'loggedInHeroProductCtaClicked',
    loggedInHeroAnotherSiteCtaClicked: 'loggedInHeroAnotherSiteCtaClicked',
    loggedInHeroExploreFeaturesClicked: 'loggedInHeroExploreFeaturesClicked',
    loggedInHeroCreateNewSiteClicked: 'loggedInHeroCreateNewSiteClicked'
};
const $27cf35ec8a7f1f0a$var$START_URL = 'https://start.atlassian.com';
const $27cf35ec8a7f1f0a$export$cbc42fadf8b93ea3 = {
    eventType: 'ui',
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'loggedInHero',
    source: '/software/jira'
};
const $27cf35ec8a7f1f0a$var$jswLoggedInCss = null;
const $27cf35ec8a7f1f0a$var$heroSectionCss = null;
const $27cf35ec8a7f1f0a$var$anchorContainer = null;
const $27cf35ec8a7f1f0a$var$jiraSiteBoxCss = null;
const $27cf35ec8a7f1f0a$var$headingCss = null;
const $27cf35ec8a7f1f0a$var$starCss = null;
const $27cf35ec8a7f1f0a$var$differentSiteCss = null;
const $27cf35ec8a7f1f0a$var$subHeadingContainerCss = null;
const $27cf35ec8a7f1f0a$var$createNewSiteAnchorCss = null;
const $27cf35ec8a7f1f0a$var$subHeadingCss = null;
const $27cf35ec8a7f1f0a$var$exploreFeaturesContainerCss = null;
const $27cf35ec8a7f1f0a$var$exploreFeaturesHeadingCss = null;
const $27cf35ec8a7f1f0a$var$exploreFeaturesCtaCss = null;
const $27cf35ec8a7f1f0a$var$nameUnderlineCss = null;
const $27cf35ec8a7f1f0a$var$inlineJiraLogoCss = null;
const $27cf35ec8a7f1f0a$var$siteInfoContainerCss = null;
const $27cf35ec8a7f1f0a$var$sitenameIconCss = null;
const $27cf35ec8a7f1f0a$var$sitenameIconTextCss = null;
const $27cf35ec8a7f1f0a$var$sitenameAndAvatarContainerCss = null;
const $27cf35ec8a7f1f0a$var$siteNameSpanCss = null;
const $27cf35ec8a7f1f0a$var$tooltipWrapperCss = null;
const $27cf35ec8a7f1f0a$var$avatarContainerCss = null;
const $27cf35ec8a7f1f0a$var$linkPlaceholderCss = null;
const $27cf35ec8a7f1f0a$export$49c6370202c57ed1 = ()=>{
    const loggedInUserProfile = (0, $3riD8.useLoggedInUser)();
    const { profile: profile, user: user } = (0, $7GVWk.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $ly0rU.useJiraSitesContext)();
    const [teammateAvatars, setTeammateAvatars] = (0, $1oC0p.useState)([]);
    const [totalUserCount, setTotalUserCount] = (0, $1oC0p.useState)();
    const intl = (0, $8e22h.default)();
    // GWP-10447: Check if the user is an SMB sales lead to adjust the hero CTA button variant
    const { isEligible: isSMBSalesLead } = (0, $aTTHV.useContactSalesCtaEligibility)();
    // Try to get name from props, and fallback to hook if needed
    const userFirstName = user.name?.split(' ')[0] ?? loggedInUserProfile.name?.split(' ')[0];
    // Try to get picture from props, and fallback to hook if needed
    const userPicture = user?.picture ?? loggedInUserProfile.picture;
    const avatars = jiraSitesFromAgg?.jira?.allJiraProjects.edges[0]?.node.assignableUsers.edges;
    (0, $1oC0p.useEffect)(()=>{
        setTeammateAvatars(jiraSitesFromAgg?.jira?.allJiraProjects.edges[0]?.node.assignableUsers.edges.filter((assignableUser)=>assignableUser.node.picture !== userPicture && assignableUser.node.accountStatus === 'active').map((assignableUser)=>{
            return assignableUser.node.picture ?? '';
        }) ?? []);
    }, [
        avatars,
        jiraSitesFromAgg?.jira?.allJiraProjects.edges,
        userPicture
    ]);
    (0, $1oC0p.useEffect)(()=>setTotalUserCount(jiraSitesFromAgg?.jira?.allJiraProjects.edges[0]?.node.assignableUsers.totalCount), [
        jiraSitesFromAgg?.jira?.allJiraProjects.edges
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const localizedTryLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-software&createNew=true');
    const localizedProductGuideLink = (0, $jQ0cd.useLocalizedHref)('/software/jira/guides/getting-started/introduction');
    const [hasMultipleJiras, setHasMultipleJiras] = (0, $1oC0p.useState)(false);
    const [siteName, setSiteName] = (0, $1oC0p.useState)('');
    const [siteInitials, setSiteInitials] = (0, $1oC0p.useState)('');
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)('');
    const { hasMultipleJiras: mostRecentHasMultipleJiras, siteName: mostRecentSiteName, siteUrl: mostRecentSiteUrl, siteInitials: mostRecentSiteInitials, cloudSiteId: mostRecentCloudSiteId, recentWorkUrl: mostRecentWorkUrl } = (0, $kP8Dm.useRecentJiraSite)();
    (0, $1oC0p.useEffect)(()=>{
        setHasMultipleJiras(mostRecentHasMultipleJiras);
        setSiteName(mostRecentSiteName);
        setSiteUrl(mostRecentSiteUrl);
        setSiteInitials(mostRecentSiteInitials);
    }, [
        mostRecentHasMultipleJiras,
        mostRecentSiteInitials,
        mostRecentSiteName,
        mostRecentSiteUrl
    ]);
    const loggedInHeroLoadedAnalyticsPayload = {
        eventType: 'ui',
        action: 'loaded',
        actionSubject: 'component',
        actionSubjectId: 'loggedInHero',
        source: '/software/jira',
        attributes: {
            atlasId: 'ATLAS-76385, ATLAS-93656'
        }
    };
    (0, $1oC0p.useEffect)(()=>{
        //if client side, fire analytics event
        if (typeof window !== 'undefined') createAnalyticsEvent({
            ...loggedInHeroLoadedAnalyticsPayload
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const clickHandler = (eventName)=>{
        createAnalyticsEvent({
            ...$27cf35ec8a7f1f0a$export$cbc42fadf8b93ea3,
            attributes: {
                eventName: eventName,
                url: window.location.href,
                atlasId: 'ATLAS-76385, ATLAS-93656'
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _11q71bjw _12vemgnk _1lrw1dfr _1e0c11p5 _yv0ehkll _4cvr1h6o _6a6z1h6o _18zr53f4 _1q5110yn _85i512am _1bsb1osq _1bhl10yn"
        ]),
        style: {
            "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _syaz1pfd _1bsb1osq _p12fk3xj _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _s51sidpf"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_t9ecuuzf _kqswstnw _1e0c1o8l _u7co1w81 _1e021vgi _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            width: 88,
                            height: 70,
                            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g06k378gucflnfse7s88i0365h14j40v.webp',
                            alt: ''
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_1wybckbl _vwz48vuz _k48p9y44 _ect41vau _6rtho7ao _bozgidpf _so7dldb6 _19q11ylp"
                    ]),
                    style: {
                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                    },
                    children: userFirstName ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBackWithName",
                        defaultMessage: `Welcome back, {name}.`,
                        values: {
                            name: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_zg8l4jg8 _kqswh2mm _3p6m1sr6 _1v5vmgnk _14rnk6ds _19h91f51 _aetrb3bt _1qdggktf _1gufd439 _1czd12gs _g0nfmyb0 _18postnw _14tt14id _1ruvyjp0"
                                ]),
                                style: {
                                    "--_1p38jlt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron400'))
                                },
                                children: userFirstName
                            })
                        }
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _gy1p53f4 _1bah1yb4 _4cvr1q9y"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ect4z4z1 _1wybgktf _vwz41f4h _k48p1nn1"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOffInProduct",
                                defaultMessage: "Pick up where you left off in <span>{product}</span>",
                                values: {
                                    product: 'Jira',
                                    // eslint-disable-next-line react/no-unstable-nested-components
                                    span: (text)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c1o8l _t9ec1jia _kqswh2mm _152tdlk8 _195g14id"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OyVz.JiraMarkBrand), {})
                                                }),
                                                text
                                            ]
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-testid": "createNewSiteAnchor",
                            href: localizedTryLink,
                            onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroCreateNewSiteClicked),
                            className: (0, $2jatx.default)([
                                "_ect4z4z1 _1wyb7vkz _k48pni7l _vwz41f4h _syazu5k9"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "WacSignupForm.createNewSite",
                                defaultMessage: "Create a new site"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _16jlkb7n _1wpz1fhb _1mougktf _158d1pfd _p1f31y44 _7s65grho"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            "data-activation-checklist-site-card": true,
                            className: (0, $2jatx.default)([
                                "_bfhk1afi _2rko1y44 _mrkb1tcb _1o0z1tcb _1bsb1osq _1ul91mjv _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19itgo0a _1rjc7vkz _18zr7vkz _kqswh2mm"
                            ]),
                            style: {
                                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jUgJp.JiraSiteContainer), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx2vrvc _4cvr1h6o _4t3ivbgk _zulppxbi"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_11q716ye _2rko1b66 _1e0c1txw _1bah1h6o _4cvr1h6o _4t3ivbgk _1bsbvbgk _1ul9vbgk"
                                                ]),
                                                style: {
                                                    "--_alcc52": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime300'))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                                    className: (0, $2jatx.default)([
                                                        "_syazsei6 _ect41vau _1wyb1ejb _k48pni7l _vwz41f4h _1dyznl7k _y3gn1h6o"
                                                    ]),
                                                    style: {
                                                        "--_rhsgef": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime800')),
                                                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                                    },
                                                    children: siteInitials
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _2lx21bp4 _1bah1h6o _zulp19bv _kqswh2mm _4t3ivbgk"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_4t3igktf"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gqkLW.default), {
                                                            content: siteName,
                                                            position: 'top-end',
                                                            mousePosition: "top",
                                                            tag: 'span',
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                className: (0, $2jatx.default)([
                                                                    "_ect4z4z1 _1wybgktf _k48p1fw0 _4t3igktf _vwz41j6v _y3gn1e5h _1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1o8l _s7n4jp4b _uhd0uuw1 _1tssl1r9"
                                                                ]),
                                                                style: {
                                                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                                                },
                                                                children: siteName
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_4t3i1tcg _uhd0uuw1 _1tssl1r9"
                                                        ]),
                                                        children: userPicture && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1YSly.LoggedInProductTourAvatarFacepile), {
                                                            max: 4,
                                                            iconSize: 24,
                                                            icons: [
                                                                userPicture,
                                                                ...teammateAvatars
                                                            ],
                                                            totalUserCount: totalUserCount ?? 0
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                        "data-testid": "goToJiraButton",
                                        variant: isSMBSalesLead ? 'primary' : 'primary_alt',
                                        href: siteUrl,
                                        size: "small",
                                        onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroProductCtaClicked),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "JiraSoftwarePageTemplate.loggedInHero.goToJira",
                                            defaultMessage: "Go to Jira"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $SWJer.ActivationChecklistLoggedInHeroPlacement), {
                            siteUrl: mostRecentSiteUrl,
                            cloudSiteId: mostRecentCloudSiteId,
                            recentWorkUrl: mostRecentWorkUrl,
                            existingSites: profile.attributes?.existingSites
                        })
                    ]
                }),
                hasMultipleJiras ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ect4z4z1 _1pfho7ao _1wybdlk8 _k48p1nn1 _gu181h6o"
                    ]),
                    style: {
                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: intl.formatMessage({
                            id: 'ConfluenceSoftwarePageTemplate.loggedInHero.lookingForDifferentSite',
                            defaultMessage: 'Looking for a different site?'
                        }),
                        href: $27cf35ec8a7f1f0a$var$START_URL,
                        type: "primary",
                        onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroAnotherSiteCtaClicked)
                    })
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3iqslr"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhvbgk _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ect4z4z1 _1wybgktf _vwz41f4h _k48p1nn1 _6rth7vkz"
                            ]),
                            style: {
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.findOutMore",
                                defaultMessage: "Want to find out more about Jira?"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-testid": "exploreFeaturesAnchor",
                            href: localizedProductGuideLink,
                            onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroExploreFeaturesClicked),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                className: (0, $2jatx.default)([
                                    "_ect4z4z1 _1wyb7vkz _k48pni7l _11q7glyw _r06hglyw _2rko1ul9 _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _19it1axk _80omtlke"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jira-product-tour.staggered-double-feature-section.first-feature-link-text",
                                    defaultMessage: "Explore features"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$27cf35ec8a7f1f0a$export$49c6370202c57ed1.displayName = 'LoggedInHeroSection';
var $27cf35ec8a7f1f0a$export$2e2bcd8739ae039 = $27cf35ec8a7f1f0a$export$49c6370202c57ed1;

});
parcelRegister("1OyVz", function(module, exports) {
$parcel$export(module.exports, "JiraMarkBrand", function () { return $ac492e84be2f5dcc$export$2c53bf5b8775580d; });

var $7VQPk = parcelRequire("7VQPk");
const $ac492e84be2f5dcc$export$2c53bf5b8775580d = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M40.202 7.22998H22.124C22.124 11.736 25.777 15.388 30.282 15.388H33.611V18.601C33.611 23.107 37.264 26.759 41.769 26.759V8.79798C41.769 7.93198 41.067 7.22998 40.201 7.22998H40.202Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.255 16.2358H13.177C13.177 20.7418 16.83 24.3938 21.335 24.3938H24.664V27.6068C24.664 32.1128 28.317 35.7648 32.822 35.7648V17.8038C32.822 16.9378 32.12 16.2358 31.254 16.2358H31.255Z",
                fill: "url(#paint0_linear_818_567)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.308 25.2412H4.22998C4.22998 29.7472 7.88298 33.3992 12.388 33.3992H15.717V36.6122C15.717 41.1182 19.37 44.7702 23.875 44.7702V26.8092C23.875 25.9432 23.173 25.2412 22.307 25.2412H22.308Z",
                fill: "url(#paint1_linear_818_567)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_567",
                        x1: "32.439",
                        y1: "16.2658",
                        x2: "24.749",
                        y2: "24.1958",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_567",
                        x1: "24.003",
                        y1: "25.3252",
                        x2: "15.112",
                        y2: "33.9752",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("kP8Dm", function(module, exports) {
$parcel$export(module.exports, "filterAvailableJiraSites", function () { return $7f42103420ec9afa$export$c88497b4217b9e30; });
$parcel$export(module.exports, "useRecentJiraSite", function () { return $7f42103420ec9afa$export$df4ec66f2732798b; });

var $1oC0p = parcelRequire("1oC0p");

var $gV7D4 = parcelRequire("gV7D4");

var $7GVWk = parcelRequire("7GVWk");

var $5Ntyw = parcelRequire("5Ntyw");
const $7f42103420ec9afa$var$GRAPHQL_GATEWAY_URL = 'https://www.atlassian.com/gateway/api/graphql';
const $7f42103420ec9afa$var$START_URL = 'https://start.atlassian.com';
const $7f42103420ec9afa$var$constructLoginUrl = (url)=>{
    const loginUrl = new URL(url);
    loginUrl.pathname = '/login.jsp';
    const searchParam = new URLSearchParams();
    const browseUrl = new URL(loginUrl);
    browseUrl.pathname = '/browse';
    searchParam.append('os_destination', browseUrl.href);
    loginUrl.search = searchParam.toString();
    return loginUrl;
};
const $7f42103420ec9afa$export$c88497b4217b9e30 = (sites)=>{
    if (sites) {
        const filteredSites = sites.filter((site)=>{
            return site.products.some((product)=>{
                return product.productKey.includes('jira-software.ondemand');
            });
        }) || [];
        return filteredSites;
    } else return [];
};
const $7f42103420ec9afa$export$df4ec66f2732798b = ()=>{
    const { profile: profile, user: user } = (0, $7GVWk.useUserContext)();
    const splitName = user.name?.split(' ');
    (0, $5Ntyw.useBxpWebStargateClient)();
    const activityClient = (0, $gV7D4.useActivityClient)('v3', 'www.atlassian.com', undefined, $7f42103420ec9afa$var$GRAPHQL_GATEWAY_URL);
    const availableJiraSites = $7f42103420ec9afa$export$c88497b4217b9e30(profile.attributes?.existingSites);
    const hasMultipleJiras = availableJiraSites.length > 1;
    const [siteName, setSiteName] = (0, $1oC0p.useState)('');
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)('');
    const [siteInitials, setSiteInitials] = (0, $1oC0p.useState)('');
    const [cloudSiteId, setCloudSiteId] = (0, $1oC0p.useState)();
    const [recentWorkUrl, setRecentWorkUrl] = (0, $1oC0p.useState)();
    const [isResolvingSite, setIsResolvingSite] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        const promises = [];
        let mostRecentActivity;
        const fetchActivitiesPromise = activityClient.fetchActivities([
            50,
            125,
            250
        ], {
            limit: 5,
            products: [
                'jira'
            ]
        }, [
            'workedOn',
            'viewed'
        ]).then((data)=>{
            const mostRecentlyViewed = data.viewed[0];
            const mostRecentlyWorkedOn = data.workedOn[0];
            if (mostRecentlyViewed && mostRecentlyWorkedOn) mostRecentActivity = new Date(mostRecentlyViewed.timestamp) > new Date(mostRecentlyWorkedOn.timestamp) ? mostRecentlyViewed : mostRecentlyWorkedOn;
            else if (mostRecentlyWorkedOn) mostRecentActivity = mostRecentlyWorkedOn;
            else if (mostRecentlyViewed) mostRecentActivity = mostRecentlyViewed;
        }).catch((error)=>console.log(error));
        promises.push(fetchActivitiesPromise);
        Promise.allSettled(promises).then(()=>{
            if (mostRecentActivity) {
                const loginUrl = $7f42103420ec9afa$var$constructLoginUrl(mostRecentActivity.object.url);
                setSiteUrl(loginUrl.href);
                setSiteName(loginUrl.hostname.split('.')[0] || '');
                setSiteInitials(loginUrl.hostname.slice(0, 1).toUpperCase() + loginUrl.hostname.slice(1, 2));
                setCloudSiteId(mostRecentActivity.object.rootContainerIdentifier.id);
                setRecentWorkUrl(mostRecentActivity.object.url);
            } else if (availableJiraSites[0]) {
                const loginUrl = $7f42103420ec9afa$var$constructLoginUrl(availableJiraSites[0].url);
                setSiteUrl(loginUrl.href);
                setSiteName(loginUrl.hostname.split('.')[0] || '');
                setSiteInitials(loginUrl.hostname.slice(0, 1).toUpperCase() + loginUrl.hostname.slice(1, 2));
                setCloudSiteId(availableJiraSites[0].cloudId);
                setRecentWorkUrl(undefined);
            } else {
                setSiteUrl($7f42103420ec9afa$var$START_URL);
                setSiteName('');
                setRecentWorkUrl(undefined);
            }
            setIsResolvingSite(false);
        });
    }, []);
    return {
        splitName: splitName,
        hasMultipleJiras: hasMultipleJiras,
        siteName: siteName,
        siteUrl: siteUrl,
        siteInitials: siteInitials,
        cloudSiteId: cloudSiteId,
        recentWorkUrl: recentWorkUrl,
        isResolvingSite: isResolvingSite
    };
};

});

parcelRegister("jUgJp", function(module, exports) {
$parcel$export(module.exports, "JiraSiteContainer", function () { return $0f278737b86939ae$export$156fedbbf16eee65; });

var $7VQPk = parcelRequire("7VQPk");

var $kP8Dm = parcelRequire("kP8Dm");

var $lJgOZ = parcelRequire("lJgOZ");
const $0f278737b86939ae$export$156fedbbf16eee65 = ({ children: children })=>{
    const { siteName: siteName, siteInitials: siteInitials, siteUrl: siteUrl } = (0, $kP8Dm.useRecentJiraSite)();
    if (siteName === '' || siteInitials === '' || siteUrl === '') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lJgOZ.JiraSiteSkeleton), {});
    return children;
};

});
parcelRegister("lJgOZ", function(module, exports) {
$parcel$export(module.exports, "JiraSiteSkeleton", function () { return $e3c088fe27eb70b0$export$129bc33e2568dfe3; });
/* jira-site-skeleton.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eUwCn = parcelRequire("eUwCn");
const $e3c088fe27eb70b0$var$siteInfoContainerCss = null;
const $e3c088fe27eb70b0$var$sitenameIconCss = null;
const $e3c088fe27eb70b0$var$sitenameAndAvatarContainerCss = null;
const $e3c088fe27eb70b0$var$containerCss = null;
const $e3c088fe27eb70b0$export$129bc33e2568dfe3 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "jira-site-skeleton",
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _kqswh2mm _16jlkb7n _1wpz1fhb"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _4t3ivbgk _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bah1h6o _4cvr1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                            width: "64px",
                            height: "64px"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1bah1h6o _zulp19bv _kqswh2mm _4t3ivbgk"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "300px",
                                height: "22px"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "160px",
                                height: "22px"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "120px",
                    height: "40px"
                })
            })
        ]
    });
};

});


parcelRegister("1YSly", function(module, exports) {
$parcel$export(module.exports, "LoggedInProductTourAvatarFacepile", function () { return $73d38aac98679b2d$export$5b9f7c22786b87bc; });
/* logged-in-product-tour-avatar-facepile.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $bUqvj = parcelRequire("bUqvj");
const $73d38aac98679b2d$export$5b9f7c22786b87bc = ({ icons: icons, max: max, overlap: overlap = 4, iconSize: iconSize = 16, totalUserCount: totalUserCount })=>{
    const userCountPillStyles = null;
    const intl = (0, $8e22h.default)();
    const maxUsersStyles = null;
    const andMoreText = intl.formatMessage({
        id: 'avatarFacePile.andMoreText',
        defaultMessage: 'and more'
    });
    const facepileStyles = [
        null,
        overlap > 0 && null
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4t3ibv8l _1bsb1osq _9e7b1bmj",
            overlap > 0 && "_ahbqccqr"
        ]),
        style: {
            "--_1lwyf0k": (0, $6ZVlx.default)(iconSize, "px"),
            "--_19zwya0-": (0, $6ZVlx.default)(overlap, "px", "-"),
            "--_19zwya0": (0, $6ZVlx.default)(overlap, "px")
        },
        children: [
            icons.slice(0, max).map((icon, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $bUqvj.AvatarIcon), {
                    icon: icon,
                    iconSize: iconSize,
                    overlap: overlap
                }, index)),
            totalUserCount > 99 ? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_syaz1qc2 _1wyb1crf _k48p1nn1 _ahbqi2wt _1e0c1txw _4cvr1h6o"
                ]),
                style: {
                    "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                },
                children: andMoreText
            }) : totalUserCount > max && /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _2rko1k4y _19it1dxc _syaz1qc2 _1e0c116y _1wybgbje _k48p1nn1 _zulpze3t _4t3ibv8l _1bah1h6o _vwz4bv8l _ahbq1564 _1yt418uk _y3gn1h6o _s7n4nkob _1bsb1wug"
                ]),
                style: {
                    "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800')),
                    "--_1lwyf0k": (0, $6ZVlx.default)(iconSize, "px"),
                    "--_1j20svt": (0, $6ZVlx.default)(overlap * -1, "px")
                },
                children: [
                    "+",
                    totalUserCount - max
                ]
            })
        ]
    });
};

});

parcelRegister("SWJer", function(module, exports) {
$parcel$export(module.exports, "ActivationChecklistLoggedInHeroPlacement", function () { return $ea8c3aa0bb1e4710$export$f01273f8b6af127f; });

var $7VQPk = parcelRequire("7VQPk");

var $2WL8B = parcelRequire("2WL8B");

var $kP8Dm = parcelRequire("kP8Dm");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $5Weqz = parcelRequire("5Weqz");
const $ea8c3aa0bb1e4710$export$f01273f8b6af127f = ({ siteUrl: siteUrl, cloudSiteId: cloudSiteId, recentWorkUrl: recentWorkUrl, existingSites: existingSites })=>{
    const gateEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jiraWacActivationChecklistGate);
    const aaGateEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jiraWacActivationChecklistAaGate);
    const loggedInHasJira = (0, $2WL8B.useLoggedInHasJira)();
    if (gateEnabled !== true && aaGateEnabled !== true || loggedInHasJira !== true) return null;
    if (!cloudSiteId) return null;
    const jiraSite = gateEnabled === true ? (0, $kP8Dm.filterAvailableJiraSites)(existingSites).find((site)=>site.cloudId === cloudSiteId) : undefined;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-activation-checklist-placement-root": true,
        children: [
            aaGateEnabled === true ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Weqz.ActivationChecklistAaExposurePlacement), {
                cloudSiteId: cloudSiteId
            }) : null,
            gateEnabled === true ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Weqz.ActivationChecklistMainPlacement), {
                siteUrl: siteUrl,
                cloudSiteId: cloudSiteId,
                recentWorkUrl: recentWorkUrl,
                canInviteTeam: jiraSite?.hasAdminAccess === true
            }) : null
        ]
    });
};
$ea8c3aa0bb1e4710$export$f01273f8b6af127f.displayName = 'ActivationChecklistLoggedInHeroPlacement';

});
parcelRegister("5Weqz", function(module, exports) {
$parcel$export(module.exports, "ActivationChecklistAaExposurePlacement", function () { return $20cc2100df4398cb$export$7ee460579ea44800; });
$parcel$export(module.exports, "ActivationChecklistMainPlacement", function () { return $20cc2100df4398cb$export$29eb3204b6e64a09; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $hCc2m = parcelRequire("hCc2m");

var $2WL8B = parcelRequire("2WL8B");

var $hgaI1 = parcelRequire("hgaI1");

var $j2b52 = parcelRequire("j2b52");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

const $20cc2100df4398cb$var$LazyActivationChecklistPostOfficeMount = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("bKqks")).then(({ ActivationChecklistPostOfficeMount: ActivationChecklistPostOfficeMount })=>({
            default: ActivationChecklistPostOfficeMount
        })));
const $20cc2100df4398cb$var$useActivationChecklistEnrollment = ({ cloudSiteId: cloudSiteId, experimentConfig: experimentConfig })=>{
    const isInTargetSiteCohort = (0, $2WL8B.useLoggedInHasJiraSiteD1toD14)(cloudSiteId);
    const experimentForTargetSite = (0, $1oC0p.useMemo)(()=>({
            ...experimentConfig,
            options: {
                ...experimentConfig.options,
                fireExperimentExposure: false
            },
            targeting: {
                cohort: ()=>isInTargetSiteCohort
            }
        }), [
        experimentConfig,
        isInTargetSiteCohort
    ]);
    const exposureMetadata = (0, $1oC0p.useMemo)(()=>({
            tenantId: cloudSiteId,
            cloudSiteId: cloudSiteId
        }), [
        cloudSiteId
    ]);
    const experiment = (0, $gIKKj.useExperiment)(experimentForTargetSite, exposureMetadata);
    const updateTenantId = (0, $hgaI1.useUpdateFeatureGatesClientWithTenantId)();
    const exposureFired = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (exposureFired.current || experiment.type !== (0, $gIKKj.EnrollmentType).ENROLLED) return;
        let isCancelled = false;
        const syncTenantContextAndFireExposure = async ()=>{
            const bootstrapValues = typeof window !== 'undefined' ? window.featureGateBootstrapValues : undefined;
            if (bootstrapValues && bootstrapValues.identifiers?.tenantId !== cloudSiteId) await updateTenantId({
                cloudId: cloudSiteId
            });
            if (!isCancelled && !exposureFired.current) {
                experiment.fireExposure();
                exposureFired.current = true;
            }
        };
        syncTenantContextAndFireExposure();
        return ()=>{
            isCancelled = true;
        };
    }, [
        cloudSiteId,
        experiment,
        updateTenantId
    ]);
    return experiment;
};
const $20cc2100df4398cb$var$useActivationChecklistAaExposure = (cloudSiteId)=>{
    $20cc2100df4398cb$var$useActivationChecklistEnrollment({
        cloudSiteId: cloudSiteId,
        experimentConfig: (0, $4X0dO.experiments).jiraWacActivationChecklistAa
    });
};
const $20cc2100df4398cb$var$useActivationChecklistLaunchEnrollment = (cloudSiteId)=>$20cc2100df4398cb$var$useActivationChecklistEnrollment({
        cloudSiteId: cloudSiteId,
        experimentConfig: (0, $4X0dO.experiments).jiraWacActivationChecklist
    });
const $20cc2100df4398cb$export$7ee460579ea44800 = ({ cloudSiteId: cloudSiteId })=>{
    $20cc2100df4398cb$var$useActivationChecklistAaExposure(cloudSiteId);
    return null;
};
const $20cc2100df4398cb$export$29eb3204b6e64a09 = (props)=>{
    const experiment = $20cc2100df4398cb$var$useActivationChecklistLaunchEnrollment(props.cloudSiteId);
    const isEligible = experiment.type === (0, $gIKKj.EnrollmentType).ENROLLED && experiment.value === true;
    if (!isEligible) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
            fallback: null,
            interactionName: "wac-activation-checklist-placement",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($20cc2100df4398cb$var$LazyActivationChecklistPostOfficeMount, {
                ...props
            })
        })
    });
};
const $20cc2100df4398cb$export$4e2ffbab462c781a = (props)=>{
    const { cloudSiteId: cloudSiteId } = props;
    const gateEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jiraWacActivationChecklistGate);
    const aaGateEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jiraWacActivationChecklistAaGate);
    const loggedInHasJira = (0, $2WL8B.useLoggedInHasJira)();
    if (gateEnabled !== true && aaGateEnabled !== true || loggedInHasJira !== true) return null;
    if (!cloudSiteId) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            aaGateEnabled === true ? /*#__PURE__*/ (0, $7VQPk.jsx)($20cc2100df4398cb$export$7ee460579ea44800, {
                cloudSiteId: cloudSiteId
            }) : null,
            gateEnabled === true ? /*#__PURE__*/ (0, $7VQPk.jsx)($20cc2100df4398cb$export$29eb3204b6e64a09, {
                ...props,
                cloudSiteId: cloudSiteId
            }) : null
        ]
    });
};
$20cc2100df4398cb$export$4e2ffbab462c781a.displayName = 'ActivationChecklistPlacement';
var $20cc2100df4398cb$export$2e2bcd8739ae039 = $20cc2100df4398cb$export$4e2ffbab462c781a;

});
parcelRegister("j2b52", function(module, exports) {
$parcel$export(module.exports, "ClientOnly", function () { return $1445362815fc2039$export$70f10949f62d7670; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
let $1445362815fc2039$var$hydrating = true;
function $1445362815fc2039$export$1b590bd8f758497b() {
    const [hydrated, setHydrated] = (0, $1oC0p.useState)(()=>!$1445362815fc2039$var$hydrating);
    (0, $1oC0p.useEffect)(function hydrate() {
        $1445362815fc2039$var$hydrating = false;
        console.debug('hydrating:', $1445362815fc2039$var$hydrating);
        setHydrated(true);
    }, []);
    return hydrated;
}
const $1445362815fc2039$export$70f10949f62d7670 = ({ children: children })=>{
    return $1445362815fc2039$export$1b590bd8f758497b() ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: children
    }) : null;
};

});

parcelRegister("bKqks", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("a6qCB"),
    $eao4m("ch50F"),
    $eao4m("5lMXK")
]).then(()=>parcelRequire('6wGS9'));

});




parcelRegister("jmYmp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $32c81aeeb0653afd$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $gNdrj = parcelRequire("gNdrj");

var $7GVWk = parcelRequire("7GVWk");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $iOXki = parcelRequire("iOXki");

var $ly0rU = parcelRequire("ly0rU");
const $32c81aeeb0653afd$var$JiraLogo = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
};
const $32c81aeeb0653afd$var$SoftwareJiraLoggedInNavbar = ()=>{
    const intl = (0, $8e22h.default)();
    const logoUrl = (0, $jQ0cd.useLocalizedHref)('/software/jira');
    const { profile: profile } = (0, $7GVWk.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $ly0rU.useJiraSitesContext)();
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)('');
    (0, $1oC0p.useEffect)(()=>{
        const site = profile?.attributes?.existingSites[0];
        let tempSiteUrl = site?.url;
        if (jiraSitesFromAgg?.jira.allJiraProjects.edges.length === 1) tempSiteUrl = jiraSitesFromAgg?.jira.allJiraProjects?.edges[0]?.node?.webUrl;
        setSiteUrl(tempSiteUrl ?? '');
    }, [
        jiraSitesFromAgg?.jira.allJiraProjects.edges,
        jiraSitesFromAgg?.jira.allJiraProjects.edges.length,
        profile?.attributes?.existingSites,
        profile?.attributes?.existingSites.length
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gNdrj.JiraSmartBanner), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
                productLogoUrl: logoUrl,
                productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($32c81aeeb0653afd$var$JiraLogo, {}),
                productLogoAriaLabel: intl.formatMessage({
                    id: 'wacJiraSoftwareNavigation.logo-label',
                    defaultMessage: 'Jira Software logo'
                }),
                mobileCtaText: intl.formatMessage({
                    id: 'JiraSoftwarePageTemplate.navbar.goToJira',
                    defaultMessage: 'Go to Jira'
                }),
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                mobileCtaOnClick: ()=>{},
                mobileCtaUrl: siteUrl,
                mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($32c81aeeb0653afd$var$JiraLogo, {}),
                navigationTrynowCtaText: intl.formatMessage({
                    id: 'JiraFeatureSoftwarePageTemplate.navbar.goToJira',
                    defaultMessage: 'Go to Jira'
                }),
                navigationTrynowCtaUrl: siteUrl,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                navigationTrynowCtaOnClick: ()=>{},
                productPageNavLinks: [],
                mobileLinksSections: [],
                isShowSearchButton: false,
                isShowAppSwitcher: false,
                isShowTabletDropdown: false
            })
        ]
    });
};
var $32c81aeeb0653afd$export$2e2bcd8739ae039 = $32c81aeeb0653afd$var$SoftwareJiraLoggedInNavbar;

});


parcelRegister("C5M69", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageLoadingSpinner", function () { return $15bdf68c5baa83a5$export$3f77c912675f54c9; });
/* jira-software-page-loading-spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $7qFQI = parcelRequire("7qFQI");
const $15bdf68c5baa83a5$var$loadingSpinnerCss = null;
const $15bdf68c5baa83a5$export$3f77c912675f54c9 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "progressbar",
        "aria-label": "Loading Jira site",
        "data-testid": "jira-software-page-loading-spinner",
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _1tkedtre"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            size: "large"
        })
    });
};

});


parcelRegister("8jRs5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $60e98f83d791250d$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");
function $60e98f83d791250d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $60e98f83d791250d$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $60e98f83d791250d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $60e98f83d791250d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("kUCSO", function(module, exports) {
$parcel$export(module.exports, "Reference", function () { return $f39732ff1e24afd6$export$e0be378c32fb70a7; });

var $1oC0p = parcelRequire("1oC0p");

var $at85i = parcelRequire("at85i");

var $8q4Jo = parcelRequire("8q4Jo");

var $elwQc = parcelRequire("elwQc");
function $f39732ff1e24afd6$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $1oC0p.useContext((0, $8q4Jo.ManagerReferenceNodeSetterContext));
    var refHandler = $1oC0p.useCallback(function(node) {
        (0, $elwQc.setRef)(innerRef, node);
        (0, $elwQc.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $1oC0p.useEffect(function() {
        return function() {
            return (0, $elwQc.setRef)(innerRef, null);
        };
    }, []);
    $1oC0p.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($at85i)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $elwQc.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("at85i", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $79f2e2331b9e0776$var$__DEV__ = false;
var $79f2e2331b9e0776$var$warning = function() {};
if ($79f2e2331b9e0776$var$__DEV__) {
    var $79f2e2331b9e0776$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $79f2e2331b9e0776$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $79f2e2331b9e0776$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $79f2e2331b9e0776$var$warning;

});


parcelRegister("lP7A9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fe343e0b0e95d831$export$2e2bcd8739ae039; });


var $9aXvx = parcelRequire("9aXvx");

var $kk9vf = parcelRequire("kk9vf");

var $7t0tI = parcelRequire("7t0tI");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $fe343e0b0e95d831$var$token(path, fallback) {
    var token = (0, $9aXvx.default)[path];
    typeof $7t0tI;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $kk9vf.TOKEN_NOT_FOUND_CSS_VAR);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $fe343e0b0e95d831$export$2e2bcd8739ae039 = $fe343e0b0e95d831$var$token;

});
parcelRegister("9aXvx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6ae3353be2245a6b$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1f64d7a1e3392b669ad5c7bfd53c7403>>
 * @codegenCommand yarn build tokens
 */ var $6ae3353be2245a6b$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.subtle': '--ds-background-danger-subtle',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.subtle': '--ds-background-warning-subtle',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.subtle': '--ds-background-success-subtle',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.subtle': '--ds-background-discovery-subtle',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.subtle': '--ds-background-information-subtle',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.lime.subtle': '--ds-border-accent-lime-subtle',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.red.subtle': '--ds-border-accent-red-subtle',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.orange.subtle': '--ds-border-accent-orange-subtle',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.yellow.subtle': '--ds-border-accent-yellow-subtle',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.green.subtle': '--ds-border-accent-green-subtle',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.teal.subtle': '--ds-border-accent-teal-subtle',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.blue.subtle': '--ds-border-accent-blue-subtle',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.purple.subtle': '--ds-border-accent-purple-subtle',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.magenta.subtle': '--ds-border-accent-magenta-subtle',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.accent.gray.subtle': '--ds-border-accent-gray-subtle',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.danger.subtle': '--ds-border-danger-subtle',
    'color.border.warning': '--ds-border-warning',
    'color.border.warning.subtle': '--ds-border-warning-subtle',
    'color.border.success': '--ds-border-success',
    'color.border.success.subtle': '--ds-border-success-subtle',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.discovery.subtle': '--ds-border-discovery-subtle',
    'color.border.information': '--ds-border-information',
    'color.border.information.subtle': '--ds-border-information-subtle',
    'color.border.bold': '--ds-border-bold',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'color.rovo.background.brand.bold': '--ds-rovo-background-brand-bold',
    'color.rovo.background.brand.bold.hovered': '--ds-rovo-background-brand-bold-hovered',
    'color.rovo.background.brand.bold.pressed': '--ds-rovo-background-brand-bold-pressed',
    'color.rovo.border.lime': '--ds-rovo-border-lime',
    'color.rovo.border.saffron': '--ds-rovo-border-saffron',
    'color.rovo.border.blue': '--ds-rovo-border-blue',
    'color.rovo.border.purple': '--ds-rovo-border-purple',
    'color.rovo.icon.lime': '--ds-rovo-icon-lime',
    'color.rovo.icon.saffron': '--ds-rovo-icon-saffron',
    'color.rovo.icon.blue': '--ds-rovo-icon-blue',
    'color.rovo.icon.purple': '--ds-rovo-icon-purple',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.container': '--ds-surface-container',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.rovo.surface.overlay': '--ds-rovo-surface-overlay',
    'elevation.rovo.surface.overlay.hovered': '--ds-rovo-surface-overlay-hovered',
    'elevation.rovo.surface.overlay.pressed': '--ds-rovo-surface-overlay-pressed',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $6ae3353be2245a6b$export$2e2bcd8739ae039 = $6ae3353be2245a6b$var$tokens;

});

parcelRegister("kk9vf", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $ecbd0c057ee21de6$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $ecbd0c057ee21de6$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", function () { return $ecbd0c057ee21de6$export$dddac1532e822863; });
var $ecbd0c057ee21de6$export$4ef52930e33717cd = 'data-theme';
var $ecbd0c057ee21de6$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $ecbd0c057ee21de6$export$a00eac3f8684bcd0 = 'data-color-mode';
var $ecbd0c057ee21de6$export$2112803007239c61 = 'data-contrast-mode';
var $ecbd0c057ee21de6$export$352e418ed5b6193a = 'data-custom-theme';
var $ecbd0c057ee21de6$export$6f0c6fb8c80fcc92 = 'ds';
var $ecbd0c057ee21de6$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $ecbd0c057ee21de6$export$dddac1532e822863 = "--".concat($ecbd0c057ee21de6$export$6f0c6fb8c80fcc92, "-token-not-found");
var $ecbd0c057ee21de6$export$9d7b58831ae93caa = "--".concat($ecbd0c057ee21de6$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("j9BEl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $df1c100df26f3bb5$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $7Zt4h = parcelRequire("7Zt4h");

var $kFuqb = parcelRequire("kFuqb");

var $3oV3g = parcelRequire("3oV3g");

var $7t0tI = parcelRequire("7t0tI");
var $df1c100df26f3bb5$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var _process$env;
    var isModernContextEnabledEnv = typeof $7t0tI !== 'undefined' && $7t0tI !== null && ((_process$env = {}, _process$env === void 0) ? void 0 : _process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);
    return isModernContextEnabledEnv || (0, $7Zt4h.getBooleanFF)('platform.analytics-next-use-modern-context_fqgbx') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3oV3g.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kFuqb.default), props);
};
var $df1c100df26f3bb5$export$2e2bcd8739ae039 = $df1c100df26f3bb5$var$ExportedAnalyticsContext;

});
parcelRegister("kFuqb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f0bf3c0a01f39e80$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $h4ELM = parcelRequire("h4ELM");

var $i7dvh = parcelRequire("i7dvh");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $4OgEb = parcelRequire("4OgEb");

var $bEiDG = parcelRequire("bEiDG");
function $f0bf3c0a01f39e80$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f0bf3c0a01f39e80$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jlBwm.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jlBwm.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $i3Ugd.default)(this, result);
    };
}
function $f0bf3c0a01f39e80$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f0bf3c0a01f39e80$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f0bf3c0a01f39e80$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).func
};
var $f0bf3c0a01f39e80$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $f0bf3c0a01f39e80$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, $i7dvh.default)(AnalyticsContext, _Component);
    var _super = $f0bf3c0a01f39e80$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, $cTewU.default)(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $f0bf3c0a01f39e80$var$noop : _this$context$getAtla;
            return [].concat((0, $lFOXD.default)(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $f0bf3c0a01f39e80$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, $avOEA.default)(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bEiDG.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $1oC0p.Component));
(0, $f53LC.default)($f0bf3c0a01f39e80$var$AnalyticsContext, "contextTypes", $f0bf3c0a01f39e80$var$ContextTypes);
(0, $f53LC.default)($f0bf3c0a01f39e80$var$AnalyticsContext, "childContextTypes", $f0bf3c0a01f39e80$var$ContextTypes);
var $f0bf3c0a01f39e80$export$2e2bcd8739ae039 = $f0bf3c0a01f39e80$var$AnalyticsContext;

});

parcelRegister("3oV3g", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $279fde3eadf46ed4$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");

var $e1T86 = parcelRequire("e1T86");

var $j10Ql = parcelRequire("j10Ql");
var $279fde3eadf46ed4$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $j10Ql.useTrackedRef)(data);
    var analyticsContext = (0, $e1T86.useAnalyticsContext)();
    var getAtlaskitAnalyticsContext = (0, $1oC0p.useCallback)(function() {
        return [].concat((0, $lFOXD.default)(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $1oC0p.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bEiDG.default).Provider, {
        value: value
    }, children);
};
var $279fde3eadf46ed4$export$2e2bcd8739ae039 = $279fde3eadf46ed4$var$AnalyticsContext;

});


parcelRegister("56Xlo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3b8b8bc15be3f933$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $j9BEl = parcelRequire("j9BEl");
var $3b8b8bc15be3f933$var$_excluded = [
    "analyticsContext"
];
function $3b8b8bc15be3f933$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b8b8bc15be3f933$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b8b8bc15be3f933$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b8b8bc15be3f933$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3b8b8bc15be3f933$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, $gnQ3X.default)(_ref, $3b8b8bc15be3f933$var$_excluded);
            var analyticsData = (0, $1oC0p.useMemo)(function() {
                return $3b8b8bc15be3f933$var$_objectSpread($3b8b8bc15be3f933$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $j9BEl.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(WrappedComponent, (0, $c9bqK.default)({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $3b8b8bc15be3f933$export$2e2bcd8739ae039 = $3b8b8bc15be3f933$var$withAnalyticsContext;

});

parcelRegister("4jLK2", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $324df84505b66cc8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $324df84505b66cc8$var$arrayPush;

});

parcelRegister("8E4Q5", function(module, exports) {

var $jjQDv = parcelRequire("jjQDv");

var $lhaWD = parcelRequire("lhaWD");
/** Used for built-in method references. */ var $64b5d013d9ba84e9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64b5d013d9ba84e9$var$hasOwnProperty = $64b5d013d9ba84e9$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $64b5d013d9ba84e9$var$propertyIsEnumerable = $64b5d013d9ba84e9$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $64b5d013d9ba84e9$var$isArguments = $jjQDv(function() {
    return arguments;
}()) ? $jjQDv : function(value) {
    return $lhaWD(value) && $64b5d013d9ba84e9$var$hasOwnProperty.call(value, 'callee') && !$64b5d013d9ba84e9$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $64b5d013d9ba84e9$var$isArguments;

});
parcelRegister("jjQDv", function(module, exports) {

var $2EKmr = parcelRequire("2EKmr");

var $lhaWD = parcelRequire("lhaWD");
/** `Object#toString` result references. */ var $e1089f2233a3dc7f$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $e1089f2233a3dc7f$var$baseIsArguments(value) {
    return $lhaWD(value) && $2EKmr(value) == $e1089f2233a3dc7f$var$argsTag;
}
module.exports = $e1089f2233a3dc7f$var$baseIsArguments;

});


parcelRegister("cTpmH", function(module, exports) {
/** Used as references for various `Number` constants. */ var $962e4c171a5f9227$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $962e4c171a5f9227$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $962e4c171a5f9227$var$MAX_SAFE_INTEGER;
}
module.exports = $962e4c171a5f9227$var$isLength;

});

parcelRegister("gHIMV", function(module, exports) {

var $24uwp = parcelRequire("24uwp");

var $7RbbL = parcelRequire("7RbbL");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $c2936778f0bf11fd$var$capitalize(string) {
    return $7RbbL($24uwp(string).toLowerCase());
}
module.exports = $c2936778f0bf11fd$var$capitalize;

});
parcelRegister("7RbbL", function(module, exports) {

var $iBcGo = parcelRequire("iBcGo");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $5b86297e1fc1db25$var$upperFirst = $iBcGo('toUpperCase');
module.exports = $5b86297e1fc1db25$var$upperFirst;

});
parcelRegister("iBcGo", function(module, exports) {

var $ehULU = parcelRequire("ehULU");

var $ePM67 = parcelRequire("ePM67");

var $1GITV = parcelRequire("1GITV");

var $24uwp = parcelRequire("24uwp");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $d8a585375440fb5a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $24uwp(string);
        var strSymbols = $ePM67(string) ? $1GITV(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $ehULU(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $d8a585375440fb5a$var$createCaseFirst;

});
parcelRegister("ehULU", function(module, exports) {

var $ezuzU = parcelRequire("ezuzU");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $a66eb0e6cce6b4e5$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $ezuzU(array, start, end);
}
module.exports = $a66eb0e6cce6b4e5$var$castSlice;

});
parcelRegister("ezuzU", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $a9bc0dc53628b88a$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $a9bc0dc53628b88a$var$baseSlice;

});


parcelRegister("ePM67", function(module, exports) {
/** Used to compose unicode character classes. */ var $accb234eacd9a37f$var$rsAstralRange = '\\ud800-\\udfff', $accb234eacd9a37f$var$rsComboMarksRange = '\\u0300-\\u036f', $accb234eacd9a37f$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $accb234eacd9a37f$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $accb234eacd9a37f$var$rsComboRange = $accb234eacd9a37f$var$rsComboMarksRange + $accb234eacd9a37f$var$reComboHalfMarksRange + $accb234eacd9a37f$var$rsComboSymbolsRange, $accb234eacd9a37f$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $accb234eacd9a37f$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $accb234eacd9a37f$var$reHasUnicode = RegExp('[' + $accb234eacd9a37f$var$rsZWJ + $accb234eacd9a37f$var$rsAstralRange + $accb234eacd9a37f$var$rsComboRange + $accb234eacd9a37f$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $accb234eacd9a37f$var$hasUnicode(string) {
    return $accb234eacd9a37f$var$reHasUnicode.test(string);
}
module.exports = $accb234eacd9a37f$var$hasUnicode;

});

parcelRegister("1GITV", function(module, exports) {

var $3VH6A = parcelRequire("3VH6A");

var $ePM67 = parcelRequire("ePM67");

var $aYfG6 = parcelRequire("aYfG6");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $13ac8b161df780fb$var$stringToArray(string) {
    return $ePM67(string) ? $aYfG6(string) : $3VH6A(string);
}
module.exports = $13ac8b161df780fb$var$stringToArray;

});
parcelRegister("3VH6A", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $2dc821c7632c8518$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $2dc821c7632c8518$var$asciiToArray;

});

parcelRegister("aYfG6", function(module, exports) {
/** Used to compose unicode character classes. */ var $7fcbab4f0bbb188c$var$rsAstralRange = '\\ud800-\\udfff', $7fcbab4f0bbb188c$var$rsComboMarksRange = '\\u0300-\\u036f', $7fcbab4f0bbb188c$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7fcbab4f0bbb188c$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7fcbab4f0bbb188c$var$rsComboRange = $7fcbab4f0bbb188c$var$rsComboMarksRange + $7fcbab4f0bbb188c$var$reComboHalfMarksRange + $7fcbab4f0bbb188c$var$rsComboSymbolsRange, $7fcbab4f0bbb188c$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $7fcbab4f0bbb188c$var$rsAstral = '[' + $7fcbab4f0bbb188c$var$rsAstralRange + ']', $7fcbab4f0bbb188c$var$rsCombo = '[' + $7fcbab4f0bbb188c$var$rsComboRange + ']', $7fcbab4f0bbb188c$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $7fcbab4f0bbb188c$var$rsModifier = '(?:' + $7fcbab4f0bbb188c$var$rsCombo + '|' + $7fcbab4f0bbb188c$var$rsFitz + ')', $7fcbab4f0bbb188c$var$rsNonAstral = '[^' + $7fcbab4f0bbb188c$var$rsAstralRange + ']', $7fcbab4f0bbb188c$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $7fcbab4f0bbb188c$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $7fcbab4f0bbb188c$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $7fcbab4f0bbb188c$var$reOptMod = $7fcbab4f0bbb188c$var$rsModifier + '?', $7fcbab4f0bbb188c$var$rsOptVar = '[' + $7fcbab4f0bbb188c$var$rsVarRange + ']?', $7fcbab4f0bbb188c$var$rsOptJoin = '(?:' + $7fcbab4f0bbb188c$var$rsZWJ + '(?:' + [
    $7fcbab4f0bbb188c$var$rsNonAstral,
    $7fcbab4f0bbb188c$var$rsRegional,
    $7fcbab4f0bbb188c$var$rsSurrPair
].join('|') + ')' + $7fcbab4f0bbb188c$var$rsOptVar + $7fcbab4f0bbb188c$var$reOptMod + ')*', $7fcbab4f0bbb188c$var$rsSeq = $7fcbab4f0bbb188c$var$rsOptVar + $7fcbab4f0bbb188c$var$reOptMod + $7fcbab4f0bbb188c$var$rsOptJoin, $7fcbab4f0bbb188c$var$rsSymbol = '(?:' + [
    $7fcbab4f0bbb188c$var$rsNonAstral + $7fcbab4f0bbb188c$var$rsCombo + '?',
    $7fcbab4f0bbb188c$var$rsCombo,
    $7fcbab4f0bbb188c$var$rsRegional,
    $7fcbab4f0bbb188c$var$rsSurrPair,
    $7fcbab4f0bbb188c$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $7fcbab4f0bbb188c$var$reUnicode = RegExp($7fcbab4f0bbb188c$var$rsFitz + '(?=' + $7fcbab4f0bbb188c$var$rsFitz + ')|' + $7fcbab4f0bbb188c$var$rsSymbol + $7fcbab4f0bbb188c$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7fcbab4f0bbb188c$var$unicodeToArray(string) {
    return string.match($7fcbab4f0bbb188c$var$reUnicode) || [];
}
module.exports = $7fcbab4f0bbb188c$var$unicodeToArray;

});





parcelRegister("5AtlP", function(module, exports) {
$parcel$export(module.exports, "getFirstName", function () { return $f5b50bde618a4cd3$export$cf3a9fa4cebe2986; });
function $f5b50bde618a4cd3$export$cf3a9fa4cebe2986(fullName = '') {
    return fullName.trim().split(' ')[0] || '';
}

});

parcelRegister("jgdMW", function(module, exports) {
$parcel$export(module.exports, "RowGrid", function () { return $a79cb55f58fa05ed$export$29ae18f9ecc70243; });
/* row-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $a79cb55f58fa05ed$export$29ae18f9ecc70243 = ({ children: children, numCols: numCols, colWidth: colWidth, numRows: numRows, rowHeight: rowHeight, rowGap: rowGap, columnGap: columnGap, paddingInline: paddingInline, paddingBlock: paddingBlock, marginInline: marginInline, marginBlock: marginBlock })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: {
            gridTemplateColumns: `${(colWidth ? `${colWidth} ` : '1fr ').repeat(numCols)}`,
            gridTemplateRows: `${numRows && (rowHeight ? `${rowHeight} ` : '1fr ').repeat(numRows)}`,
            rowGap: rowGap,
            columnGap: columnGap,
            paddingInline: paddingInline,
            paddingBlock: paddingBlock,
            marginInline: marginInline,
            marginBlock: marginBlock
        },
        className: (0, $2jatx.default)([
            "_1e0c11p5"
        ]),
        children: children
    });
};

});

parcelRegister("kX9u3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfe75e26330f86b48e811f0d520fc5e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f410ac9a9ac4f2f6$var$_react = $f410ac9a9ac4f2f6$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f410ac9a9ac4f2f6$var$_baseNew = $f410ac9a9ac4f2f6$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f410ac9a9ac4f2f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f410ac9a9ac4f2f6$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $f410ac9a9ac4f2f6$var$_react.default.createElement($f410ac9a9ac4f2f6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$f410ac9a9ac4f2f6$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $f410ac9a9ac4f2f6$var$_default = module.exports.default = $f410ac9a9ac4f2f6$var$OfficeBuildingIcon;

});

parcelRegister("hrBjL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e29ae4526453fe67eff894ad5ac76ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb31e7ce97688c96$var$_react = $cb31e7ce97688c96$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cb31e7ce97688c96$var$_baseNew = $cb31e7ce97688c96$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $cb31e7ce97688c96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb31e7ce97688c96$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $cb31e7ce97688c96$var$_react.default.createElement($cb31e7ce97688c96$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$cb31e7ce97688c96$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $cb31e7ce97688c96$var$_default = module.exports.default = $cb31e7ce97688c96$var$CheckCircleIcon;

});

parcelRegister("hiWeO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63dc429f33c9470dc156b62d0ec66db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9914af41d2254d3$var$_react = $c9914af41d2254d3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c9914af41d2254d3$var$_baseNew = $c9914af41d2254d3$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $c9914af41d2254d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9914af41d2254d3$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $c9914af41d2254d3$var$_react.default.createElement($c9914af41d2254d3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$c9914af41d2254d3$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $c9914af41d2254d3$var$_default = module.exports.default = $c9914af41d2254d3$var$QuestionCircleIcon;

});

parcelRegister("a9CD6", function(module, exports) {
$parcel$export(module.exports, "ConfluenceMarkBrand", function () { return $2ce451c25fbd45ca$export$c3c079c94b97bdde; });

var $7VQPk = parcelRequire("7VQPk");
const $2ce451c25fbd45ca$export$c3c079c94b97bdde = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.76706 32.3019C8.42806 32.8539 8.04306 33.5009 7.74406 34.0099C7.45606 34.5009 7.61106 35.1319 8.09606 35.4309L14.8901 39.6239C15.3881 39.9309 16.0401 39.7729 16.3371 39.2689C16.6071 38.8119 16.9571 38.2239 17.3391 37.5919C20.0321 33.1479 22.7401 33.6899 27.6191 36.0089L34.3571 39.2119C34.8881 39.4649 35.5231 39.2289 35.7621 38.6909L38.9981 31.3849C39.2281 30.8649 39.0021 30.2579 38.4881 30.0159C37.0651 29.3469 34.2371 28.0119 31.7051 26.7859C22.5051 22.3309 14.7201 22.6249 8.76806 32.3019H8.76706Z",
                fill: "url(#paint0_linear_818_553)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M39.233 15.6978C39.572 15.1458 39.957 14.4988 40.256 13.9898C40.544 13.4988 40.389 12.8678 39.904 12.5688L33.11 8.37583C32.612 8.06883 31.96 8.22683 31.663 8.73083C31.393 9.18783 31.043 9.77583 30.661 10.4078C27.968 14.8518 25.26 14.3098 20.381 11.9908L13.643 8.78783C13.112 8.53483 12.477 8.77083 12.238 9.30883L9.00202 16.6148C8.77202 17.1348 8.99802 17.7418 9.51202 17.9838C10.935 18.6528 13.763 19.9878 16.295 21.2138C25.495 25.6688 33.28 25.3748 39.232 15.6978H39.233Z",
                fill: "url(#paint1_linear_818_553)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_553",
                        x1: "38.7961",
                        y1: "41.7759",
                        x2: "18.2371",
                        y2: "29.9619",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.972",
                                stopColor: "#1C78FA"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_553",
                        x1: "9.20302",
                        y1: "6.22383",
                        x2: "29.763",
                        y2: "18.0378",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.972",
                                stopColor: "#1C78FA"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("98rQm", function(module, exports) {
$parcel$export(module.exports, "TrelloMarkBrand", function () { return $af693e7b669a0669$export$f4e51c099e77aab7; });

var $7VQPk = parcelRequire("7VQPk");
const $af693e7b669a0669$export$f4e51c099e77aab7 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M36.429 7.69385H11.571C9.42997 7.69385 7.69397 9.42985 7.69397 11.5708V36.4288C7.69397 38.5698 9.42997 40.3058 11.571 40.3058H36.429C38.57 40.3058 40.306 38.5698 40.306 36.4288V11.5708C40.306 9.42985 38.57 7.69385 36.429 7.69385ZM21.742 31.1828C21.742 31.8948 21.165 32.4708 20.454 32.4708H15.003C14.291 32.4708 13.715 31.8938 13.715 31.1828V15.0028C13.715 14.2908 14.292 13.7148 15.003 13.7148H20.454C21.166 13.7148 21.742 14.2918 21.742 15.0028V31.1828ZM34.285 23.7548C34.285 24.4668 33.708 25.0428 32.997 25.0428H27.546C26.834 25.0428 26.258 24.4658 26.258 23.7548V15.0028C26.258 14.2908 26.835 13.7148 27.546 13.7148H32.997C33.709 13.7148 34.285 14.2918 34.285 15.0028V23.7548Z",
                fill: "url(#paint0_linear_818_512)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_512",
                    x1: "24",
                    y1: "40.3058",
                    x2: "24",
                    y2: "7.69385",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("bIY3n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8892631fc819236e$var$_react = $8892631fc819236e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8892631fc819236e$var$_baseNew = $8892631fc819236e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $8892631fc819236e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8892631fc819236e$var$AddIcon = (props)=>/*#__PURE__*/ $8892631fc819236e$var$_react.default.createElement($8892631fc819236e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$8892631fc819236e$var$AddIcon.displayName = 'AddIcon';
var $8892631fc819236e$var$_default = module.exports.default = $8892631fc819236e$var$AddIcon;

});

parcelRegister("4jcRW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3232eb4c0efd91e0$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $7DAIH = parcelRequire("7DAIH");
var $dtlzK = parcelRequire("dtlzK");
function $3232eb4c0efd91e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3232eb4c0efd91e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3232eb4c0efd91e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3232eb4c0efd91e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3232eb4c0efd91e0$var$shimmerKeyframes = null;
var $3232eb4c0efd91e0$var$skeletonStyles = null;
var $3232eb4c0efd91e0$var$activeShimmerStyles = null;
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ var $3232eb4c0efd91e0$var$Skeleton = function Skeleton(_ref) {
    var width = _ref.width, height = _ref.height, _ref$borderRadius = _ref.borderRadius, borderRadius = _ref$borderRadius === void 0 ? "var(--ds-radius-small, 4px)" : _ref$borderRadius, color = _ref.color, ShimmeringEndColor = _ref.ShimmeringEndColor, _ref$isShimmering = _ref.isShimmering, isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering, groupName = _ref.groupName, testId = _ref.testId;
    var groupDataAttribute = groupName && "data-".concat(groupName);
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $c9bqK.default)({
        "data-testid": testId
    }, groupDataAttribute && (0, $f53LC.default)({}, groupDataAttribute, 'true'), {
        className: (0, $7DAIH.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
            isShimmering && "",
            isShimmering && "_j7hq586c"
        ]),
        style: $3232eb4c0efd91e0$var$_objectSpread($3232eb4c0efd91e0$var$_objectSpread({}, {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        }), {}, {
            "--_wenvhl": (0, $dtlzK.default)("var(--ds-skeleton-from-color, ".concat("var(--ds-skeleton, #091E420F)", ")")),
            "--_1soe2er": (0, $dtlzK.default)("var(--ds-skeleton-to-color, ".concat("var(--ds-skeleton-subtle, #091E4208)", ")"))
        })
    }));
};
var $3232eb4c0efd91e0$export$2e2bcd8739ae039 = $3232eb4c0efd91e0$var$Skeleton;

});
parcelRegister("7DAIH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $58f8a8b7a32ab166$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $58f8a8b7a32ab166$var$ATOMIC_GROUP_LENGTH = 5;
function $58f8a8b7a32ab166$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $58f8a8b7a32ab166$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("dtlzK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9ceeb844cdd8c978$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $9ceeb844cdd8c978$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});


parcelRegister("l5ucJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5a17e8d4d565048$var$_react = $f5a17e8d4d565048$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f5a17e8d4d565048$var$_baseNew = $f5a17e8d4d565048$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f5a17e8d4d565048$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f5a17e8d4d565048$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $f5a17e8d4d565048$var$_react.default.createElement($f5a17e8d4d565048$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$f5a17e8d4d565048$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $f5a17e8d4d565048$var$_default = module.exports.default = $f5a17e8d4d565048$var$ChevronDownIcon;

});

parcelRegister("97j0t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a3382d00f416b95$var$_react = $6a3382d00f416b95$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6a3382d00f416b95$var$_baseNew = $6a3382d00f416b95$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $6a3382d00f416b95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a3382d00f416b95$var$BoardIcon = (props)=>/*#__PURE__*/ $6a3382d00f416b95$var$_react.default.createElement($6a3382d00f416b95$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$6a3382d00f416b95$var$BoardIcon.displayName = 'BoardIcon';
var $6a3382d00f416b95$var$_default = module.exports.default = $6a3382d00f416b95$var$BoardIcon;

});

parcelRegister("auF8s", function(module, exports) {

var $4jLK2 = parcelRequire("4jLK2");

var $e06LX = parcelRequire("e06LX");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a3c9d6218c43abc$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $e06LX);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a3c9d6218c43abc$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $4jLK2(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a3c9d6218c43abc$var$baseFlatten;

});
parcelRegister("e06LX", function(module, exports) {

var $3MHuE = parcelRequire("3MHuE");

var $8E4Q5 = parcelRequire("8E4Q5");

var $lPKNl = parcelRequire("lPKNl");
/** Built-in value references. */ var $a31651a1aa52b9f5$var$spreadableSymbol = $3MHuE ? $3MHuE.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $a31651a1aa52b9f5$var$isFlattenable(value) {
    return $lPKNl(value) || $8E4Q5(value) || !!($a31651a1aa52b9f5$var$spreadableSymbol && value && value[$a31651a1aa52b9f5$var$spreadableSymbol]);
}
module.exports = $a31651a1aa52b9f5$var$isFlattenable;

});


parcelRegister("5oMeU", function(module, exports) {

var $hLLeA = parcelRequire("hLLeA");

var $119FI = parcelRequire("119FI");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $3ee49cf968a053d8$var$baseGet(object, path) {
    path = $hLLeA(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$119FI(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $3ee49cf968a053d8$var$baseGet;

});

parcelRegister("4EAwS", function(module, exports) {

var $5oMeU = parcelRequire("5oMeU");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $36373bd43f9f4b21$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $5oMeU(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $36373bd43f9f4b21$var$get;

});

parcelRegister("8avIg", function(module, exports) {

var $90xK9 = parcelRequire("90xK9");

var $eW6W4 = parcelRequire("eW6W4");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $5f27db6f2fb2ce7d$var$hasIn(object, path) {
    return object != null && $eW6W4(object, path, $90xK9);
}
module.exports = $5f27db6f2fb2ce7d$var$hasIn;

});
parcelRegister("90xK9", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $68ee49e62966a7ed$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $68ee49e62966a7ed$var$baseHasIn;

});

parcelRegister("eW6W4", function(module, exports) {

var $hLLeA = parcelRequire("hLLeA");

var $8E4Q5 = parcelRequire("8E4Q5");

var $lPKNl = parcelRequire("lPKNl");

var $f6osf = parcelRequire("f6osf");

var $cTpmH = parcelRequire("cTpmH");

var $119FI = parcelRequire("119FI");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $adfbdcbd1c5e47b6$var$hasPath(object, path, hasFunc) {
    path = $hLLeA(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $119FI(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $cTpmH(length) && $f6osf(key, length) && ($lPKNl(object) || $8E4Q5(object));
}
module.exports = $adfbdcbd1c5e47b6$var$hasPath;

});


parcelRegister("1f5iV", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $0e7b4e76421e80bb$var$identity(value) {
    return value;
}
module.exports = $0e7b4e76421e80bb$var$identity;

});

parcelRegister("axmYb", function(module, exports) {

var $3ls0q = parcelRequire("3ls0q");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7abecdc323c478eb$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $7abecdc323c478eb$var$overRest(func, start, transform) {
    start = $7abecdc323c478eb$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $7abecdc323c478eb$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $3ls0q(func, this, otherArgs);
    };
}
module.exports = $7abecdc323c478eb$var$overRest;

});
parcelRegister("3ls0q", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $26f90e9ed1e087a4$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $26f90e9ed1e087a4$var$apply;

});


parcelRegister("jj29P", function(module, exports) {

var $j199U = parcelRequire("j199U");

var $i9M4A = parcelRequire("i9M4A");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $e0e17718533c241f$var$setToString = $i9M4A($j199U);
module.exports = $e0e17718533c241f$var$setToString;

});
parcelRegister("j199U", function(module, exports) {

var $3Kt5H = parcelRequire("3Kt5H");

var $cmtMX = parcelRequire("cmtMX");

var $1f5iV = parcelRequire("1f5iV");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $dd85370c1f08aaa6$var$baseSetToString = !$cmtMX ? $1f5iV : function(func, string) {
    return $cmtMX(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $3Kt5H(string),
        'writable': true
    });
};
module.exports = $dd85370c1f08aaa6$var$baseSetToString;

});
parcelRegister("3Kt5H", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $2bac3bd7f8fc3bd7$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $2bac3bd7f8fc3bd7$var$constant;

});


parcelRegister("i9M4A", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $d37e5b869faf8491$var$HOT_COUNT = 800, $d37e5b869faf8491$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d37e5b869faf8491$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $d37e5b869faf8491$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $d37e5b869faf8491$var$nativeNow(), remaining = $d37e5b869faf8491$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $d37e5b869faf8491$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $d37e5b869faf8491$var$shortOut;

});


parcelRegister("l23yj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4fc8a53b23a3baa$var$_react = $f4fc8a53b23a3baa$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f4fc8a53b23a3baa$var$_baseNew = $f4fc8a53b23a3baa$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f4fc8a53b23a3baa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4fc8a53b23a3baa$var$PersonIcon = (props)=>/*#__PURE__*/ $f4fc8a53b23a3baa$var$_react.default.createElement($f4fc8a53b23a3baa$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$f4fc8a53b23a3baa$var$PersonIcon.displayName = 'PersonIcon';
var $f4fc8a53b23a3baa$var$_default = module.exports.default = $f4fc8a53b23a3baa$var$PersonIcon;

});

parcelRegister("61pdb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5437a6fa40a6a5e2291c258b3bd34ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46266490593ddb94$var$_react = $46266490593ddb94$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $46266490593ddb94$var$_baseNew = $46266490593ddb94$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $46266490593ddb94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $46266490593ddb94$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $46266490593ddb94$var$_react.default.createElement($46266490593ddb94$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$46266490593ddb94$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $46266490593ddb94$var$_default = module.exports.default = $46266490593ddb94$var$CheckMarkIcon;

});

parcelRegister("56bcs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b66335b7827c74c$var$_react = $3b66335b7827c74c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3b66335b7827c74c$var$_baseNew = $3b66335b7827c74c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3b66335b7827c74c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b66335b7827c74c$var$CalendarIcon = (props)=>/*#__PURE__*/ $3b66335b7827c74c$var$_react.default.createElement($3b66335b7827c74c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$3b66335b7827c74c$var$CalendarIcon.displayName = 'CalendarIcon';
var $3b66335b7827c74c$var$_default = module.exports.default = $3b66335b7827c74c$var$CalendarIcon;

});

parcelRegister("gta0F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::481d1ea8ad85e9d7b0bddff8ba9b16d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfd71e82ab0194f9$var$_react = $bfd71e82ab0194f9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bfd71e82ab0194f9$var$_baseNew = $bfd71e82ab0194f9$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $bfd71e82ab0194f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListChecklist".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: Checklist, 'Requirement' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bfd71e82ab0194f9$var$ListChecklistIcon = (props)=>/*#__PURE__*/ $bfd71e82ab0194f9$var$_react.default.createElement($bfd71e82ab0194f9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.59 9.97-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07-1.37-2.12 1.26-.81.81 1.25 2.33-2.95zm0-7.5-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07L.01 4.04l1.26-.81.81 1.25 2.33-2.95zM16 11v1.5H7V11zm0-7.5V5H7V3.5z"/>`
    }, props));
$bfd71e82ab0194f9$var$ListChecklistIcon.displayName = 'ListChecklistIcon';
var $bfd71e82ab0194f9$var$_default = module.exports.default = $bfd71e82ab0194f9$var$ListChecklistIcon;

});

parcelRegister("NtjLk", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $2da6ff99551ef1ce$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $cNOwN = parcelRequire("cNOwN");

var $5kbMC = parcelRequire("5kbMC");

var $FapDU = parcelRequire("FapDU");

var $hnmMQ = parcelRequire("hnmMQ");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $8cYSw = parcelRequire("8cYSw");

var $21L8z = parcelRequire("21L8z");

var $eOIix = parcelRequire("eOIix");

var $6iX8D = parcelRequire("6iX8D");

var $iPPTB = parcelRequire("iPPTB");
const $2da6ff99551ef1ce$export$3c868f5963107f89 = {
    atlassian: 'https://dam-cdn.atl.orangelogic.com/AssetLink/25o68v5s8lr856c06p606q47s76rs10f.svg',
    guard: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8j5d41rmb7q4himg4r42k3e84hvoo07i.svg'
};
const $2da6ff99551ef1ce$export$60332b2344f7fe41 = ({ align: align = 'start', orientation: // we currently do not support a horizontal orientation card with an image
// the outstanding issue is that the the image has a requirement of an aspect ratio of 16:9
// and the card text is unbounded (so prioritizing the image would make the text potentially
// overflow), and prioritizing the text would make the image potentially have undesired
// white space at the end
orientation = 'vertical', columns: columns, background: background = 'light', eyebrow: eyebrow, logo: logo, title: title, body: body, image: image, imageAspectRatio: imageAspectRatio = '16 / 9', icon: { linkedIcon: { url: iconUrl, size: iconSize = 'medium', paddingIncluded: paddingIncluded = false } = {}, iconComponent: iconComponent } = {}, callToAction: callToAction, spotIllustration: spotIllustration, videoSrc: videoSrc, ...props })=>{
    // hedge against the value being passed in as a string (the options in uniform can only be string values)
    // which would subsequently fail a string vs number check ie 10 === "10" is false
    const numColumns = Number(columns);
    const { titleAs: TitleComponent = 'h3', containerType: Container = 'div' } = props;
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    const isDark = background === 'dark' || isDarkTheme;
    const isLinkableCard = !!callToAction;
    // React's useId() returns strings like ":R0:" which contain colons — colons are valid
    // in HTML id attributes but invalid in CSS id selectors without escaping. Compiled CSS
    // generates :has() selectors that reference elements by their id, and jsdom's nwsapi
    // cannot parse unescaped colons in generated selectors. Sanitize by replacing colons
    // with hyphens to produce CSS-safe ids like "-R0-".
    const uniqueId = (0, $1oC0p.useId)().replace(/:/g, '-');
    const titleId = `card-title-${uniqueId}`;
    const callToActionId = `card-cta-${uniqueId}`;
    const [isVideoOverlayOpen, setIsVideoOverlayOpen] = (0, $1oC0p.useState)(false);
    const bodyElement = typeof body === 'string' ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3"
        ]),
        children: body
    }) : body;
    const openVideoOverlay = (event)=>{
        event.preventDefault();
        setIsVideoOverlayOpen(true);
    };
    const videoOverlay = videoSrc ? isVideoOverlayOpen && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5kbMC.default), {
        onClose: ()=>setIsVideoOverlayOpen(false),
        label: typeof title === 'string' ? title : callToAction?.text,
        width: "x-large",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iX8D.EmbeddedVideo), {
                    embedUrl: videoSrc,
                    title: typeof title === 'string' ? title : callToAction?.text,
                    autoPlay: true
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                    type: "button",
                    onClick: ()=>setIsVideoOverlayOpen(false),
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _11q7vkha _19itidpf _2rko1ssb _syaz1afi _80omtlke _1e0c1txw _152tu2gc _rjxpu2gc _1yt412x7 _kqswstnw _1pbykb7n _1ygb14ak _1ah3yh40"
                    ]),
                    style: {
                        "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200')),
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
                            label: "",
                            color: "currentColor"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FapDU.default), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "card.video.close",
                                defaultMessage: "Close video"
                            })
                        })
                    ]
                })
            ]
        })
    }) : null;
    const card = /*#__PURE__*/ (0, $7VQPk.jsxs)(Container, {
        className: (0, $2jatx.default)([
            "_2rko1ylz _1e0c1txw _yyhy10md",
            align === 'center' && "_4cvr1h6o _y3gn1h6o",
            isDark ? "_11q7vkha _19itxb7o _syaz1afi _cg411afi _qliy1afi _1rhq1afi _jl6w1afi _s9741afi _125x1afi _1evh1afi _1suq1afi" : "_11q71afi _19itkze7",
            orientation === 'vertical' && "_2lx21bp4",
            orientation === 'horizontal' && "_2lx2vrvc _4t3i1osq _1bsb1osq _14q21bp4",
            isLinkableCard && "_kqswh2mm _13whb3bt _ykcxidpf _1heustnw _1w8ikb7n _1piy1vf8 _q7ne1vf8",
            isLinkableCard && !isDark && "_v564mnji _1ni61kw8 _a7on1kw8 _clok130s _1v69130s"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200')),
            "--_19gw9o2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark100')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
        },
        children: [
            spotIllustration ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1pfhxy5q _ahbqxy5q _12l2xy5q _6rthu2gc",
                    orientation === 'horizontal' && "_12l2u2gc _1ob9xy5q",
                    "spotIllustrationContainer"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: spotIllustration.src,
                    alt: spotIllustration.alt ?? '',
                    style: {
                        height: spotIllustration.height ?? (orientation === 'vertical' ? (0, $21L8z.SPOT_ILLUSTRATION_MAX_HEIGHT) : 'auto'),
                        maxHeight: orientation === 'vertical' ? (0, $21L8z.SPOT_ILLUSTRATION_MAX_HEIGHT) : 'auto',
                        width: orientation === 'horizontal' && !spotIllustration.height ? (0, $21L8z.SPOT_ILLUSTRATION_WIDTH_ON_HORIZONTAL_CARD) : 'auto',
                        maxWidth: orientation === 'horizontal' && spotIllustration.height ? 'auto' : '100%'
                    }
                })
            }) : image && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1reozryt _18m9zryt _1e0c1txw _1bah1h6o _4cvr1h6o",
                    orientation === 'vertical' && "_1s1g1ylz _5fbc1ylz _1o9zidpf _kqswh2mm _1bsb1osq",
                    orientation === 'vertical' && imageAspectRatio === '1 / 1' && "_1h1t1ekt",
                    orientation === 'vertical' && imageAspectRatio !== '1 / 1' && "_1h1tcq2i",
                    orientation === 'horizontal' && "_1s1g1ylz _1yxn1ylz _4t3i1osq _1bsb1osq _1e0c1txw",
                    videoSrc && "_kqswh2mm _1hfkvkha _aetrb3bt _9v7aidpf _1peqnh7s _11fnglyw _18postnw",
                    `cardImageContainer${videoSrc ? ' videoCardImageContainer' : ''}`
                ]),
                style: {
                    "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                    "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        ...image,
                        src: image.src,
                        alt: image.alt,
                        className: (0, $2jatx.default)([
                            "_4t3i1osq _1bsb1osq _1e0c1txw",
                            orientation === 'vertical' && "_1r04idpf _5ral1dfr _kqswstnw",
                            orientation === 'horizontal' && "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _5ral1f51",
                            videoSrc && "_4t3i1osq _5ral1dfr _t9ec1h7a _8hrzaqso _v5648pnm"
                        ])
                    }),
                    videoSrc && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iX8D.PlayIcon), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1yt41ejb _1e0c1txw _2lx21bp4 _zulpu2gc",
                    orientation === 'vertical' && "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                    orientation === 'horizontal' && "_1bsb1osq _4t3i1osq _1q51xy5q"
                ]),
                children: [
                    logo && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: $2da6ff99551ef1ce$export$3c868f5963107f89[logo],
                                alt: '',
                                height: 24
                            }
                        })
                    }),
                    iconUrl && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_6rthpxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                            src: iconUrl,
                            alt: '',
                            style: {
                                width: `${(0, $8cYSw.iconSizesPaddingIncluded)[iconSize]}px`,
                                height: `${(0, $8cYSw.iconSizesPaddingIncluded)[iconSize]}px`,
                                aspectRatio: '1',
                                padding: `${paddingIncluded ? 0 : ((0, $8cYSw.iconSizesPaddingIncluded)[iconSize] - (0, $8cYSw.iconSizesPaddingExcluded)[iconSize]) / 2}px`,
                                objectPosition: 'center'
                            }
                        })
                    }),
                    iconComponent && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_6rthpxbi"
                        ]),
                        children: iconComponent
                    }),
                    eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3",
                            "eyebrow-md"
                        ]),
                        children: eyebrow
                    }),
                    title && /*#__PURE__*/ (0, $7VQPk.jsx)(TitleComponent, {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3",
                            "card-title"
                        ]),
                        id: titleId,
                        children: title
                    }),
                    body && bodyElement,
                    isLinkableCard && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            orientation === 'vertical' && "_1pfh1wug",
                            "_1q51pxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            id: callToActionId,
                            ariaLabelledby: `${callToActionId} ${titleId}`,
                            type: videoSrc ? 'video' : 'primary',
                            ...callToAction,
                            href: videoSrc ?? callToAction.href,
                            anchorProps: videoSrc ? {
                                onClick: openVideoOverlay
                            } : callToAction.anchorProps,
                            className: `full-card ${callToAction?.className ?? ''}`,
                            bgColor: isDark ? 'bgBlackBlue' : 'bgWhite',
                            "aria-label": callToAction.text
                        })
                    })
                ]
            })
        ]
    });
    const fullWidthGridStyles = null;
    if (numColumns && orientation === 'horizontal') return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            videoOverlay,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_195g1wug _p12f1osq _1bsb1osq _13ltwklj _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bcx6w _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg _1qnyaw08 _n6am13k5"
                    ]),
                    style: {
                        "--_18qdfwk": (0, $6ZVlx.default)(numColumns === 10 ? 2 : 1),
                        "--_1xniuc0": (0, $6ZVlx.default)(numColumns === 10 ? 10 : 12)
                    },
                    children: card
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            videoOverlay,
            card
        ]
    });
};
const $2da6ff99551ef1ce$var$cardContainer = null;
const $2da6ff99551ef1ce$var$cardContainerLight = null;
const $2da6ff99551ef1ce$var$cardContainerDark = null;
const $2da6ff99551ef1ce$var$illustrationContainer = null;
const $2da6ff99551ef1ce$var$horizontalIllustrationContainer = null;
const $2da6ff99551ef1ce$var$verticalOrientation = null;
const $2da6ff99551ef1ce$var$horizontalOrientation = null;
const $2da6ff99551ef1ce$var$centeredCardContainer = null;
const $2da6ff99551ef1ce$var$linkableCardContainer = null;
const $2da6ff99551ef1ce$var$linkableCardHoverShadow = null;
const $2da6ff99551ef1ce$var$cardImageContainer = null;
const $2da6ff99551ef1ce$var$horizontalImageContainer = null;
const $2da6ff99551ef1ce$var$verticalImageContainer = null;
const $2da6ff99551ef1ce$var$widescreenImageAspectRatio = null;
const $2da6ff99551ef1ce$var$squareImageAspectRatio = null;
const $2da6ff99551ef1ce$var$imageStyle = null;
const $2da6ff99551ef1ce$var$verticalImageStyle = null;
const $2da6ff99551ef1ce$var$horizontalImageStyle = null;
const $2da6ff99551ef1ce$var$videoThumbnailContainer = null;
const $2da6ff99551ef1ce$var$videoThumbnailImageStyle = null;
const $2da6ff99551ef1ce$var$verticalBodyContainer = null;
const $2da6ff99551ef1ce$var$horizontalBodyContainer = null;
const $2da6ff99551ef1ce$var$cardBodyContainer = null;
const $2da6ff99551ef1ce$var$resetMargin = null;
const $2da6ff99551ef1ce$var$iconContainer = null;
const $2da6ff99551ef1ce$var$linkContainer = null;
const $2da6ff99551ef1ce$var$verticalLinkContainer = null;
const $2da6ff99551ef1ce$var$videoOverlayContent = null;
const $2da6ff99551ef1ce$var$videoOverlayCloseButton = null;

});
parcelRegister("6iX8D", function(module, exports) {
$parcel$export(module.exports, "PlayIcon", function () { return $41efe20f21d8b288$export$a6630b90defda83f; });
$parcel$export(module.exports, "EmbeddedVideo", function () { return $41efe20f21d8b288$export$e71032fcfd2bdb71; });
/* embedded-video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");
const $41efe20f21d8b288$export$a6630b90defda83f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_lswu1afi _tzy4q80t _kqswstnw _1e02idpf _rjxpidpf _152tidpf _u7coidpf _19pk1wug _2hwx1wug _otyr1wug _18u01wug _lcxvglyw _2rko1osq _1pbykb7n",
            "play-icon"
        ]),
        width: "70px",
        height: "70px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M16,0 C7.163444,-5.41083001e-16 1.082166e-15,7.163444 0,16 C-1.082166e-15,24.836556 7.163444,32 16,32 C24.836556,32 32,24.836556 32,16 C32,11.7565362 30.3142906,7.68687356 27.3137085,4.6862915 C24.3131264,1.68570945 20.2434638,2.5983722e-16 16,0 Z M11.1288889,22.2222222 L11.1288889,9.77777778 L23.6533333,16 L11.1288889,22.2222222 Z"
        })
    });
};
const $41efe20f21d8b288$export$c233dcaeaeace6e8 = (url)=>{
    const normalizedUrl = url.toLowerCase();
    if (normalizedUrl.includes('loom.com')) return 'loom';
    if (normalizedUrl.endsWith('.mp4') || normalizedUrl.includes('video/mp4')) return 'mp4';
    return 'youtube';
};
/**
 * Normalizes a Loom URL to its embed format.
 * Converts share URLs (loom.com/share/ID) to embed URLs (loom.com/embed/ID).
 */ const $41efe20f21d8b288$var$normalizeLoomUrl = (url)=>{
    return url.replace('/share/', '/embed/');
};
/**
 * Normalizes a YouTube URL to its embed format.
 */ const $41efe20f21d8b288$var$normalizeYoutubeUrl = (url)=>{
    return url.replace('youtu.be/', 'youtube.com/embed/').replace('watch?v=', 'embed/').replace('https://youtube.com', 'https://www.youtube.com');
};
const $41efe20f21d8b288$export$e71032fcfd2bdb71 = ({ embedUrl: embedUrl, title: title, thumbnail: thumbnail, dataEventProps: dataEventProps, videoType: videoType, autoPlay: autoPlay = false })=>{
    const [isPlaying, setIsPlaying] = (0, $1oC0p.useState)(autoPlay);
    const videoRef = (0, $1oC0p.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const resolvedVideoType = videoType ?? $41efe20f21d8b288$export$c233dcaeaeace6e8(embedUrl);
    const videoOverlayCss = null;
    const iFrameCss = null;
    const mp4VideoCss = null;
    const handleClick = (e)=>{
        e.preventDefault();
        setIsPlaying(true);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'embeddedVideoPlay',
            source: dataEventProps?.['data-event-container'] ?? 'embeddedVideo',
            attributes: {
                ...dataEventProps?.['data-product-key'] && {
                    productKey: dataEventProps['data-product-key']
                },
                ...dataEventProps?.['data-label'] && {
                    label: dataEventProps['data-label']
                },
                videoType: resolvedVideoType
            }
        }).fire();
    };
    // needs to be defined outside of css
    const bgImage = `url("${thumbnail?.src}")`;
    const intl = (0, $8e22h.default)();
    const renderPlayingContent = ()=>{
        switch(resolvedVideoType){
            case 'mp4':
                return /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
                    ref: videoRef,
                    src: embedUrl,
                    title: title,
                    controls: true,
                    autoPlay: true,
                    playsInline: true,
                    "aria-label": title ?? '',
                    className: (0, $2jatx.default)([
                        "_1e0c1ule _1h1tbb7n _1bsb1osq _4t3i1wug _bfhk1pfd"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("track", {
                            kind: "captions"
                        }),
                        intl.formatMessage({
                            id: 'embeddedVideo.videoNotSupported',
                            defaultMessage: 'Video not supported.'
                        })
                    ]
                });
            case 'youtube':
            default:
                {
                    const youtubeUrl = $41efe20f21d8b288$var$normalizeYoutubeUrl(embedUrl);
                    if (youtubeUrl.includes('iframe')) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: youtubeUrl
                        },
                        className: (0, $2jatx.default)([
                            "_digdyfq0 _11av1ule _1stxbb7n _i01y1osq _91ut1wug _mi22p5ev"
                        ])
                    });
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("iframe", {
                        width: "100%",
                        height: "auto",
                        src: `${youtubeUrl}${youtubeUrl.includes('?') ? '&' : '?'}autoplay=1`,
                        title: title,
                        allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; autoplay;",
                        allowFullScreen: true,
                        "data-gtm-yt-inspected-12": "true",
                        className: (0, $2jatx.default)([
                            "_s7n4yfq0 _1e0c1ule _1h1tbb7n _1bsb1osq _4t3i1wug _3y3kp5ev _19itglyw"
                        ])
                    });
                }
        }
    };
    if (resolvedVideoType === 'loom') {
        const loomUrl = $41efe20f21d8b288$var$normalizeLoomUrl(embedUrl);
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("iframe", {
                width: "100%",
                height: "auto",
                src: loomUrl,
                title: title,
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen",
                allowFullScreen: true,
                className: (0, $2jatx.default)([
                    "_s7n4yfq0 _1e0c1ule _1h1tbb7n _1bsb1osq _4t3i1wug _3y3kp5ev _19itglyw"
                ])
            })
        });
    }
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            !isPlaying && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1tke1osq _1bsb1osq _kqswh2mm _19itidpf _80omtlke _1e0c1txw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                    type: "button",
                    className: (0, $2jatx.default)([
                        "_1e0c1ule _1bsb1osq _1tke1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _80omtlke _ul7n1qgu _e6731y44 _8zzh1afi _12lu1vf8 _15l81afi _18y71vf8",
                        "play-trigger"
                    ]),
                    "aria-label": intl.formatMessage({
                        id: 'embeddedVideo.playTriggerButton.ariaLabel',
                        defaultMessage: 'Play Video'
                    }),
                    onClick: handleClick,
                    style: {
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                            className: (0, $2jatx.default)([
                                "_p12f1osq _1bsb1osq _4t3i1wug _8hrzaqso _t9ec1h7a _v5648pnm _1itk1n01 _1lrw1dfr _ouxl1ssb _bfhkygj1 _11q31n0t _s7n4yfq0 _lcxvglyw",
                                "video-thumbnail"
                            ]),
                            src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAABFJREFUKBVjYBgFoyFAhRAAAAJJAAFEkgypAAAAAElFTkSuQmCC',
                            alt: thumbnail?.alt ?? '',
                            style: {
                                "--_um3idz": (0, $6ZVlx.default)(bgImage)
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($41efe20f21d8b288$export$a6630b90defda83f, {})
                    ]
                })
            }),
            isPlaying && renderPlayingContent()
        ]
    });
};

});


parcelRegister("hrGO1", function(module, exports) {
$parcel$export(module.exports, "TRACKING_EVENT_NAMES", function () { return $37d29093f218a0c9$export$9a56b303ccc53008; });
$parcel$export(module.exports, "DEFAULT_COUNTRY_ISO_CODE", function () { return $37d29093f218a0c9$export$b1f75679747bdf24; });
$parcel$export(module.exports, "DEFAULT_CURRENCY_ISO_CODE", function () { return $37d29093f218a0c9$export$427ae666c2c86a64; });
$parcel$export(module.exports, "SpecialPlanNames", function () { return $37d29093f218a0c9$export$3f5e519890ec420; });
$parcel$export(module.exports, "CloudOfferingsWithSkus", function () { return $37d29093f218a0c9$export$49640008eae271a8; });
$parcel$export(module.exports, "SpecialProductKeys", function () { return $37d29093f218a0c9$export$9bb4a98475a54313; });
$parcel$export(module.exports, "DefaultPlanLimits", function () { return $37d29093f218a0c9$export$dcfb07a55b760b78; });
$parcel$export(module.exports, "PricingStrategy", function () { return $37d29093f218a0c9$export$d5367d5d99549333; });
$parcel$export(module.exports, "parsePricingStrategy", function () { return $37d29093f218a0c9$export$b136e5eb1cbda98a; });
$parcel$export(module.exports, "TRELLO_CTA_URL", function () { return $37d29093f218a0c9$export$3d9423ec9a4e8352; });
$parcel$export(module.exports, "SIGNUP_CTA_URL", function () { return $37d29093f218a0c9$export$3c460f2e36dca740; });
$parcel$export(module.exports, "CONTACT_CTA_URL", function () { return $37d29093f218a0c9$export$cee779d81c7e245b; });
$parcel$export(module.exports, "CtaBtnText", function () { return $37d29093f218a0c9$export$7f370599117a54aa; });
$parcel$export(module.exports, "Edition", function () { return $37d29093f218a0c9$export$6f4a0f769e61929; });
$parcel$export(module.exports, "PRICE_FINDER_CONTAINER", function () { return $37d29093f218a0c9$export$c5526af38120e3f; });
$parcel$export(module.exports, "COMPARE_FEATURES_CONTAINER", function () { return $37d29093f218a0c9$export$67b29c0af8205db6; });
const $37d29093f218a0c9$export$bd7123388de718a2 = {
    desktop: `@media (min-width: 1024px)`,
    tablet: `@media (max-width: 1023px)`,
    mobile: `@media (max-width: 768px)`,
    extraSmall: `@media (max-width: 360px)`
};
const $37d29093f218a0c9$export$9a56b303ccc53008 = {
    unitTierBox: 'pricing_page_unit_tier_box',
    unitDescriptionTooltipTriggered: 'unit-description-tooltip-triggered',
    billingCycleChanged: 'billing-cycle-changed',
    planCardCTAButtonClicked: 'edition-table-button-clicked',
    unitBreachModalDecision: 'unit-breach-modal-decision',
    unitLimitBreachModal: 'unit-limit-breach-modal',
    userTierTooltipTriggered: 'user-tier-tooltip-triggered',
    showPricingExampleTriggered: 'show-pricing-example-triggered',
    hidePricingExampleTriggered: 'hide-pricing-example-triggered',
    pricingExampleBillingCycleChanged: 'pricing-example-billing-cycle-changed',
    promoCardCTAButtonClicked: 'promo-card-button-clicked'
};
const $37d29093f218a0c9$export$803d5f8ee4072798 = {
    users: 'users',
    agents: 'agents'
};
const $37d29093f218a0c9$export$b1f75679747bdf24 = 'US';
const $37d29093f218a0c9$export$427ae666c2c86a64 = 'USD';
const $37d29093f218a0c9$export$3f5e519890ec420 = {
    FREE: 'Free',
    STARTER: 'Starter',
    STANDARD: 'Standard',
    PREMIUM: 'Premium',
    ENTERPRISE: 'Enterprise'
};
const $37d29093f218a0c9$export$c6264333cd6ce1a4 = {
    confluence: 'pricingplan.confluence.ondemand',
    jiraSoftware: 'jira-software.ondemand',
    jiraServiceDesk: 'jira-servicedesk.ondemand',
    jiraServiceManagement: 'jira-servicedesk.ondemand',
    bitbucket: 'com.atlassian.bitbucket.manual',
    atlassianGuard: 'com.atlassian.identity-manager',
    compass: 'compass.ondemand',
    jiraProductDiscovery: 'jira-product-discovery.ondemand',
    rovo: 'rovo',
    trello: 'trello',
    loom: 'loom',
    teamworkCollection: 'teamwork-collection',
    strategyCollection: 'strategy-collection'
};
const $37d29093f218a0c9$export$49640008eae271a8 = {
    confluence: 'confluence',
    jiraSoftware: 'jira-software',
    jiraServiceDesk: 'jira-servicedesk',
    jiraServiceManagement: 'jira-servicedesk',
    atlassianGuard: 'atlassian-access',
    compass: 'compass',
    jiraProductDiscovery: 'jira-product-discovery',
    rovo: 'rovo-org-purchase-sku',
    trello: 'trello',
    loom: 'loom'
};
const $37d29093f218a0c9$export$2766faac8d5287ee = {
    confluence: 'pricingplan.confluence-data-center',
    jiraSoftware: 'jira-software.data-center',
    jiraServiceDesk: 'jira-servicedesk.data-center',
    jiraServiceManagement: 'jira-servicedesk.data-center',
    bitbucket: 'pricingplan.stash-data-center'
};
const $37d29093f218a0c9$export$9bb4a98475a54313 = {
    JSM: 'jira-servicedesk.ondemand',
    BITBUCKET: 'com.atlassian.bitbucket.manual'
};
const $37d29093f218a0c9$export$dcfb07a55b760b78 = {
    UNIT_LIMIT_FREE: 10,
    UNIT_LIMIT: 150000,
    UNIT_MIN_ENTERPRISE: 801
};
const $37d29093f218a0c9$export$d5367d5d99549333 = {
    FIXED_COST: 'FIXED_COST',
    MARGINAL_PER_UNIT: 'MARGINAL_PER_UNIT',
    PER_UNIT: 'PER_UNIT'
};
function $37d29093f218a0c9$export$a97d19165664aecc(value) {
    switch(value){
        case $37d29093f218a0c9$export$d5367d5d99549333.FIXED_COST:
        case $37d29093f218a0c9$export$d5367d5d99549333.MARGINAL_PER_UNIT:
        case $37d29093f218a0c9$export$d5367d5d99549333.PER_UNIT:
            return true;
        default:
            return false;
    }
}
function $37d29093f218a0c9$export$b136e5eb1cbda98a(value) {
    if ($37d29093f218a0c9$export$a97d19165664aecc(value)) return value;
    else throw new SyntaxError(`${value} is not a valid PricingStrategy`);
}
const $37d29093f218a0c9$export$3d9423ec9a4e8352 = 'https://id.atlassian.com/signup?application=trello&continue=https%3A%2F%2Ftrello.com%2Fauth%2Fatlassian%2Fcallback%3Fdisplay%3DeyJ2ZXJpZmljYXRpb25TdHJhdGVneSI6InNvZnQifQ%253D%253D&display=eyJ2ZXJpZmljYXRpb25TdHJhdGVneSI6InNvZnQifQ%3D%3D';
const $37d29093f218a0c9$export$3c460f2e36dca740 = '/try/cloud/signup';
const $37d29093f218a0c9$export$cee779d81c7e245b = '/enterprise/contact?formType=pricing-quotes';
const $37d29093f218a0c9$export$7f370599117a54aa = {
    GET_IT_NOW: 'Get it now',
    START_FREE_TRIAL: 'Start free trial',
    CONTACT_SALES: 'Contact sales',
    JOIN_WAITLIST: 'Join waitlist'
};
const $37d29093f218a0c9$export$6f4a0f769e61929 = {
    FREE: 'free',
    STANDARD: 'standard',
    PREMIUM: 'premium',
    ENTERPRISE: 'enterprise'
};
const $37d29093f218a0c9$export$c2f12bc66b1c3231 = 67;
const $37d29093f218a0c9$export$e528a8f1399647be = 210;
const $37d29093f218a0c9$export$27ed77542911fb0e = 1024;
const $37d29093f218a0c9$export$c5526af38120e3f = 'priceBlock';
const $37d29093f218a0c9$export$67b29c0af8205db6 = 'priceFeaturesTable';

});

parcelRegister("lOlsU", function(module, exports) {
$parcel$export(module.exports, "useFirePricingPlanCtaEvent", function () { return $94595cb38e128ae6$export$7f90eaa475fc1c9f; });

var $fuLgT = parcelRequire("fuLgT");

var $eY3N6 = parcelRequire("eY3N6");
function $94595cb38e128ae6$export$7f90eaa475fc1c9f(props) {
    const { edition: edition, productKey: productKey, containerId: containerId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const createPayload = ()=>({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            containerId: containerId,
            actionSubjectId: 'pricingPlanCta',
            attributes: {
                migrationExperimentCta: true,
                pricingEventId: (0, $fuLgT.default)(),
                productKey: productKey,
                edition: edition
            }
        });
    return ()=>createAnalyticsEvent(createPayload()).fire();
}

});

parcelRegister("dkcYJ", function(module, exports) {
$parcel$export(module.exports, "ProductCatalogClient", function () { return $44efc64b5afbeaf3$export$103ea0adeef74210; });
$parcel$export(module.exports, "useCCPPriceFinderData", function () { return $44efc64b5afbeaf3$export$cd96e69292b0829; });
$parcel$export(module.exports, "useHAMSPriceData", function () { return $44efc64b5afbeaf3$export$487b53c25dfbddc8; });

var $1oC0p = parcelRequire("1oC0p");

var $hrGO1 = parcelRequire("hrGO1");

var $g7Jsj = parcelRequire("g7Jsj");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
var $44efc64b5afbeaf3$var$EDITION_SUFFIXES = /*#__PURE__*/ function(EDITION_SUFFIXES) {
    EDITION_SUFFIXES["FREE"] = ".free";
    EDITION_SUFFIXES["STANDARD"] = "";
    EDITION_SUFFIXES["PREMIUM"] = ".premium";
    EDITION_SUFFIXES["ENTERPRISE"] = ".enterprise";
    return EDITION_SUFFIXES;
}($44efc64b5afbeaf3$var$EDITION_SUFFIXES || {});
const $44efc64b5afbeaf3$var$NON_STANDARD_EDITION_SUFFIXES = [
    ".free",
    ".premium",
    ".enterprise"
];
class $44efc64b5afbeaf3$export$103ea0adeef74210 {
    constructor(accessToken, space, environment = 'master'){
        this.accessToken = accessToken;
        this.space = space;
        this.environment = environment;
    }
    getUrl() {
        return `https://cdn.contentful.com/spaces/${this.space}/environments/${this.environment}`;
    }
    async getEntries(queryParams) {
        const url = this.getUrl();
        const response = await fetch(`${url}/entries?access_token=${this.accessToken}&${queryParams}`);
        if (response.ok) return response.json();
        throw new (0, $g7Jsj.UnsuccessfulFetchError)({
            message: 'Unable to fetch prices',
            response: response
        });
    }
    /**
   *
   * @param key the `key` property of the HAMS Product
   * @returns Monthly prices for each headcount bucket for the free, standard and premium tiers
   */ //TODO: Update to accept CCP Offering Sku
    async getLocalizedPriceBlockPrices(key) {
        const pricingQuery = `content_type=product&select=fields.key%2Cfields.defaultStdPricingPlanMonthly%2Cfields.defaultPremiumPricingPlanMonthly%2Cfields.defaultFreePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanMonthly%2Csys.id%2Csys.type&fields.key%5Bin%5D=${key}&include=2`;
        const { includes: includes, items: items } = await this.getEntries(pricingQuery);
        if (!items.length) throw new Error('No pricing plans match this key');
        const parentPricingPlan = items[0];
        const freeMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultFreePricingPlanMonthly?.sys.id);
        const standardMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultStdPricingPlanMonthly?.sys.id);
        const premiumMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultPremiumPricingPlanMonthly?.sys.id);
        return {
            free: freeMonthly?.fields.configuration,
            standard: standardMonthly?.fields.configuration,
            premium: premiumMonthly?.fields.configuration
        };
    }
    async getLocalizedPriceBlockDropdown(key) {
        const pricingQuery = `content_type=product&select=fields.key%2Cfields.defaultStdPricingPlanMonthly%2Cfields.defaultStdPricingPlanYearly%2Cfields.defaultPremiumPricingPlanMonthly%2Cfields.defaultPremiumPricingPlanYearly%2Cfields.defaultFreePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanYearly%2Csys.id%2Csys.type&fields.key%5Bin%5D=${key}`;
        const { includes: includes, items: items } = await this.getEntries(pricingQuery);
        if (!items.length || !includes) throw new Error('No pricing plans match this key');
        const fields = includes.Entry[0]?.fields.configuration;
        return fields;
    }
    /**
   *
   * @param key the `key` property of the HAMS Product
   * @returns Monthly prices for each headcount bucket for the free, standard and premium tiers
   */ async getHAMSPrices(key) {
        const pricingQuery = `content_type=product&select=fields.key%2Cfields.defaultStdPricingPlanMonthly%2Cfields.defaultStdPricingPlanYearly%2Cfields.defaultPremiumPricingPlanMonthly%2Cfields.defaultPremiumPricingPlanYearly%2Cfields.defaultFreePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanYearly%2Csys.id%2Csys.type&fields.key%5Bin%5D=${key}`;
        const { includes: includes, items: items } = await this.getEntries(pricingQuery);
        if (!items.length) throw new Error(`No HAMS plans match this key: ${key}`);
        const productKeys = [
            key + ".free",
            key,
            key + ".premium",
            key + ".enterprise"
        ];
        const removeEditionSuffix = (productKey)=>productKey.replace(new RegExp($44efc64b5afbeaf3$var$NON_STANDARD_EDITION_SUFFIXES.map((suffix)=>`\\${suffix}`).join('|') + '$'), '');
        const getPricingPlansForEditionSuffixedKey = (editionSuffixedProductKey)=>{
            const matchedEditionSuffix = $44efc64b5afbeaf3$var$NON_STANDARD_EDITION_SUFFIXES.reduce((matchingEditionSuffix, editionSuffix)=>editionSuffixedProductKey.endsWith(editionSuffix) ? editionSuffix : matchingEditionSuffix, "");
            const parentPricingPlan = items[0];
            const freeMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultFreePricingPlanMonthly?.sys.id);
            const freeAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultFreePricingPlanYearly?.sys.id);
            const standardMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultStdPricingPlanMonthly?.sys.id);
            const premiumMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultPremiumPricingPlanMonthly?.sys.id);
            const enterpriseMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultEnterprisePricingPlanMonthly?.sys.id);
            const standardAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultStdPricingPlanYearly?.sys.id);
            const premiumAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultPremiumPricingPlanYearly?.sys.id);
            const enterpriseAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultEnterprisePricingPlanYearly?.sys.id);
            let monthly = undefined;
            let annual = undefined;
            switch(matchedEditionSuffix){
                case ".free":
                    monthly = freeMonthly?.fields.configuration;
                    annual = freeAnnual?.fields.configuration;
                    break;
                case "":
                    monthly = standardMonthly?.fields.configuration;
                    annual = standardAnnual?.fields.configuration;
                    break;
                case ".premium":
                    monthly = premiumMonthly?.fields.configuration;
                    annual = premiumAnnual?.fields.configuration;
                    break;
                case ".enterprise":
                    monthly = enterpriseMonthly?.fields.configuration;
                    annual = enterpriseAnnual?.fields.configuration;
                    break;
            }
            return {
                monthly: monthly?.map($44efc64b5afbeaf3$var$mapPricingPlanToPricingTier),
                annual: annual?.map($44efc64b5afbeaf3$var$mapPricingPlanToPricingTier)
            };
        };
        let ret = {};
        for (const productKey of productKeys){
            const editionlessKey = removeEditionSuffix(productKey);
            const entry = items.find(({ fields: { key: key } })=>key === editionlessKey);
            if (entry) ret = {
                ...ret,
                [productKey]: getPricingPlansForEditionSuffixedKey(productKey)
            };
        }
        return ret;
    }
    /**
   *
   * @param offeringSKUs the `key` property of the CCP Product
   * @returns A map of offeringSkus to their respective product plan content
   */ async getCCPPricingData(offeringSKUs) {
        const mappedOfferings = offeringSKUs.map((offeringSku, idx)=>{
            if (idx > 0) return `%2C${offeringSku}`;
            else return `=${offeringSku}`;
        }).join('');
        const ccpPricingDataQuery = `content_type=31uDFGQ9rMyZpBgP4oexja&fields.sku%5Bin%5D${mappedOfferings}`;
        const { items: items, includes: includes } = await this.getEntries(ccpPricingDataQuery);
        if (!items.length) throw new Error('No offerings match this key');
        const ret = {};
        // Match plans to their offering by offeringKey, not offeringName:
        // the name is just the edition label ("Standard", "Premium", …) and
        // is shared across products, so a name match pulls in every product's
        // plans for that edition when multiple products are fetched in one call.
        const matchPlansByOfferingKey = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp12437MatchPricingPlansByOfferingKey);
        for (const offeringSKU of offeringSKUs){
            const entry = items.find(({ fields: { sku: sku } })=>sku === offeringSKU);
            const contentfulOffering = entry?.fields;
            const pricingPlans = includes.Entry.map((includedEntry)=>{
                const isMatch = matchPlansByOfferingKey ? includedEntry.fields.offeringKey === contentfulOffering?.key : includedEntry.fields.offeringName === contentfulOffering?.name;
                if (isMatch) return includedEntry.fields;
                else return undefined;
            }).filter(Boolean);
            contentfulOffering?.defaultPricingPlans?.splice(0, contentfulOffering.defaultPricingPlans.length, ...pricingPlans);
            ret[offeringSKU] = contentfulOffering;
        }
        return ret;
    }
}
function $44efc64b5afbeaf3$export$cd96e69292b0829(offeringSKUs, accessToken, space, environment) {
    const offeringSKUsCount = offeringSKUs.length;
    const [status, setStatus] = (0, $1oC0p.useState)('idle');
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = (0, $1oC0p.useRef)(new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment)).current;
    const fetchData = (0, $1oC0p.useCallback)(async ()=>{
        if (offeringSKUsCount) {
            setStatus('fetching');
            const retrievedPrices = await client.getCCPPricingData(offeringSKUs);
            setPrices(retrievedPrices);
            setStatus('complete');
        } else {
            setStatus('complete');
            setPrices({});
        }
    }, [
        offeringSKUsCount
    ]);
    return {
        status: status,
        prices: prices,
        fetchData: fetchData
    };
}
function $44efc64b5afbeaf3$export$487b53c25dfbddc8(key, accessToken, space, environment) {
    const [status, setStatus] = (0, $1oC0p.useState)('idle');
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment);
    (0, $1oC0p.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus('fetching');
            const retrievedPrices = await client.getHAMSPrices(key);
            setPrices(retrievedPrices);
            setStatus('complete');
        };
        if (key) fetchData();
        else {
            setStatus('complete');
            setPrices({});
        }
    }, [
        key
    ]);
    return {
        status: status,
        prices: prices
    };
}
function $44efc64b5afbeaf3$export$cee963e0757fb89b(key, accessToken, space, environment) {
    const [status, setStatus] = (0, $1oC0p.useState)('idle');
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment);
    (0, $1oC0p.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus('fetching');
            const retrievedPrices = await client.getLocalizedPriceBlockPrices(key);
            setPrices(retrievedPrices);
            setStatus('complete');
        };
        fetchData();
    }, []);
    return {
        status: status,
        prices: prices
    };
}
//TODO: Do we need this? Can we just use the types already declared and reuse them?
function $44efc64b5afbeaf3$var$mapPricingPlanToPricingTier({ pricing_strategy: pricing_strategy, unit_description: unit_description, unit_limit_lower: unit_limit_lower, unit_limit_upper: unit_limit_upper, prices: prices }) {
    return {
        pricingStrategy: (0, $hrGO1.parsePricingStrategy)(pricing_strategy),
        unitDescription: unit_description,
        unitLimitLower: unit_limit_lower,
        unitLimitUpper: unit_limit_upper,
        prices: prices.map($44efc64b5afbeaf3$var$mapPricingPlanPricesItemPriceToPricingTierPrice)
    };
}
function $44efc64b5afbeaf3$var$mapPricingPlanPricesItemPriceToPricingTierPrice({ currency: currency, unit_price: unit_price }) {
    return {
        currency: currency,
        unitPrice: unit_price
    };
}
function $44efc64b5afbeaf3$export$9e1397dbc82e4578(key, accessToken, space, environment) {
    const [status, setStatus] = (0, $1oC0p.useState)('idle');
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment);
    (0, $1oC0p.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus('fetching');
            const retrievedPrices = await client.getLocalizedPriceBlockDropdown(key);
            setPrices(retrievedPrices);
            setStatus('complete');
        };
        fetchData();
    }, []);
    return {
        status: status,
        prices: prices
    };
}

});

parcelRegister("1RK9J", function(module, exports) {
$parcel$export(module.exports, "getFreePriceCalc", function () { return $9f9b50f36097439e$export$cb6f0dbb8c9b28d2; });
$parcel$export(module.exports, "usePriceFinderRequests", function () { return $9f9b50f36097439e$export$e1ef037d62746bfa; });
$parcel$export(module.exports, "usePricing", function () { return $9f9b50f36097439e$export$2bd1dff4b72a4894; });

var $1oC0p = parcelRequire("1oC0p");

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $69Lp1 = parcelRequire("69Lp1");

var $8dsKS = parcelRequire("8dsKS");
const $9f9b50f36097439e$export$cb6f0dbb8c9b28d2 = (currencyISOCode)=>{
    const zeroPrice = (0, $ieLA0.getFormattedPrice)(currencyISOCode, 0);
    return {
        totalPrice: 0,
        avgPerUnitPrice: 0,
        avgPerUnitPriceWithDiscount: 0,
        formattedTotalPrice: zeroPrice,
        formattedAvgPerUnitPrice: zeroPrice,
        formattedAvgPerUnitPriceWithDiscount: zeroPrice,
        formattedTotalPriceWithDiscount: zeroPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: 0,
                unitsAvailableInTier: 0,
                unitLimitLower: 0,
                unitLimitUpper: 0,
                totalPriceForTier: 0,
                avgPerUnitPriceForTier: 0
            }
        ],
        formattedBreakdown: [
            {
                formattedUnitsInTier: '0',
                formattedUnitsAvailableInTier: '0',
                formattedUnitLimitLower: '0',
                formattedUnitLimitUpper: '0',
                formattedTotalPriceForTier: zeroPrice,
                formattedAvgPerUnitPriceForTier: zeroPrice
            }
        ]
    };
};
const $9f9b50f36097439e$export$e1ef037d62746bfa = (productKey, productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    return (0, $1oC0p.useMemo)(()=>{
        const getNumUnits = (planName, signupUnitLimit)=>{
            let adjNumUnits = 0;
            // following scenarios do not have pricing and should send a zero unit count,
            // the zero pricing will not be displayed and is needed only to retain the
            // correct array order of the pricing requests/responses
            // Free plan has no pricing
            const isFree = planName === (0, $hrGO1.SpecialPlanNames).FREE;
            // Enterprise plans do not have monthly pricing
            const isMonthlyEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && billingCycle === 'MONTHLY';
            // Enterprise plans have a minimum unit count
            const isUnmetUnitCountEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
            const isOverSignupUnitLimit = unitCount > signupUnitLimit;
            if (![
                isFree,
                isMonthlyEnterprise,
                isUnmetUnitCountEnterprise,
                isOverSignupUnitLimit
            ].includes(true)) adjNumUnits = unitCount;
            // keep unit count to general maximum limit
            return Math.min(adjNumUnits, signupUnitLimit);
        };
        const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
                ccpOfferingSKU: offeringSku,
                hamsProductKey: productKey + (planName === (0, $hrGO1.SpecialPlanNames).STANDARD ? '' : `.${planName.toLowerCase()}`),
                numUnits: getNumUnits(planName, signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT),
                period: billingCycle
            }));
        return planPriceReqs;
    }, [
        productPlans,
        productKey,
        billingCycle,
        unitCount,
        unitMinEnterprise
    ]);
};
const $9f9b50f36097439e$export$2bd1dff4b72a4894 = (ccpPricingData, hamsPricingData, getPriceRequests, currencyISOCode, localeISOCode)=>{
    const priceCalculations = [];
    for (const { ccpOfferingSKU: ccpOfferingSKU, hamsProductKey: hamsProductKey, numUnits: numUnits, period: period } of getPriceRequests)if (numUnits === 0) priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
    else {
        const pricingTiers = (0, $69Lp1.extractPricingTiersFromEntry)(ccpPricingData, hamsPricingData, period, currencyISOCode, ccpOfferingSKU, hamsProductKey);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
        } else priceCalculations.push((0, $8dsKS.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
    return priceCalculations;
};

});
parcelRegister("ieLA0", function(module, exports) {
$parcel$export(module.exports, "getFormattedPrice", function () { return $db8d9502e3c15040$export$1b80ff309ec5fcb1; });
$parcel$export(module.exports, "getTwoDigitFormattedPrice", function () { return $db8d9502e3c15040$export$716b461c5fe22c57; });
$parcel$export(module.exports, "getFormattedUnitAmount", function () { return $db8d9502e3c15040$export$4f6f7f43804883a5; });
const $db8d9502e3c15040$export$93b318a4d10f1db1 = (value)=>{
    if (value !== null && value !== undefined && !Number.isNaN(value)) return Number.isInteger(+value) ? 0 : 2;
    else return 0;
};
const $db8d9502e3c15040$var$fmtCurrencyValue = (currencyISOCode, value, useTwoDigits)=>{
    const isJPY = currencyISOCode === 'JPY';
    const adjVal = isJPY ? Math.ceil(value || 0) : value;
    return new Intl.NumberFormat(isJPY ? 'ja-JP' : 'en-US', {
        style: 'currency',
        currency: currencyISOCode,
        // Note: JPY does not use decimals
        minimumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal),
        maximumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal)
    }).format(adjVal || 0);
};
const $db8d9502e3c15040$export$1b80ff309ec5fcb1 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, false);
const $db8d9502e3c15040$export$716b461c5fe22c57 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, true);
const $db8d9502e3c15040$export$4f6f7f43804883a5 = (localeISOCode, value)=>new Intl.NumberFormat(localeISOCode).format(value || 0);

});

parcelRegister("69Lp1", function(module, exports) {
$parcel$export(module.exports, "extractPricingTiersFromEntry", function () { return $eeff08f2d55148ea$export$99b3bd15b49bca3d; });

var $6AKYt = parcelRequire("6AKYt");
const $eeff08f2d55148ea$export$99b3bd15b49bca3d = (ccpOfferingsBySKU, hamsPricingPlansByKey, period, currencyISOCode, ccpOfferingSKU, hamsProductKey, getCcpTiers)=>{
    let pricingPlans;
    let pricingTiers;
    if (ccpOfferingSKU) {
        const offering = ccpOfferingsBySKU[ccpOfferingSKU];
        pricingPlans = offering?.defaultPricingPlans;
        if (!pricingPlans) {
            console.log(`Offering empty of pricing plan data for: ${ccpOfferingSKU}`);
            return undefined;
        }
        const convertedTiers = (0, $6AKYt.convertCCPPricingPlansToHAMS)(pricingPlans, currencyISOCode, getCcpTiers);
        if (period === 'MONTHLY' && convertedTiers.monthly) pricingTiers = convertedTiers.monthly.slice();
        else if (period === 'ANNUAL' && convertedTiers.annual) pricingTiers = convertedTiers.annual.slice();
        else {
            console.log(`Found neither monthly or annual pricing tiers for CCP Offering SKU: ${ccpOfferingSKU}`);
            return undefined;
        }
    } else {
        if (hamsProductKey === undefined) {
            console.log(`HAMS product key was undefined for price request!`);
            return undefined;
        }
        pricingPlans = hamsPricingPlansByKey[hamsProductKey];
        if (pricingPlans === undefined) {
            console.log(`No ${period} pricing plans found for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
        if (period === 'MONTHLY' && pricingPlans.monthly) pricingTiers = pricingPlans.monthly.slice();
        else if (period === 'ANNUAL' && pricingPlans.annual) pricingTiers = pricingPlans.annual.slice();
        else {
            console.log(`Found neither monthly or annual (period is ${period}) pricing tiers for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
    }
    return pricingTiers;
};

});
parcelRegister("6AKYt", function(module, exports) {
$parcel$export(module.exports, "convertCCPPricingPlansToHAMS", function () { return $ba494f9c4080e515$export$1fb00d50ed2ce89c; });

var $hrGO1 = parcelRequire("hrGO1");
// CCP Amounts are stored in cents - Note: JPY needs no conversion
const $ba494f9c4080e515$var$formatCentsToDollars = (value, currency)=>{
    if (currency === 'USD' && value) return value / 100;
    return value;
};
const $ba494f9c4080e515$var$convertCCPTiersToHAMS = (ccpTiers, chargeElement, currency)=>ccpTiers.map((ccpTier)=>{
        let pricingStrategy = (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT;
        let unitPrice = ccpTier.unitAmount;
        if (ccpTier.flatAmount) {
            pricingStrategy = (0, $hrGO1.PricingStrategy).FIXED_COST;
            unitPrice = ccpTier.flatAmount;
        }
        return {
            starter: false,
            pricingStrategy: pricingStrategy,
            unitDescription: chargeElement,
            unitLimitLower: ccpTier.floor,
            unitLimitUpper: ccpTier.ceiling,
            prices: [
                {
                    currency: currency,
                    unitPrice: $ba494f9c4080e515$var$formatCentsToDollars(unitPrice, currency)
                }
            ]
        };
    });
const $ba494f9c4080e515$export$1fb00d50ed2ce89c = (pricingPlans, currencyISOCode, getCcpTiers)=>{
    const [monthlyCCP, annualCCP] = [
        'MONTH',
        'YEAR'
    ].map((primaryCycle)=>// Per CCP Team: We need to filter by COMMERCIAL, DEFAULT_PRICING
        pricingPlans.find((pricingPlan)=>pricingPlan.primaryCycle_interval === primaryCycle && pricingPlan.type === 'COMMERCIAL' && pricingPlan.activatedWithReason === 'DEFAULT_PRICING' && // We filter by currencyISOCode as we need both USD & JPY Pricing for Pricing Pages
            // If needed, can filter by USD only which we will pass in directly in those components
            pricingPlan.currency === currencyISOCode));
    const [monthly, annual] = [
        monthlyCCP,
        annualCCP
    ].map((ccpContent)=>{
        if (!ccpContent) return undefined;
        const ccpTiers = getCcpTiers ? getCcpTiers(ccpContent) : ccpContent.items[0];
        const { tiers: tiers, chargeElement: chargeElement } = ccpTiers;
        return $ba494f9c4080e515$var$convertCCPTiersToHAMS(tiers, chargeElement, ccpContent.currency);
    });
    return {
        monthly: monthly,
        annual: annual
    };
};

});


parcelRegister("8dsKS", function(module, exports) {
$parcel$export(module.exports, "calculatePrice", function () { return $9c8fafac440a889f$export$8f857d3e1dbdf9cf; });

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $cuq2S = parcelRequire("cuq2S");

var $fmcUV = parcelRequire("fmcUV");
const $9c8fafac440a889f$var$getTierIdxForNumUnits = (numUnits, tiers)=>tiers.findIndex(({ unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper })=>numUnits >= (unitLimitLower || 0) && numUnits <= (unitLimitUpper || Math.pow(10, 1000)));
function $9c8fafac440a889f$export$8f857d3e1dbdf9cf(numUnits, tiers, currencyISOCode, period, localeISOCode = 'en-US') {
    if (!Number.isInteger(numUnits) || numUnits < 1) throw new Error(`Number of units must be a positive non-zero integer, got ${numUnits}.`);
    if (!tiers || tiers.length === 0) throw new Error(`Price tiers must not be null, undefined or an empty array, got ${tiers}.`);
    tiers.sort((a, b)=>{
        return (a.unitLimitLower ?? 0) - (b.unitLimitLower ?? 0);
    });
    let matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(numUnits, tiers);
    const matchingTier = tiers[matchingTierIdx];
    const finalTier = tiers[tiers.length - 1];
    let adjustedNumberOfUnits = numUnits;
    let calcFunc;
    if (matchingTier !== undefined) {
        const tierPricingStrategy = matchingTier.pricingStrategy;
        calcFunc = period === 'MONTHLY' || tierPricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT ? (0, $fmcUV.default) : (0, $cuq2S.default);
    } else if (finalTier && finalTier.pricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT) calcFunc = (0, $fmcUV.default);
    else {
        /*
     * When a user input is greater than the max tier limit
     * we will reset the number of users to max tier limit
     * of that product and perform price calculations.
     * */ adjustedNumberOfUnits = finalTier?.unitLimitUpper || 0;
        matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(adjustedNumberOfUnits, tiers);
        calcFunc = (0, $cuq2S.default);
    }
    const fmtUnit = (amount)=>(0, $ieLA0.getFormattedUnitAmount)(localeISOCode, amount);
    const fmtPrice = (price)=>(0, $ieLA0.getFormattedPrice)(currencyISOCode, price);
    const { totalPrice: totalPrice, avgPerUnitPrice: avgPerUnitPrice, hasFlatRateFirstTier: hasFlatRateFirstTier, breakdown: breakdown } = calcFunc(adjustedNumberOfUnits, matchingTierIdx, tiers, currencyISOCode);
    const avgPerUnitPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, avgPerUnitPrice);
    const totalPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, totalPrice);
    return {
        totalPrice: totalPrice,
        avgPerUnitPriceWithDiscount: avgPerUnitPriceWithDiscount,
        formattedTotalPrice: fmtPrice(totalPrice),
        formattedAvgPerUnitPriceWithDiscount: fmtPrice(avgPerUnitPriceWithDiscount),
        formattedTotalPriceWithDiscount: fmtPrice(totalPriceWithDiscount),
        avgPerUnitPrice: avgPerUnitPrice,
        formattedAvgPerUnitPrice: fmtPrice(avgPerUnitPrice),
        breakdown: breakdown,
        hasFlatRateFirstTier: hasFlatRateFirstTier,
        formattedBreakdown: breakdown.map(({ unitsInTier: unitsInTier, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsAvailableInTier: unitsAvailableInTier, totalPriceForTier: totalPriceForTier, avgPerUnitPriceForTier: avgPerUnitPriceForTier })=>({
                formattedUnitsInTier: fmtUnit(unitsInTier),
                formattedUnitsAvailableInTier: fmtUnit(unitsAvailableInTier),
                formattedUnitLimitLower: fmtUnit(unitLimitLower),
                formattedUnitLimitUpper: fmtUnit(unitLimitUpper),
                formattedTotalPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, totalPriceForTier),
                formattedAvgPerUnitPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, avgPerUnitPriceForTier)
            }))
    };
}

});
parcelRegister("cuq2S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20e5665ddc9d914c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "calculateDiscountedPrice", function () { return $20e5665ddc9d914c$export$3a875854e1248ca4; });

var $8q2jX = parcelRequire("8q2jX");
function $20e5665ddc9d914c$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    const matchingTier = tiers[matchingTierIdx];
    if (!matchingTier) throw new Error(`Matching price tier not found for ${numUnits}.`);
    const { prices: prices, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = matchingTier;
    const totalPrice = (0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices.slice());
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: numUnits,
                unitsAvailableInTier: (unitLimitUpper || 0) - numUnits,
                unitLimitLower: unitLimitLower || 1,
                unitLimitUpper: unitLimitUpper || 0,
                totalPriceForTier: totalPrice,
                avgPerUnitPriceForTier: totalPrice / numUnits
            }
        ]
    };
}
const $20e5665ddc9d914c$export$3a875854e1248ca4 = (discountRate, price)=>price * (1 - discountRate);

});
parcelRegister("8q2jX", function(module, exports) {
$parcel$export(module.exports, "getLocalUnitPrice", function () { return $032de19fb775a510$export$e4a3f0ac75d6f09; });
const $032de19fb775a510$export$e4a3f0ac75d6f09 = (currencyISOCode, prices)=>prices.find(({ currency: currency })=>currency === currencyISOCode)?.unitPrice || 0;

});


parcelRegister("fmcUV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e064390e0d1f8ae6$export$2e2bcd8739ae039; });

var $hrGO1 = parcelRequire("hrGO1");

var $8q2jX = parcelRequire("8q2jX");
function $e064390e0d1f8ae6$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    let totalPrice = 0;
    let price = 0;
    const breakdown = [];
    const getUnitPrice = (prices)=>(0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices);
    // if no matching tier then default to highest (last) tier
    if (matchingTierIdx === -1) matchingTierIdx = tiers.length - 1;
    let idx = 0;
    for (const tier of tiers){
        const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = tier;
        const adjUnitLimitLower = Math.max((unitLimitLower || 0) - 1, 0);
        // the upper unit limit can't be undefined so we can just set it to
        // one million units as an upper bound
        const adjUnitLimitUpper = unitLimitUpper || 1000000;
        const unitsInTier = idx === matchingTierIdx ? numUnits - adjUnitLimitLower : adjUnitLimitUpper - adjUnitLimitLower;
        if (tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST) price = getUnitPrice(tier.prices.slice());
        else {
            const finalTier = tiers[Math.min(idx, tiers.length - 1)];
            price = getUnitPrice(finalTier.prices.slice());
        }
        const totalPriceForTier = tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST ? price : unitsInTier * price;
        totalPrice += totalPriceForTier;
        breakdown.push({
            unitsInTier: unitsInTier,
            unitsAvailableInTier: adjUnitLimitUpper - unitsInTier,
            unitLimitLower: adjUnitLimitLower || 1,
            unitLimitUpper: adjUnitLimitUpper,
            totalPriceForTier: totalPriceForTier,
            avgPerUnitPriceForTier: price
        });
        if (++idx > matchingTierIdx) break;
    }
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: tiers[0]?.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST,
        breakdown: breakdown
    };
}

});



parcelRegister("cwszX", function(module, exports) {
$parcel$export(module.exports, "InfoIcon", function () { return $a32037f0fe1c069c$export$2957fc44b3d2481; });

var $7VQPk = parcelRequire("7VQPk");

var $3c7rQ = parcelRequire("3c7rQ");

var $kbpa7 = parcelRequire("kbpa7");
const $a32037f0fe1c069c$export$2957fc44b3d2481 = ({ size: size = 'small' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size === 'small' ? '14' : '22',
        height: size === 'small' ? '14' : '22',
        viewBox: "0 0 24 24",
        role: "presentation",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                    fill: (0, $kbpa7.wacToken)('color.primary.black'),
                    cx: "12",
                    cy: "12",
                    r: "10"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                    fill: (0, $3c7rQ.N0),
                    cx: "12",
                    cy: "18",
                    r: "1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M15.89 9.05a3.975 3.975 0 00-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 00.982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 014.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 00-1 .987v2.014a1.001 1.001 0 002.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0015.89 9.05",
                    fill: (0, $3c7rQ.N0)
                })
            ]
        })
    });

});

parcelRegister("6KUQg", function(module, exports) {
$parcel$export(module.exports, "AccountCreation", function () { return $42aa4ee4b4afed63$export$b841b541bc741e79; });

var $7VQPk = parcelRequire("7VQPk");

var $7u4F3 = parcelRequire("7u4F3");

var $cGEBM = parcelRequire("cGEBM");
const $42aa4ee4b4afed63$export$b841b541bc741e79 = ({ getContinueUrl: getContinueUrl, identityCobranding: identityCobranding, templateId: templateId, ...props })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cGEBM.AccountCreationContextProvider), {
        getContinueUrl: getContinueUrl,
        identityCobranding: identityCobranding,
        templateId: templateId,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7u4F3.Content), {
            ...props
        })
    });

});
parcelRegister("7u4F3", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $6cc2293976038b02$export$7c6e2c02157bb7d2; });

var $7VQPk = parcelRequire("7VQPk");

var $lX14w = parcelRequire("lX14w");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $cGEBM = parcelRequire("cGEBM");

var $mG5bv = parcelRequire("mG5bv");

var $irRyj = parcelRequire("irRyj");

var $lJMiD = parcelRequire("lJMiD");

var $4qMMD = parcelRequire("4qMMD");

var $32ARy = parcelRequire("32ARy");

var $l7G9R = parcelRequire("l7G9R");

var $8K1Jw = parcelRequire("8K1Jw");
const $6cc2293976038b02$export$7c6e2c02157bb7d2 = ({ Submit: Submit = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7G9R.Submit), {}), Input: Input = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $irRyj.Input), {}), Social: Social = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {}), Separator: Separator = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4qMMD.Separator), {}), Error: Error = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $mG5bv.Error), {}), Login: Login = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lJMiD.Login), {}), TermsAndConditions: TermsAndConditions })=>{
    const { onSubmit: onSubmit } = (0, $cGEBM.useAccountCreationContext)();
    if (TermsAndConditions === undefined && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).accountCreationTermsAndConditions)) TermsAndConditions = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8K1Jw.TermsAndConditions), {});
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                onSubmit: onSubmit,
                isDisabled: false,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                        ...formProps,
                        autoComplete: "off",
                        "data-testid": "account-creation",
                        children: [
                            Input,
                            TermsAndConditions,
                            Submit
                        ]
                    })
            }),
            Error,
            Separator,
            Social,
            Login
        ]
    });
};

});
parcelRegister("cGEBM", function(module, exports) {
$parcel$export(module.exports, "useAccountCreationContext", function () { return $835e146085c3a79b$export$30b295205cfae694; });
$parcel$export(module.exports, "AccountCreationContextProvider", function () { return $835e146085c3a79b$export$b0a1b3550379fc78; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $buVH1 = parcelRequire("buVH1");

var $fFzjl = parcelRequire("fFzjl");

var $gPKCY = parcelRequire("gPKCY");

var $gZgIU = parcelRequire("gZgIU");

var $gfjAv = parcelRequire("gfjAv");

var $7GVWk = parcelRequire("7GVWk");

var $hZy36 = parcelRequire("hZy36");

var $8bsd2 = parcelRequire("8bsd2");

var $1ka2O = parcelRequire("1ka2O");

var $iSeHD = parcelRequire("iSeHD");
const $835e146085c3a79b$export$52bc2238e0ff8657 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $835e146085c3a79b$export$30b295205cfae694 = ()=>{
    const context = (0, $1oC0p.useContext)($835e146085c3a79b$export$52bc2238e0ff8657);
    if (!context) throw new Error('useAccountCreationContext must be used within a AccountCreationContextProvider');
    return context;
};
const $835e146085c3a79b$export$b0a1b3550379fc78 = ({ getContinueUrl: getContinueUrl, identityCobranding: identityCobranding = 'wac', templateId: templateId, children: children })=>{
    const location = (0, $1ka2O.useLocation)();
    const isEmbedded = !location.pathname.endsWith('/try/cloud/signup');
    const { product: product, edition: edition } = (0, $7GVWk.useUserContext)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const [isEmailValid, setIsEmailValid] = (0, $1oC0p.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $1oC0p.useState)(false);
    const [isReadyForInvalid, setIsReadyForInvalid] = (0, $1oC0p.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $1oC0p.useState)(false);
    const [formError, setFormError] = (0, $1oC0p.useState)(false);
    const [typeAheadEmail, setTypeAheadEmail] = (0, $1oC0p.useState)('');
    const [tryIntentAnalyticsEventHasFired, setTryIntentAnalyticsEventHasFired] = (0, $1oC0p.useState)(false);
    const localePath = (0, $gZgIU.getLocalePath)(intl.locale);
    const continueParam = (0, $gZgIU.getContinueParam)(location);
    const dataFoundationsActionSubjectId = !!isEmbedded ? 'embedded' : 'standalone';
    // default experiment params
    if (product && identityCobranding === 'wac') {
        if (product.name === 'confluence') identityCobranding = 'wac--otp-confluence';
        else if (product.name === 'jira') identityCobranding = 'wac--otp-jira';
        else if (product.name === 'loom') identityCobranding = 'wac--loom';
        else if (product.name === 'jira-product-discovery') identityCobranding = 'wac--jpd';
        else if (product.name === 'jira-servicedesk') identityCobranding = 'wac--jsm';
        else if (product.name === 'service-collection') identityCobranding = 'wac--service-collection';
        else if (product.name === 'teamwork-collection') identityCobranding = 'wac--teamwork-collection';
    }
    const defaultContinueUrl = (0, $1oC0p.useCallback)(()=>continueParam ? continueParam : (0, $gZgIU.getNameYourSiteRedirectUrl)({
            bundle: product?.bundle,
            edition: edition,
            localePath: localePath,
            templateId: templateId,
            application: identityCobranding,
            isEmbedded: isEmbedded
        }), [
        continueParam,
        product,
        edition,
        localePath,
        templateId,
        identityCobranding
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!analyticsClient) return;
        (0, $buVH1.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            productKey: product?.key,
            edition: edition
        });
        (0, $gPKCY.ufoEventSignupFormLoad).success({
            customData: {
                webPlatform: 'bxp-ui',
                reactComponent: 'DefaultSignupForm',
                isLoggedIn: false
            }
        });
        (0, $buVH1.trackSignFormLoad)(createAnalyticsEvent);
        (0, $buVH1.trackTimeToFormReady)(createAnalyticsEvent, performance.now());
    }, [
        createAnalyticsEvent,
        edition,
        product?.key,
        dataFoundationsActionSubjectId,
        analyticsClient
    ]);
    const onSubmit = (0, $1oC0p.useCallback)(async ({ email: email })=>{
        setIsReadyForInvalid(true);
        if (!email || !isEmailValid) {
            (0, $buVH1.trackInvalidEmail)(createAnalyticsEvent);
            return;
        }
        (0, $buVH1.trackFormSubmit)(createAnalyticsEvent, product?.key, edition);
        setIsSubmitting(true);
        let continueUrl;
        if (getContinueUrl) continueUrl = getContinueUrl();
        if (!continueUrl) continueUrl = defaultContinueUrl();
        try {
            const castleToken = await (0, $hZy36.getCastleRequestToken)();
            // check identity interstitial redirect experiments for enrollment
            const url = (0, $gZgIU.getIdentityInterstitialUrl)(email, continueUrl, identityCobranding, castleToken);
            createAnalyticsEvent({
                eventType: 'ui',
                action: 'succeeded',
                actionSubject: 'accountCreationInterstitialRedirect',
                containerId: 'bxp-ui-signup',
                attributes: {
                    productKey: product?.key,
                    edition: edition
                }
            }).fire();
            (0, $8bsd2.trackCastleSignupAttempt)({
                href: url,
                email: email,
                productKey: product?.key
            });
            window.location.assign(url);
            return;
        } catch  {
            setHasSubmitted(true);
            setFormError(true);
            setIsSubmitting(false);
            createAnalyticsEvent({
                eventType: 'ui',
                action: 'errored',
                actionSubject: 'accountCreationInterstitialRedirect',
                containerId: 'bxp-ui-signup',
                attributes: {
                    productKey: product?.key,
                    edition: edition
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        defaultContinueUrl,
        edition,
        getContinueUrl,
        identityCobranding,
        isEmailValid,
        product
    ]);
    const onClickSocialButton = (provider)=>{
        (0, $buVH1.trackContinueWithSocialSignups)(createAnalyticsEvent, provider, product?.key, edition);
        let continueUrl;
        if (getContinueUrl) continueUrl = getContinueUrl();
        if (!continueUrl) continueUrl = defaultContinueUrl();
        const socialRedirectUrl = (0, $fFzjl.getSocialButtonUrl)({
            redirectTo: continueUrl,
            identityCobranding: identityCobranding,
            provider: provider
        });
        // Note: no Castle event here. Social signups don't go through the email
        // form, so we have no user-entered email to correlate against — and
        // Castle is only valuable with an email-to-fingerprint correlation.
        window.location.assign(socialRedirectUrl);
    };
    const onClickSubmitButton = ()=>(0, $buVH1.trackSubmitButtonClick)(createAnalyticsEvent);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($835e146085c3a79b$export$52bc2238e0ff8657.Provider, {
        value: {
            dataFoundationsActionSubjectId: dataFoundationsActionSubjectId,
            edition: edition,
            formError: formError,
            hasSubmitted: hasSubmitted,
            identityCobranding: identityCobranding,
            isReadyForInvalid: isReadyForInvalid,
            isSubmitting: isSubmitting,
            onClickSocialButton: onClickSocialButton,
            onClickSubmitButton: onClickSubmitButton,
            onSubmit: onSubmit,
            product: product,
            setIsEmailValid: setIsEmailValid,
            setIsReadyForInvalid: setIsReadyForInvalid,
            setTypeAheadEmail: setTypeAheadEmail,
            typeAheadEmail: typeAheadEmail,
            tryIntentAnalyticsEventHasFired: tryIntentAnalyticsEventHasFired
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
            edition: edition,
            intentType: "form",
            productKey: product?.key,
            onAnalyticsEventFired: ()=>!tryIntentAnalyticsEventHasFired && setTryIntentAnalyticsEventHasFired(true),
            children: children
        })
    });
};

});
parcelRegister("8bsd2", function(module, exports) {
$parcel$export(module.exports, "trackCastleSignupAttempt", function () { return $cc4df0ecef4c9b53$export$5b4bab8f0582c91c; });

var $hZy36 = parcelRequire("hZy36");
const $cc4df0ecef4c9b53$export$3aef6f37ef107ada = 'WAC Signup Attempted';
const $cc4df0ecef4c9b53$var$MAX_PATH_SEGMENT_LENGTH = 48;
const $cc4df0ecef4c9b53$var$SAFE_QUERY_PARAM_NAMES = new Set([
    'bundle',
    'edition',
    'product',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term'
]);
const $cc4df0ecef4c9b53$var$getUrl = (href)=>{
    try {
        return new URL(href, window.location.origin);
    } catch  {
        return undefined;
    }
};
const $cc4df0ecef4c9b53$var$getSafeSearchParams = (url)=>{
    const safe = new URLSearchParams();
    url.searchParams.forEach((value, name)=>{
        if ($cc4df0ecef4c9b53$var$SAFE_QUERY_PARAM_NAMES.has(name)) safe.append(name, value);
    });
    return safe.toString();
};
const $cc4df0ecef4c9b53$var$sanitizePathSegment = (segment)=>{
    if (segment.length > $cc4df0ecef4c9b53$var$MAX_PATH_SEGMENT_LENGTH) return '[redacted]';
    return segment;
};
const $cc4df0ecef4c9b53$var$getSanitizedPath = (pathname)=>{
    return pathname.split('/').map((segment)=>$cc4df0ecef4c9b53$var$sanitizePathSegment(segment)).join('/');
};
const $cc4df0ecef4c9b53$var$getSanitizedHref = (url)=>{
    const safeParams = $cc4df0ecef4c9b53$var$getSafeSearchParams(url);
    const safePath = $cc4df0ecef4c9b53$var$getSanitizedPath(url.pathname);
    const base = `${url.origin}${safePath}`;
    return safeParams ? `${base}?${safeParams}` : base;
};
const $cc4df0ecef4c9b53$var$getSanitizedPagePath = ()=>$cc4df0ecef4c9b53$var$getSanitizedPath(window.location.pathname);
const $cc4df0ecef4c9b53$export$5b4bab8f0582c91c = ({ href: href, email: email, productKey: productKey })=>{
    const url = $cc4df0ecef4c9b53$var$getUrl(href);
    if (!url) return;
    (0, $hZy36.sendCastleCustomEvent)({
        name: $cc4df0ecef4c9b53$export$3aef6f37ef107ada,
        properties: {
            wac_href: $cc4df0ecef4c9b53$var$getSanitizedHref(url),
            wac_pagePath: $cc4df0ecef4c9b53$var$getSanitizedPagePath(),
            wac_eventType: 'signup',
            ...productKey ? {
                wac_productKey: productKey
            } : {}
        },
        email: email
    });
};

});


parcelRegister("mG5bv", function(module, exports) {
$parcel$export(module.exports, "Error", function () { return $d2f561c370fddce6$export$edf27be85e5f6da0; });
/* error.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $cGEBM = parcelRequire("cGEBM");

var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");
const $d2f561c370fddce6$export$edf27be85e5f6da0 = ({ errorText: errorText })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8e22h.default)();
    const { formError: formError } = (0, $cGEBM.useAccountCreationContext)();
    if (!formError) return null;
    if (errorText === undefined) errorText = locale === 'en' // temporary fix until translation is available
     ? formatMessage({
        id: 'AccountCreation.userSignupError',
        defaultMessage: `It's taking longer than expected to get you started. Please refresh and try again or <contactUsLink>contact us</contactUsLink>.`
    }, {
        contactUsLink: $d2f561c370fddce6$var$contactUsLink
    }) : formatMessage({
        id: 'BxpUiSignup.SignupForm.formError',
        defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>."
    }, {
        contactUsLink: $d2f561c370fddce6$var$contactUsLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        role: "alert",
        className: (0, $2jatx.default)([
            "_syaz1cjc _19pk1j6v _2hwxidpf _otyr1j6v _18u0idpf _3fcw150s"
        ]),
        children: errorText
    });
};
const $d2f561c370fddce6$var$contactUsLink = (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: "/company/contact",
        className: "linkText"
    });
const $d2f561c370fddce6$var$errorCss = null;

});

parcelRegister("irRyj", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return $5190fd2e8a96a930$export$f5b8910cec6cf069; });
/* input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $gM7M2 = parcelRequire("gM7M2");

var $iTHVN = parcelRequire("iTHVN");

var $bNzAT = parcelRequire("bNzAT");

var $eOIix = parcelRequire("eOIix");

var $cGEBM = parcelRequire("cGEBM");

var $6nMZs = parcelRequire("6nMZs");
const $5190fd2e8a96a930$var$HELP_TEXT_ID = 'account_creation_email_help_text';
const $5190fd2e8a96a930$export$f5b8910cec6cf069 = ({ helpText: helpText, errorMessageText: errorMessageText, labelText: labelText, placeholderText: placeholderText })=>{
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, typeAheadEmail: typeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const [email, setEmail] = (0, $1oC0p.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $1oC0p.useState)();
    const intl = (0, $8e22h.default)();
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    if (helpText === undefined) helpText = intl.formatMessage({
        id: 'signupForm.accountCreation.helperText',
        defaultMessage: 'Using a work email helps find teammates and boost collaboration.'
    });
    if (errorMessageText === undefined) errorMessageText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.invalidEmail',
        defaultMessage: 'Please enter a valid email address.'
    });
    if (labelText === undefined) labelText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.workEmail',
        defaultMessage: 'Work email'
    });
    if (placeholderText === undefined) placeholderText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.emailPlaceholder',
        defaultMessage: 'you@company.com'
    });
    (0, $1oC0p.useEffect)(()=>{
        const isValid = (0, $gM7M2.emailIsValid)(email);
        // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_6rth7vkz _1rwquftu _1heu1kw7 _125x1syg _62vcmccc _1d6jidpf _1t2q1kw7 _17rn1kw7 _1q9pbfng _d78pglyw _1osle4h9 _tx14t94y _1bjadkaa _kj1xidpf",
            isDarkTheme && "_1mi9rttd _1rwqrttd _psgk1afi _1t2q1afi"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md),
            "--_1mehvmr": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark200'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            label: labelText,
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_7hwb183y",
                        isValid === true && "_olzhaf4m _1osldkaa _tx14idpf",
                        isValid === false && "_olzh1wfy _1osldkaa _tx14idpf"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                            ...fieldProps,
                            autoComplete: "email",
                            "aria-describedby": $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            elemAfterInput: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6nMZs.InputIcon), {
                                valid: isValid
                            }),
                            onBlur: ()=>setIsReadyForInvalid(true),
                            onChange: (e)=>{
                                setEmail(e.target.value);
                                setTypeAheadEmail(e.target.value);
                                fieldProps.onChange(e);
                            },
                            placeholder: placeholderText,
                            testId: "email_field",
                            type: "email",
                            value: email
                        }),
                        isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            role: "alert",
                            className: (0, $2jatx.default)([
                                "_syaz1tmw _1wybepq8 _vwz4bs82 _1pfhi2wt",
                                isDarkTheme && "_syaz1366"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                            },
                            children: errorMessageText
                        }) : helpText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            className: (0, $2jatx.default)([
                                "_1wybepq8 _vwz4bs82 _syazl3em _1pfhi2wt"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                            },
                            children: helpText
                        }) : null
                    ]
                })
        })
    });
};
const $5190fd2e8a96a930$var$errorMessageCss = null;
const $5190fd2e8a96a930$var$darkThemeErrorMessageCss = null;
const $5190fd2e8a96a930$var$helpTextCss = null;
const $5190fd2e8a96a930$var$fieldCss = null;
const $5190fd2e8a96a930$var$darkThemeFieldCss = null;
const $5190fd2e8a96a930$var$inputCss = null;
const $5190fd2e8a96a930$var$inputInvalidCss = null;
const $5190fd2e8a96a930$var$inputValidCss = null;

});
parcelRegister("6nMZs", function(module, exports) {
$parcel$export(module.exports, "InputIcon", function () { return $f28bd5fc1ae39550$export$f8fea9f50a4bfae6; });
/* input-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $hrBjL = parcelRequire("hrBjL");

var $5J9KJ = parcelRequire("5J9KJ");

var $iTHVN = parcelRequire("iTHVN");

var $kbpa7 = parcelRequire("kbpa7");
const $f28bd5fc1ae39550$export$f8fea9f50a4bfae6 = ({ valid: valid })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const validMessage = formatMessage({
        id: 'signupForm.accountCreation.validEmailIcon',
        defaultMessage: 'Success'
    });
    const invalidMessage = formatMessage({
        id: 'signupForm.accountCreation.invalidEmailIconError',
        defaultMessage: 'Error'
    });
    if (valid === undefined) return null;
    return valid ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _lswu1afi _1wyb1syg _y4ti19bv _w8l5gktf _1752gktf",
            "_syaz81oq"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md),
            "--_12jscdq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime600'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hrBjL))), {
            label: validMessage
        })
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _lswu1afi _1wyb1syg _y4ti19bv _w8l5gktf _1752gktf",
            "_syaz1bqt"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5J9KJ))), {
            label: invalidMessage
        })
    });
};
const $f28bd5fc1ae39550$var$iconWrapperCss = null;
const $f28bd5fc1ae39550$var$iconValidCss = null;
const $f28bd5fc1ae39550$var$iconInvalidCss = null;

});


parcelRegister("lJMiD", function(module, exports) {
$parcel$export(module.exports, "Login", function () { return $50db90a6da99c80d$export$21a94553ffa41578; });
/* login.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $iTHVN = parcelRequire("iTHVN");

var $gZgIU = parcelRequire("gZgIU");

var $iPPTB = parcelRequire("iPPTB");

var $1ka2O = parcelRequire("1ka2O");

var $cGEBM = parcelRequire("cGEBM");
const $50db90a6da99c80d$export$21a94553ffa41578 = ({ loginText: loginText })=>{
    const intl = (0, $8e22h.default)();
    const location = (0, $1ka2O.useLocation)();
    const { product: product } = (0, $cGEBM.useAccountCreationContext)();
    if (loginText === undefined) loginText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.existingProduct',
        defaultMessage: 'Already have {product}? <logInLink>Log in</logInLink>'
    }, {
        product: product?.description,
        logInLink: (text)=>$50db90a6da99c80d$var$logInLink(text, location)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_1wyb8oy7 _19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1h6o"
        ]),
        style: {
            "--_djwknj": (0, $6ZVlx.default)((0, $iTHVN.fontSize).sm)
        },
        children: loginText
    });
};
const $50db90a6da99c80d$var$logInLink = (text, location)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: (0, $gZgIU.getLoginUrl)(location)
    });
const $50db90a6da99c80d$var$existingProductCss = null;

});

parcelRegister("32ARy", function(module, exports) {
$parcel$export(module.exports, "Social", function () { return $4e2e5c1067955974$export$9a0fadb2797ac9a5; });
/* social.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jUqeL = parcelRequire("jUqeL");

var $lHKk6 = parcelRequire("lHKk6");

var $cGEBM = parcelRequire("cGEBM");

var $8e22h = parcelRequire("8e22h");
const $4e2e5c1067955974$export$9a0fadb2797ac9a5 = ({ providers: providers })=>{
    const intl = (0, $8e22h.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $cGEBM.useAccountCreationContext)();
    if (providers === undefined) providers = {
        google: 'Google',
        microsoft: 'Microsoft',
        apple: 'Apple',
        slack: 'Slack'
    };
    const buttons = Object.entries(providers);
    // when there are 3 buttons, we display in a single row and visually hide the text labels
    const rowStyle = buttons.length === 3;
    /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        role: "list",
        className: (0, $2jatx.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            buttons.length > 1 && !rowStyle && "_1e0c11p5 _zulp7vkz _yv0efsjm",
            rowStyle && "_1e0c11p5 _zulp7vkz _wij21bp4"
        ]),
        children: buttons.map(([provider, label])=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lHKk6.LogoButton), {
                    "aria-label": intl.formatMessage({
                        id: 'social.label.signup',
                        defaultMessage: 'sign up with {provider}'
                    }, {
                        provider: label
                    }),
                    onClick: ()=>onClickSocialButton(provider),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jUqeL.ProviderLogo), {
                            logo: provider
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                rowStyle && "_kqswstnw _1e021cib _152t1wug _1bsbt94y _4t3it94y _1reo15vq _18m915vq _ogtohxbz _o5721q9c"
                            ]),
                            children: label
                        })
                    ]
                })
            }, provider))
    });
};
const $4e2e5c1067955974$var$buttonGridCss = null;
const $4e2e5c1067955974$var$buttonListCss = null;
const $4e2e5c1067955974$var$buttonRowCss = null;
const $4e2e5c1067955974$var$srOnlyCss = null;

});

parcelRegister("l7G9R", function(module, exports) {
$parcel$export(module.exports, "Submit", function () { return $9e3c42c7c44204a7$export$2c4cf1f7b42ef78c; });
/* submit.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $cGEBM = parcelRequire("cGEBM");
const $9e3c42c7c44204a7$export$2c4cf1f7b42ef78c = ({ buttonText: buttonText })=>{
    const intl = (0, $8e22h.default)();
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $cGEBM.useAccountCreationContext)();
    if (buttonText === undefined) buttonText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.submit',
        defaultMessage: 'Sign up'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: onClickSubmitButton,
        className: (0, $2jatx.default)([
            "_ect41kw7 _1wyb7vkz _p12f1wug _1rjcftgi _1bsb1osq"
        ]),
        children: buttonText
    });
};
const $9e3c42c7c44204a7$var$buttonCss = null;

});

parcelRegister("8K1Jw", function(module, exports) {
$parcel$export(module.exports, "TermsAndConditions", function () { return $44792323d2da14c0$export$71c56c718a357b5; });
/* terms-and-conditions.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");
const $44792323d2da14c0$export$71c56c718a357b5 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        "data-testid": "terms-and-conditions",
        className: (0, $2jatx.default)([
            "_1wyboqnp _vwz41k92 _1mou1j6v"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.SignupForm.termsAndConditions",
            defaultMessage: "I agree to the <termsOfServiceLink>Atlassian Customer Agreement</termsOfServiceLink>, which incorporates by reference the <aiTermsLink>AI Product-Specific Terms</aiTermsLink>, and acknowledge the <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.",
            values: {
                termsOfServiceLink: $44792323d2da14c0$var$TermsOfServiceLink,
                aiTermsLink: $44792323d2da14c0$var$AiTermsLink,
                privacyPolicyLink: $44792323d2da14c0$var$PrivacyPolicyLink
            }
        })
    });
const $44792323d2da14c0$var$AiTermsLink = (text)=>{
    const aiTermsLinkHref = (0, $jQ0cd.useLocalizedHref)('/legal/product-specific-terms#atlassian-intelligence-specific-terms');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        "aria-label": text,
        href: aiTermsLinkHref,
        text: text,
        type: "inline"
    });
};
const $44792323d2da14c0$var$PrivacyPolicyLink = (text)=>{
    const privacyPolicyLinkHref = (0, $jQ0cd.useLocalizedHref)('/legal/privacy-policy#what-this-policy-covers');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        "aria-label": text,
        href: privacyPolicyLinkHref,
        text: text,
        type: "inline"
    });
};
const $44792323d2da14c0$var$TermsOfServiceLink = (text)=>{
    const termsOfServiceLinkHref = (0, $jQ0cd.useLocalizedHref)('/legal/cloud-terms-of-service');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        "aria-label": text,
        href: termsOfServiceLinkHref,
        text: text,
        type: "inline"
    });
};
const $44792323d2da14c0$var$termsAndConditionsCss = null;

});



parcelRegister("dEFIL", function(module, exports) {
$parcel$export(module.exports, "EnhancedBannerAlert", function () { return $41ab4e6d9e0b9eaf$export$e2bb4f4abc9a31da; });
/* enhanced-banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $1rGpC = parcelRequire("1rGpC");

var $dE0sS = parcelRequire("dE0sS");

var $jsxHL = parcelRequire("jsxHL");

var $2gCne = parcelRequire("2gCne");
const $41ab4e6d9e0b9eaf$export$e2bb4f4abc9a31da = (bannerInfo)=>{
    const bannerStorageItem = `BannerAlert_dismiss-${bannerInfo.identifier}`;
    const closeIconDataEventProps = {
        'data-product-key': bannerInfo.productKey,
        'data-event-component': 'button',
        'data-event-container': 'announcementBanner',
        'data-event': 'clicked',
        'data-label': 'Close',
        'data-label-english': 'Close'
    };
    const [isHidden, setIsHidden] = (0, $1oC0p.useState)(true);
    const mobileClass = bannerInfo.mobileTextThirdScreen ? 'three-screen' : 'two-screen';
    (0, $1oC0p.useEffect)(()=>{
        const dismissValue = (0, $2gCne.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== '1') setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    let mobileProps = bannerInfo.imageProps;
    if (bannerInfo.imageMobileProps && bannerInfo.imageMobileProps.src) mobileProps = bannerInfo.imageMobileProps;
    const bannerBgPreset = bannerInfo.backgroundPreset ? `bg-${bannerInfo.backgroundPreset}` : `bg-none`;
    const bannerType = bannerInfo.bannerType ? `banner-type-${bannerInfo.bannerType}` : 'banner-type-default';
    const bgLinkColor = bannerInfo.backgroundPreset === 'gwp-5090-banners' ? 'bgBlackBlue' : 'bgWhite';
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_bfhk1bjw _kqswh2mm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1pbykb7n _85i5yh40 _189eh5ge _1dqonqa1 _5pioemm7 _nzmgglyw _1auo1lef _21w0idpf _15641crf _s4s5idpf _1qlo1crf _7j8l1lk2 _jw2n1wug _1yvc1wug _19z9gktf _nue91vuk _1lrfidpf _pytjidpf _smywidpf _4tf1idpf _1dkqidpf _1i8zidpf _1twsidpf _c7u0idpf _1u1bu5k9 _1876mq8p _gsz9mgnk _evayglyw _lhr7161t _1cmq12iu _88w11afi _5vmz1ejb _3kek1ejb _190eni2e _wb1217a9 _vb1gvgh6 _1at2oyge _49yzdf70 _cfy01ule _18901k92 _1aavidpf _72q2idpf _11sc1y44 _i4q0idpf _n8ff1cby _qho21j28 _1w7d1pfd _sqps1bjw _iawm1pfd _abydglyw _6c4a1afi _udn3glyw _2fl2idpf _1kn81afi _1vxm1afi _1maf1afi _waep1afi _1y8x1afi _1ur01afi _ojfc1afi _1yaa1afi _11zs1afi _1s051afi _6rr71bjw _fsy11bjw _sx881bjw _1s7h1bjw _1gud1afi _1m8a1afi _1lcv1afi _v05m1afi _lkhdni7l _pu49ni7l _162fni7l _19ycni7l _102q1hbo _2utfmgnk _1vm51dlf _1e74altx _1o3a1izt _1blmu4dp _1si213i1 _1k051ms4 _1yip1f51 _6zpp1f51 _eyt5xchc _nxj7u58z _7w4f1afi _xfs2idpf _17esg7ng _lfur1dgx _1t0kmgnk _ejrwidpf _1m4lanty _7ax8uuw1 _1ww71tcg _cfnoftgi _ogm61et3 _ve7k1ule _1mt7kfja _76j711ux _1dxgidpf _1i4jt1wm _ne8lqiko _1it7ys9h _umq2mgvx _16471dnu _1uhmmr2s _6cysidpf _yo8p1tcg _17pqqslr _ti1kp3fh _onmtn7od",
                `${bannerBgPreset} ${bannerType}`
            ]),
            "data-dismissed": isHidden ? 'true' : undefined,
            "data-testid": "banner-alert-container",
            style: {
                ...bannerInfo.customCSS,
                "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
                "--_1z9q1i": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.purple500')),
                "--_1hcckvk": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue900')),
                "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700')),
                "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red')),
                "--_td2gmy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.saffron')),
                "--_ci5h4w": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.green')),
                "--_5p9fny": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.lime')),
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1rjcpxbi _1e0c1txw _2lx2vrvc _zulpzwfg _kqswh2mm _6rth12gs _sugaglyw",
                                    "desktop-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _4cvr1h6o"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                            image: {
                                                width: 209,
                                                ...bannerInfo.imageProps
                                            },
                                            style: {
                                                maxWidth: '100%',
                                                height: 'auto'
                                            },
                                            forceEagerLoad: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_191wqgqc _4t3i1osq _sugaglyw",
                                            "line"
                                        ]),
                                        style: {
                                            "--_1e97w25": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light700'))
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1bsb1osq _1e0c1txw _2lx2vrvc _1bah1yb4 _4cvr1h6o _zulpzwfg _na0i1bp4 _dh1a1y6m _2osn14y2 _ag851h6o _10ca1q9c"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                    "body-md"
                                                ]),
                                                children: bannerInfo.text
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                bgColor: bgLinkColor,
                                                text: bannerInfo.linkText,
                                                "aria-label": bannerInfo.linkText,
                                                href: bannerInfo.linkUrl,
                                                type: "primary",
                                                dataEventProps: bannerInfo.dataEventProps
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1rjcpxbi _1e0cglyw _2lx21bp4 _4cvr1h6o _suga1txw",
                                    "mobile-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _p12f1osq _18zr7vkz"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow34q126 _ezr91onc _17k81cg0 _18shrjc5 _1h6z1ule",
                                                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                        image: {
                                                            width: 180,
                                                            ...mobileProps
                                                        },
                                                        style: {
                                                            maxWidth: '100%',
                                                            height: 'auto'
                                                        },
                                                        forceEagerLoad: true
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow34q126 _ezr91onc _17k81cg0 _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju25i11n",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileText
                                                })
                                            }),
                                            bannerInfo.mobileTextThirdScreen && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow34q126 _ezr91onc _17k81cg0 _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju251onc",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileTextThirdScreen
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                        bgColor: bgLinkColor,
                                        text: bannerInfo.linkText,
                                        "aria-label": bannerInfo.linkText,
                                        href: bannerInfo.linkUrl,
                                        type: "primary",
                                        dataEventProps: bannerInfo.dataEventProps
                                    })
                                ]
                            })
                        ]
                    })
                }),
                bannerInfo.bannerType !== 'lifted' && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    className: (0, $2jatx.default)([
                        "_19itidpf _r06hglyw _bfhk1j28 _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _1pbykb7n _rjxpidpf _19pk7vkz _2hwx7vkz _otyr7vkz _18u07vkz",
                        `close-button-symbol`
                    ]),
                    "data-testid": "close-button",
                    "aria-label": "Close",
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $2gCne.setLocalStorage)(bannerStorageItem, '1');
                    },
                    ...closeIconDataEventProps,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dE0sS.Cross), {
                        size: "24"
                    })
                })
            ]
        })
    });
};
const $41ab4e6d9e0b9eaf$var$scrollUpTwoScreens = null;
const $41ab4e6d9e0b9eaf$var$scrollUpThreeScreens = null;
const $41ab4e6d9e0b9eaf$var$desktopContainerStyles = null;
const $41ab4e6d9e0b9eaf$var$mobileContainerStyles = null;
const $41ab4e6d9e0b9eaf$var$desktopLogoStyles = null;
const $41ab4e6d9e0b9eaf$var$marqueeContainerStyles = null;
const $41ab4e6d9e0b9eaf$var$marqueeItemStyle = null;
const $41ab4e6d9e0b9eaf$var$marqueeItem1Styles = null;
const $41ab4e6d9e0b9eaf$var$marqueeItem2Styles = null;
const $41ab4e6d9e0b9eaf$var$marqueeItem3Styles = null;
const $41ab4e6d9e0b9eaf$var$containerStyles = null;
const $41ab4e6d9e0b9eaf$var$contentStyles = null;
const $41ab4e6d9e0b9eaf$var$pStyle = null;
const $41ab4e6d9e0b9eaf$var$lineStyle = null;
const $41ab4e6d9e0b9eaf$var$closeStyles = null;

});

parcelRegister("aTHox", function(module, exports) {
$parcel$export(module.exports, "BITBUCKET_DEFAULT_BILLING_CYCLE", function () { return $4c3894076c255a40$export$6e78cb64dcbedbb9; });
$parcel$export(module.exports, "BITBUCKET_DEFAULT_UNIT_COUNT", function () { return $4c3894076c255a40$export$36a5806a0e4fc360; });
$parcel$export(module.exports, "BITBUCKET_MIN_ENTERPRISE_USER_COUNT", function () { return $4c3894076c255a40$export$2b15976b7672c2da; });
$parcel$export(module.exports, "bitbucketOfferingSkus", function () { return $4c3894076c255a40$export$eeb88db779daf862; });
$parcel$export(module.exports, "BITBUCKET_SIGNUP_LIMIT", function () { return $4c3894076c255a40$export$4d264dc26702f23b; });
$parcel$export(module.exports, "bitbucketOfferingSkusArray", function () { return $4c3894076c255a40$export$9a2735659d85fd7c; });
$parcel$export(module.exports, "bitbucketPlanLimitConfigs", function () { return $4c3894076c255a40$export$66d05a9262b43b7f; });
$parcel$export(module.exports, "bitbucketBillingCycleConfig", function () { return $4c3894076c255a40$export$f9cab01559b23739; });
const $4c3894076c255a40$export$6e78cb64dcbedbb9 = 'MONTHLY';
const $4c3894076c255a40$export$36a5806a0e4fc360 = 5;
const $4c3894076c255a40$export$2b15976b7672c2da = 201;
const $4c3894076c255a40$export$eeb88db779daf862 = {
    free: 'bitbucket-test-free',
    standard: 'bitbucket-std',
    premium: 'bitbucket-premium'
};
const $4c3894076c255a40$export$4d264dc26702f23b = 35000;
const $4c3894076c255a40$export$9a2735659d85fd7c = Object.values($4c3894076c255a40$export$eeb88db779daf862);
const $4c3894076c255a40$export$66d05a9262b43b7f = [
    {
        planName: 'Free',
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.free,
        recommendationLimit: 0,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    },
    {
        planName: 'Standard',
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.standard,
        recommendationLimit: 5,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    },
    {
        planName: 'Premium',
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.premium,
        recommendationLimit: 100,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    }
];
const $4c3894076c255a40$export$f9cab01559b23739 = {
    monthly: true,
    annual: false
};

});

parcelRegister("29JVp", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_BILLING_CYCLE", function () { return $1e226e69d394223a$export$d60dc2d142b5e9dd; });
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_UNIT_COUNT", function () { return $1e226e69d394223a$export$ab3750ec8101ffcc; });
$parcel$export(module.exports, "CONFLUENCE_MIN_ENTERPRISE_USER_COUNT", function () { return $1e226e69d394223a$export$f76a76b996ace375; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return $1e226e69d394223a$export$ffe6d3f38b5f7c3a; });
$parcel$export(module.exports, "confluenceOfferingSkusArray", function () { return $1e226e69d394223a$export$39e8fbae2abd0443; });
$parcel$export(module.exports, "confluencePlanLimitConfigs", function () { return $1e226e69d394223a$export$53fbba6eb29a73ad; });
$parcel$export(module.exports, "confluenceBillingCycleConfig", function () { return $1e226e69d394223a$export$e8f1610e98745fd7; });
const $1e226e69d394223a$export$d60dc2d142b5e9dd = 'MONTHLY';
const $1e226e69d394223a$export$ab3750ec8101ffcc = 300;
const $1e226e69d394223a$export$f76a76b996ace375 = 801;
const $1e226e69d394223a$export$ffe6d3f38b5f7c3a = {
    free: 'confluence-free',
    standard: 'confluence-standard',
    premium: 'confluence-premium',
    enterprise: 'confluence-enterprise-sku'
};
const $1e226e69d394223a$export$39e8fbae2abd0443 = Object.values($1e226e69d394223a$export$ffe6d3f38b5f7c3a);
const $1e226e69d394223a$export$53fbba6eb29a73ad = [
    {
        planName: 'Free',
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.free,
        recommendationLimit: 0,
        signupLimit: 250000
    },
    {
        planName: 'Standard',
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.standard,
        recommendationLimit: 10,
        signupLimit: 250000
    },
    {
        planName: 'Premium',
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.premium,
        recommendationLimit: 250,
        signupLimit: 250000
    },
    {
        planName: 'Enterprise',
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.enterprise,
        recommendationLimit: 5000,
        signupLimit: 250000,
        minUnitCount: $1e226e69d394223a$export$f76a76b996ace375
    }
];
const $1e226e69d394223a$export$e8f1610e98745fd7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("j1ORI", function(module, exports) {
$parcel$export(module.exports, "JIRA_DEFAULT_BILLING_CYCLE", function () { return $2a2b2c5bc611aa86$export$c34e5566df36b6ba; });
$parcel$export(module.exports, "JIRA_DEFAULT_UNIT_COUNT", function () { return $2a2b2c5bc611aa86$export$6521a918e64524fb; });
$parcel$export(module.exports, "JIRA_MIN_ENTERPRISE_USER_COUNT", function () { return $2a2b2c5bc611aa86$export$9aef50cd5f48bb38; });
$parcel$export(module.exports, "jiraOfferingSkus", function () { return $2a2b2c5bc611aa86$export$7529f2cfeec98447; });
$parcel$export(module.exports, "jiraOfferingSkusArray", function () { return $2a2b2c5bc611aa86$export$b2b09200ca76754f; });
$parcel$export(module.exports, "jiraPlanLimitConfigs", function () { return $2a2b2c5bc611aa86$export$3070b86c7bc28aea; });
$parcel$export(module.exports, "jiraBillingCycleConfig", function () { return $2a2b2c5bc611aa86$export$7a133a10c706882b; });
const $2a2b2c5bc611aa86$export$c34e5566df36b6ba = 'MONTHLY';
const $2a2b2c5bc611aa86$export$6521a918e64524fb = 300;
const $2a2b2c5bc611aa86$export$9aef50cd5f48bb38 = 801;
const $2a2b2c5bc611aa86$export$7529f2cfeec98447 = {
    free: 'jira-software-free',
    standard: 'jira-software-standard',
    premium: 'jira-software-premium',
    enterprise: 'jira-software-enterprise-sku'
};
const $2a2b2c5bc611aa86$export$b2b09200ca76754f = Object.values($2a2b2c5bc611aa86$export$7529f2cfeec98447);
const $2a2b2c5bc611aa86$export$3070b86c7bc28aea = [
    {
        planName: 'Free',
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.free,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: 'Standard',
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.standard,
        recommendationLimit: 10,
        signupLimit: 100000
    },
    {
        planName: 'Premium',
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.premium,
        recommendationLimit: 250,
        signupLimit: 100000
    },
    {
        planName: 'Enterprise',
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $2a2b2c5bc611aa86$export$9aef50cd5f48bb38
    }
];
const $2a2b2c5bc611aa86$export$7a133a10c706882b = {
    monthly: true,
    annual: true
};

});

parcelRegister("lc7EO", function(module, exports) {
$parcel$export(module.exports, "JPD_DEFAULT_BILLING_CYCLE", function () { return $a2567840a72a8d9f$export$513f99bdcd3bd2; });
$parcel$export(module.exports, "JPD_DEFAULT_UNIT_COUNT", function () { return $a2567840a72a8d9f$export$503245d941330408; });
$parcel$export(module.exports, "JPD_MIN_ENTERPRISE_USER_COUNT", function () { return $a2567840a72a8d9f$export$4ebabaf17c585254; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return $a2567840a72a8d9f$export$400db592c8d58797; });
$parcel$export(module.exports, "jpdBillingCycleConfig", function () { return $a2567840a72a8d9f$export$370b1f24abd91670; });
$parcel$export(module.exports, "jpdPlanLimitConfigs", function () { return $a2567840a72a8d9f$export$886e6b42d7675517; });
$parcel$export(module.exports, "jpdOfferingSkusArray", function () { return $a2567840a72a8d9f$export$cf1798af40f51188; });
$parcel$export(module.exports, "useJpdPlanLimitConfigs", function () { return $a2567840a72a8d9f$export$489f0bd45c02b5f3; });
$parcel$export(module.exports, "useJpdPlanTitlesAllowList", function () { return $a2567840a72a8d9f$export$74aab5e5781ecaa8; });
$parcel$export(module.exports, "stripJpdHighlightedFeatures", function () { return $a2567840a72a8d9f$export$7f3e0ab07e999189; });
$parcel$export(module.exports, "useShouldStripJpdHighlightedFeatures", function () { return $a2567840a72a8d9f$export$5b64204eb3ad795a; });

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $a2567840a72a8d9f$export$513f99bdcd3bd2 = 'MONTHLY';
const $a2567840a72a8d9f$export$503245d941330408 = 10;
const $a2567840a72a8d9f$export$4ebabaf17c585254 = 201;
const $a2567840a72a8d9f$export$400db592c8d58797 = {
    free: 'jira-servicedesk-free',
    // jpd-free shares the same sku as jsm-free
    standard: 'jira-product-discovery-standard',
    premium: 'jira-product-discovery-premium-sku',
    enterprise: 'jira-product-discovery-enterprise'
};
const $a2567840a72a8d9f$export$370b1f24abd91670 = {
    monthly: true,
    annual: true
};
const $a2567840a72a8d9f$var$JPD_FREE_PLAN_LIMIT_CONFIG = {
    planName: 'Free',
    offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.free,
    recommendationLimit: 0,
    signupLimit: 20000
};
const $a2567840a72a8d9f$var$JPD_STANDARD_PLAN_LIMIT_CONFIG = {
    planName: 'Standard',
    offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.standard,
    recommendationLimit: 3,
    signupLimit: 20000
};
const $a2567840a72a8d9f$var$JPD_PREMIUM_PLAN_LIMIT_CONFIG = {
    planName: 'Premium',
    offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.premium,
    recommendationLimit: 50,
    signupLimit: 20000
};
const $a2567840a72a8d9f$var$JPD_ENTERPRISE_PLAN_LIMIT_CONFIG = {
    planName: 'Enterprise',
    offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.enterprise,
    recommendationLimit: 250,
    signupLimit: 20000,
    minUnitCount: $a2567840a72a8d9f$export$4ebabaf17c585254
};
const $a2567840a72a8d9f$export$33b06374587a97d9 = ()=>{
    return (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10907JpdEnterpriseSku);
};
const $a2567840a72a8d9f$export$886e6b42d7675517 = ()=>{
    const isEnterpriseSkuEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10907JpdEnterpriseSku);
    const base = [
        $a2567840a72a8d9f$var$JPD_FREE_PLAN_LIMIT_CONFIG,
        $a2567840a72a8d9f$var$JPD_STANDARD_PLAN_LIMIT_CONFIG,
        $a2567840a72a8d9f$var$JPD_PREMIUM_PLAN_LIMIT_CONFIG
    ];
    return isEnterpriseSkuEnabled ? [
        ...base,
        $a2567840a72a8d9f$var$JPD_ENTERPRISE_PLAN_LIMIT_CONFIG
    ] : base;
};
const $a2567840a72a8d9f$export$cf1798af40f51188 = ()=>$a2567840a72a8d9f$export$886e6b42d7675517().map((config)=>config.offeringSku);
const $a2567840a72a8d9f$export$489f0bd45c02b5f3 = ()=>{
    return $a2567840a72a8d9f$export$886e6b42d7675517();
};
const $a2567840a72a8d9f$export$3dbf1d01fece31ca = ()=>{
    return $a2567840a72a8d9f$export$489f0bd45c02b5f3().map((config)=>config.offeringSku);
};
const $a2567840a72a8d9f$export$74aab5e5781ecaa8 = ()=>{
    return $a2567840a72a8d9f$export$489f0bd45c02b5f3().map((config)=>config.planName);
};
const $a2567840a72a8d9f$export$89d0322d6cc3b745 = ()=>{
    return $a2567840a72a8d9f$export$33b06374587a97d9();
};
const $a2567840a72a8d9f$export$7f3e0ab07e999189 = (plans)=>plans.map((plan)=>({
            ...plan,
            fields: {
                ...plan.fields,
                highlightedFeaturesContainer: undefined,
                highlightedFeaturesTitle: undefined
            }
        }));
const $a2567840a72a8d9f$export$5b64204eb3ad795a = (urlSlug)=>{
    const shouldShow = $a2567840a72a8d9f$export$89d0322d6cc3b745();
    return urlSlug === 'product-discovery' && !shouldShow;
};

});

parcelRegister("9Nmuw", function(module, exports) {
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_BILLING_CYCLE", function () { return $5113a0e17f25a106$export$f7b45b42f23a06a6; });
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_UNIT_COUNT", function () { return $5113a0e17f25a106$export$c80f45e98f559c29; });
$parcel$export(module.exports, "ROVO_DEV_MIN_ENTERPRISE_USER_COUNT", function () { return $5113a0e17f25a106$export$5cdb7bb84622bb8e; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return $5113a0e17f25a106$export$6a8477cfea6a8fb8; });
$parcel$export(module.exports, "rovoDevOfferingSkusArray", function () { return $5113a0e17f25a106$export$69f1beff4f684452; });
$parcel$export(module.exports, "rovoDevPlanLimitConfigs", function () { return $5113a0e17f25a106$export$93aaa2531823d54e; });
$parcel$export(module.exports, "rovoDevBillingCycleConfig", function () { return $5113a0e17f25a106$export$120b0272a23f9b21; });
const $5113a0e17f25a106$export$f7b45b42f23a06a6 = 'MONTHLY';
const $5113a0e17f25a106$export$c80f45e98f559c29 = 10;
const $5113a0e17f25a106$export$5cdb7bb84622bb8e = Infinity;
const $5113a0e17f25a106$export$6a8477cfea6a8fb8 = {
    standard: 'rovodev-standard'
};
const $5113a0e17f25a106$export$69f1beff4f684452 = Object.values($5113a0e17f25a106$export$6a8477cfea6a8fb8);
const $5113a0e17f25a106$export$93aaa2531823d54e = [
    {
        planName: 'Standard',
        offeringSku: $5113a0e17f25a106$export$6a8477cfea6a8fb8.standard,
        recommendationLimit: Infinity,
        signupLimit: Infinity,
        minUnitCount: $5113a0e17f25a106$export$5cdb7bb84622bb8e
    }
];
const $5113a0e17f25a106$export$120b0272a23f9b21 = {
    monthly: false,
    annual: false
};

});

parcelRegister("fEBe5", function(module, exports) {
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $6246fc483000f258$export$9423de11a8a6dfa7; });
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $6246fc483000f258$export$515fa2affea780b3; });
$parcel$export(module.exports, "SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $6246fc483000f258$export$3df704b75c4818f2; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return $6246fc483000f258$export$84b191ede7d628ea; });
$parcel$export(module.exports, "serviceCollectionOfferingSkusArray", function () { return $6246fc483000f258$export$953539e2774d6323; });
$parcel$export(module.exports, "serviceCollectionPlanLimitConfigs", function () { return $6246fc483000f258$export$29e5f53cb4f38894; });
$parcel$export(module.exports, "serviceCollectionBillingCycleConfig", function () { return $6246fc483000f258$export$7c96cfb0c18bfb05; });
const $6246fc483000f258$export$9423de11a8a6dfa7 = 'MONTHLY';
const $6246fc483000f258$export$515fa2affea780b3 = 75;
const $6246fc483000f258$export$3df704b75c4818f2 = 201;
const $6246fc483000f258$export$84b191ede7d628ea = {
    free: 'service-collection-free',
    standard: 'service-collection-standard',
    premium: 'service-collection-premium',
    enterprise: 'service-collection-enterprise'
};
const $6246fc483000f258$export$953539e2774d6323 = Object.values($6246fc483000f258$export$84b191ede7d628ea);
const $6246fc483000f258$export$29e5f53cb4f38894 = [
    {
        planName: 'Free',
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.free,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: 'Standard',
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.standard,
        recommendationLimit: 3,
        signupLimit: 100000
    },
    {
        planName: 'Premium',
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.premium,
        recommendationLimit: 50,
        signupLimit: 100000
    },
    {
        planName: 'Enterprise',
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.enterprise,
        recommendationLimit: 250,
        signupLimit: 100000,
        minUnitCount: $6246fc483000f258$export$3df704b75c4818f2
    }
];
const $6246fc483000f258$export$7c96cfb0c18bfb05 = {
    monthly: true,
    annual: true
};

});

parcelRegister("YmHME", function(module, exports) {
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $bf49a3d87bcf04a1$export$5784a04bb778d3c1; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $bf49a3d87bcf04a1$export$482604a575f7b4a5; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return $bf49a3d87bcf04a1$export$2e2107bfa20be1d8; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkusArray", function () { return $bf49a3d87bcf04a1$export$b61ab2c6a18de6d4; });
$parcel$export(module.exports, "teamworkCollectionPlanLimitConfigs", function () { return $bf49a3d87bcf04a1$export$88bcddbae46dd5f1; });
$parcel$export(module.exports, "teamworkCollectionBillingCycleConfig", function () { return $bf49a3d87bcf04a1$export$5861c5ce06e1556; });
const $bf49a3d87bcf04a1$export$5784a04bb778d3c1 = 'MONTHLY';
const $bf49a3d87bcf04a1$export$482604a575f7b4a5 = 300;
const $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2 = 801;
const $bf49a3d87bcf04a1$export$2e2107bfa20be1d8 = {
    free: 'teamwork-collection-free-sku',
    standard: 'teamwork-collection-standard-sku',
    premium: 'teamwork-collection-premium-sku',
    enterprise: 'teamwork-collection-enterprise-sku'
};
const $bf49a3d87bcf04a1$export$b61ab2c6a18de6d4 = Object.values($bf49a3d87bcf04a1$export$2e2107bfa20be1d8);
const $bf49a3d87bcf04a1$export$88bcddbae46dd5f1 = [
    {
        planName: 'Free',
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.free,
        recommendationLimit: 0,
        signupLimit: 10
    },
    {
        planName: 'Standard',
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.standard,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: 'Premium',
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.premium,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: 'Enterprise',
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2
    }
];
const $bf49a3d87bcf04a1$export$5861c5ce06e1556 = {
    monthly: true,
    annual: true
};

});

parcelRegister("e0LCf", function(module, exports) {
$parcel$export(module.exports, "CollectionPricingHero", function () { return $2a773e3b9098f7a0$export$8065869e82d5a4c7; });
/* collection-pricing-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $8A3gV = parcelRequire("8A3gV");
const $2a773e3b9098f7a0$var$horizontalOrientationCss = null;
const $2a773e3b9098f7a0$var$verticalOrientationCss = null;
const $2a773e3b9098f7a0$var$logoCss = null;
const $2a773e3b9098f7a0$var$verticalLogoCss = null;
const $2a773e3b9098f7a0$export$8065869e82d5a4c7 = (props)=>{
    const orientation = props.orientation || 'horizontal';
    const messages = (0, $8A3gV.useCollectionPricingHeroMessages)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1f2ygktf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1ns9 _p12fuoas"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulppxbi _1yt417la _1lp7vrvc _19wgxy5q _6yttgfpe"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: props.collectionImage.src,
                                    alt: props.collectionImage.alt,
                                    height: props.collectionImage.height,
                                    width: props.collectionImage.width
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _zulp1crf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_ect4z4z1 _1wyb19bv _k48p1nn1 _1p1dangw _syaz1qc2 _vwz47vkz _y3gn1h6o _uj6k18uv"
                                    ]),
                                    style: {
                                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                        "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                                    },
                                    children: messages.includes
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        orientation === 'horizontal' ? "_1e0c11p5 _yv0efsjm _2z05im57 _zulpxy5q _gy1pxy5q _1p57pxbi _ect41vau _k48p1nn1 _1wyb1wbj" : "_1e0c1txw _2lx21bp4 _zulppxbi"
                                    ]),
                                    style: {
                                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                    },
                                    children: props.products.map((product, key)=>{
                                        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                orientation === 'horizontal' ? "_1e0c1txw _4cvr1h6o _zulp12x7 _1bsb1n5l" : "_1e0c1txw _4cvr1h6o _4t3igktf"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                    image: {
                                                        src: product.image.src,
                                                        alt: product.image.alt
                                                    },
                                                    className: (0, $2jatx.default)([
                                                        "_y4ti1xn6"
                                                    ]),
                                                    style: {
                                                        height: '20px',
                                                        "--_1tc2js6": (0, $6ZVlx.default)(orientation === 'vertical' ? "var(--ds-space-075, 6px)" : 0)
                                                    }
                                                }),
                                                product.name
                                            ]
                                        }, key);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _mqm21hma"
                    ]),
                    style: {
                        "--_1hwkv7u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark1100'))
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_syaz1pfd _1e0c1ule _y3gn1h6o _ect4z4z1 _1wyb7vkz _zg8l4jg8 _k48p1fw0 _vwz41ou6 _1yt4zu5n"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                            },
                            children: messages.heading
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bah1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1n261g80 _1bah1h6o _zulpu2gc _19wgpxbi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/k383m26br4w8fu6i68s0qbnym881f0wb.svg",
                                        name: messages.home,
                                        alt: messages.home
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/r7k15161ensv07cht48h87c31ueh7sh3.svg",
                                        name: messages.goals,
                                        alt: messages.goals
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/51ht267g50ve2d3051aw8nrgs0k11ad6.svg",
                                        name: messages.teams,
                                        alt: messages.teams
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2pqaabre17cu7mx66ydvhplnbt4hh3ub.svg",
                                        name: messages.studio,
                                        alt: messages.studio
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/to7s6r4xr4564x6jhc134qhgevi13wo3.svg",
                                        name: messages.search,
                                        alt: messages.search
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/pe661ex05dvkmxul5nf4fi1e20hq8063.svg",
                                        name: messages.chat,
                                        alt: messages.chat
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8f6ta76fw1d04u40k8fp622i67154764.svg",
                                        name: messages.analytics,
                                        alt: messages.analytics
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/dv817l8n01hct543cmd030ksu3hfj0k6.svg",
                                        name: messages.admin,
                                        alt: messages.admin
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $2a773e3b9098f7a0$var$Subproduct = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1b66 _1ul91l27 _1yt41giy"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkrdoj _2hwxrdoj _otyrrdoj _18u0rdoj _4t3igktf _1bsbgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: props.src,
                            alt: props.alt
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect4z4z1 _1wybsm30 _zg8l4jg8 _k48p1nn1 _vwz41crf"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                },
                children: props.name
            })
        ]
    });
};

});
parcelRegister("8A3gV", function(module, exports) {
$parcel$export(module.exports, "useCollectionPricingHeroMessages", function () { return $6e2ac6bb4e232ff3$export$7c226aa081048b2; });

var $8e22h = parcelRequire("8e22h");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
function $6e2ac6bb4e232ff3$export$7c226aa081048b2() {
    const intl = (0, $8e22h.default)();
    const hardcoded = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp8279CollectionHeroIntl);
    if (hardcoded) return $6e2ac6bb4e232ff3$export$22298271baa6ded9(intl.locale);
    return {
        heading: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.platformAppsHeading',
            defaultMessage: 'Plus all Atlassian Platform Apps'
        }),
        includes: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.includes',
            defaultMessage: 'Includes'
        }),
        home: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.home.alt',
            defaultMessage: 'Home'
        }),
        goals: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.goals',
            defaultMessage: 'Goals'
        }),
        teams: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.teams',
            defaultMessage: 'Teams'
        }),
        studio: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.studio',
            defaultMessage: 'Studio'
        }),
        search: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.search',
            defaultMessage: 'Search'
        }),
        chat: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.chat',
            defaultMessage: 'Chat'
        }),
        analytics: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.analytics',
            defaultMessage: 'Analytics'
        }),
        admin: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.admin',
            defaultMessage: 'Admin'
        })
    };
}
function $6e2ac6bb4e232ff3$export$22298271baa6ded9(locale) {
    return $6e2ac6bb4e232ff3$var$MESSAGES[locale] ?? $6e2ac6bb4e232ff3$var$enMessages;
}
const $6e2ac6bb4e232ff3$var$enMessages = {
    home: 'Home',
    heading: 'Plus all Atlassian Platform Apps',
    includes: 'Includes',
    goals: 'Goals',
    teams: 'Teams',
    studio: 'Studio',
    search: 'Search',
    chat: 'Chat',
    analytics: 'Analytics',
    admin: 'Admin'
};
const $6e2ac6bb4e232ff3$var$MESSAGES = {
    en: $6e2ac6bb4e232ff3$var$enMessages,
    nl: {
        home: 'Home',
        heading: 'Plus alle Atlassian Platform-apps',
        includes: 'Omvat',
        goals: 'Doelstellingen',
        teams: 'Teams',
        studio: 'Studio',
        search: 'Zoeken',
        chat: 'Chat',
        analytics: 'Analyses',
        admin: 'Beheerder'
    },
    es: {
        home: 'Inicio',
        heading: "Adem\xe1s de todas las aplicaciones de la plataforma de Atlassian",
        includes: 'Incluye',
        goals: 'Objetivos',
        teams: 'Equipos',
        studio: 'Studio',
        search: 'Buscar',
        chat: 'Chat',
        analytics: "An\xe1lisis",
        admin: 'Administrativo'
    },
    ru: {
        home: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
        heading: "\u0410 \u0442\u0430\u043A\u0436\u0435 \u0432\u0441\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B Atlassian",
        includes: "\u0412\u043A\u043B\u044E\u0447\u0430\u0435\u0442",
        goals: "\u0426\u0435\u043B\u0438",
        teams: "\u041A\u043E\u043C\u0430\u043D\u0434\u044B",
        studio: "\u041C\u0430\u0441\u0442\u0435\u0440\u0441\u043A\u0430\u044F",
        search: "\u041F\u043E\u0438\u0441\u043A",
        chat: "\u0427\u0430\u0442",
        analytics: "\u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0430",
        admin: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440"
    },
    fr: {
        home: 'Accueil',
        heading: 'Et toutes les apps de la plateforme Atlassian',
        includes: "Fonctionnalit\xe9s incluses",
        goals: 'Objectifs',
        teams: "\xc9quipes",
        studio: 'Studio',
        search: 'Recherche',
        chat: 'Chat',
        analytics: 'Analyses',
        admin: 'Administrateur'
    },
    ko: {
        home: "\uD648",
        heading: "\uBC0F \uBAA8\uB4E0 Atlassian \uD50C\uB7AB\uD3FC \uC571",
        includes: "\uD3EC\uD568 \uC0AC\uD56D",
        goals: "\uBAA9\uD45C",
        teams: "\uD300",
        studio: "\uC2A4\uD29C\uB514\uC624",
        search: "\uAC80\uC0C9",
        chat: "\uCC44\uD305",
        analytics: "\uBD84\uC11D",
        admin: "\uAD00\uB9AC\uC790"
    },
    br: {
        home: "In\xedcio",
        heading: "Al\xe9m de todos os apps da plataforma Atlassian",
        includes: 'Inclui',
        goals: 'Metas',
        teams: 'Equipes',
        studio: 'Studio',
        search: 'Pesquisar',
        chat: 'Bate-papo',
        analytics: "Dados de An\xe1lise",
        admin: 'Admin'
    },
    pl: {
        home: "Strona g\u0142\xf3wna",
        heading: 'Plus wszystkie aplikacje platformy Atlassian',
        includes: 'Obejmuje',
        goals: 'Cele',
        teams: "Zespo\u0142y",
        studio: 'Studio',
        search: 'Wyszukiwanie',
        chat: 'Czat',
        analytics: 'Analizy',
        admin: 'Administrator'
    },
    de: {
        home: 'Home',
        heading: 'Plus alle Apps der Atlassian-Plattform',
        includes: 'Beinhaltet',
        goals: 'Ziele',
        teams: 'Teams',
        studio: 'Studio',
        search: 'Suchen',
        chat: 'Chat',
        analytics: 'Analysen',
        admin: 'Administrator'
    },
    zh: {
        home: "\u9996\u9875",
        heading: "\u4EE5\u53CA\u6240\u6709 Atlassian \u5E73\u53F0\u5E94\u7528",
        includes: "\u5305\u62EC",
        goals: "\u76EE\u6807",
        teams: "\u56E2\u961F",
        studio: "\u5DE5\u4F5C\u5BA4",
        search: "\u641C\u7D22",
        chat: "\u804A\u5929",
        analytics: "\u5206\u6790",
        admin: "\u7BA1\u7406\u5458"
    },
    it: {
        home: 'Pagina iniziale',
        heading: 'E tutte le app della piattaforma di Atlassian',
        includes: 'Include',
        goals: 'Obiettivi',
        teams: 'Team',
        studio: 'Studio',
        search: 'Cerca',
        chat: 'Chat',
        analytics: 'Analisi',
        admin: 'Amministratore'
    },
    ja: {
        home: "\u30DB\u30FC\u30E0",
        heading: "\u3055\u3089\u306B\u3059\u3079\u3066\u306E\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3 \u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0 \u30A2\u30D7\u30EA",
        includes: "\u30A4\u30F3\u30AF\u30EB\u30FC\u30C9",
        goals: "\u76EE\u6A19",
        teams: "\u30C1\u30FC\u30E0",
        studio: "\u30B9\u30BF\u30B8\u30AA",
        search: "\u691C\u7D22",
        chat: "\u30C1\u30E3\u30C3\u30C8",
        analytics: "\u5206\u6790\u6A5F\u80FD",
        admin: "\u7BA1\u7406\u8005"
    }
};

});


parcelRegister("jfojT", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionPricingHero", function () { return $e2d3685819b80935$export$11d510446f2a0235; });

var $7VQPk = parcelRequire("7VQPk");

var $e0LCf = parcelRequire("e0LCf");
const $e2d3685819b80935$export$11d510446f2a0235 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e0LCf.CollectionPricingHero), {
        collectionImage: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wwq35151x13e6200i5xc4qs5r21er0q5.svg',
            alt: 'Teamwork Collection'
        },
        products: [
            {
                name: 'Jira',
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/36a5pi244g3e1j3540td888vgj855s0u/collections-teamwork-jira.svg',
                    alt: 'Jira'
                }
            },
            {
                name: 'Confluence',
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nj0wofvhj3q26f3vy866q801p5bbw83w/collections-teamwork-confluence.svg',
                    alt: 'Confluence'
                }
            },
            {
                name: 'Loom',
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/138cux5d67t757a2ddy0l833ihe728l8/collections-teamwork-loom.svg',
                    alt: 'Loom'
                }
            },
            {
                name: 'Rovo',
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/bijp0lf52qxqdt3257q0kj73t8d5681g.svg',
                    alt: 'Rovo'
                }
            }
        ]
    });
};

});

parcelRegister("ilkqI", function(module, exports) {
$parcel$export(module.exports, "Adg4TabPanel", function () { return $640ef6c57a5f1486$export$34e8382484247e57; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lTkkF = parcelRequire("lTkkF");

var $6jJHH = parcelRequire("6jJHH");

var $iyOcM = parcelRequire("iyOcM");
const $640ef6c57a5f1486$var$hidePanelStyle = null;
/**
 * @deprecated - Please use @/libraries/design/patterns/tabs instead
 */ const $640ef6c57a5f1486$export$34e8382484247e57 = ({ forceRender: forceRender, keepInDom: keepInDom, children: children, panelIndex: panelIndex, id: id, hideTabPanelRole: hideTabPanelRole, ...props })=>{
    const { isCurrentTab: isCurrentTab } = (0, $iyOcM.useAdg4TabsContext)();
    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? 'active-panel' : '';
    const originalChildrenCount = (0, $1oC0p.Children).count(children);
    const shouldHideRole = hideTabPanelRole !== undefined ? hideTabPanelRole : originalChildrenCount === 0;
    children = forceRender || isTabSelected || keepInDom ? children : null;
    const { panelId: panelId, tabId: tabId } = (0, $lTkkF.generateSafeIds)(id, panelIndex);
    const { css: existingCss, ...propsWithoutCss } = props;
    const filteredProps = Object.fromEntries(Object.entries(propsWithoutCss).filter(([key])=>!key.startsWith('aria-') && key !== 'role'));
    if (!shouldHideRole) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...filteredProps,
        id: panelId,
        "aria-labelledby": tabId,
        "aria-hidden": !isTabSelected,
        role: "tabpanel",
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                'tab-panel',
                activeClass
            ].join(' ')
        ]),
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $6jJHH.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
    const cssProp = [
        !isTabSelected && !forceRender && $640ef6c57a5f1486$var$hidePanelStyle
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: panelId,
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                'tab-panel',
                activeClass
            ].join(' ')
        ]),
        "aria-labelledby": undefined,
        "aria-hidden": undefined,
        role: undefined,
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $6jJHH.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
};
$640ef6c57a5f1486$export$34e8382484247e57.tabsRole = 'Adg4TabPanel';

});

parcelRegister("hhv63", function(module, exports) {
$parcel$export(module.exports, "updatePreferences", function () { return $a62f11770126afae$export$7bb3e177c1a1e841; });
$parcel$export(module.exports, "ConsentHubClientConfigProvider", function () { return $a62f11770126afae$export$4f1d572ab3f4c2e6; });
$parcel$export(module.exports, "useConsentHubClientConfig", function () { return $a62f11770126afae$export$ef2475d0eafefa1b; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $5Ntyw = parcelRequire("5Ntyw");
const $a62f11770126afae$var$requiredProps = [
    'email',
    'site',
    'locale',
    'formUrl'
];
const $a62f11770126afae$var$defaultLocaleConfig = {
    locale: 'UNKNOWN',
    localeRequiresMarketingCommunicationOptIn: true
};
const $a62f11770126afae$export$ff156a5e09be2a6a = async (stargateClient)=>{
    return await stargateClient.getConsentConfig().then((response)=>response, ()=>$a62f11770126afae$var$defaultLocaleConfig);
};
const $a62f11770126afae$export$7bb3e177c1a1e841 = async (stargateClient, params, localeConfig)=>{
    const paramsLocale = params.paramsLocale ? params.paramsLocale : 'UNKNOWN';
    const postData = {
        locale: localeConfig?.locale || paramsLocale,
        ...params
    };
    if (!$a62f11770126afae$var$requiredProps.every((prop)=>postData.hasOwnProperty(prop))) throw `Invalid parameters. Required: {${$a62f11770126afae$var$requiredProps.toString()}}`;
    const updateConsentPreferencesResponseStatus = await stargateClient.updateConsentPreferences(postData);
    return updateConsentPreferencesResponseStatus;
};
const $a62f11770126afae$var$useGetConsentConfig = ()=>{
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const [localeConfig, setLocaleConfig] = (0, $1oC0p.useState)($a62f11770126afae$var$defaultLocaleConfig);
    (0, $1oC0p.useEffect)(()=>{
        const fetchConfigData = async ()=>{
            const consentHubConfig = await $a62f11770126afae$export$ff156a5e09be2a6a(stargateClient);
            if (consentHubConfig) setLocaleConfig(consentHubConfig);
        };
        fetchConfigData().catch((err)=>console.log(err));
    }, [
        stargateClient
    ]);
    return localeConfig;
};
const $a62f11770126afae$export$6ccd5662e539f2b6 = /*#__PURE__*/ (0, $1oC0p.createContext)($a62f11770126afae$var$defaultLocaleConfig);
const $a62f11770126afae$export$4f1d572ab3f4c2e6 = ({ children: children })=>{
    const localeConfig = $a62f11770126afae$var$useGetConsentConfig();
    return /*#__PURE__*/ (0, $7VQPk.jsx)($a62f11770126afae$export$6ccd5662e539f2b6.Provider, {
        value: localeConfig,
        children: children
    });
};
const $a62f11770126afae$export$ef2475d0eafefa1b = ()=>{
    const context = (0, $1oC0p.useContext)($a62f11770126afae$export$6ccd5662e539f2b6);
    if (!context) throw new Error('useConsentHubClientConfig must be used within a ConsentHubClientConfigProvider');
    return context;
};

});

parcelRegister("hpDnm", function(module, exports) {

var $kp5nV = parcelRequire("kp5nV");

var $1frIC = parcelRequire("1frIC");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $cad350b3a4d1e4e2$var$pick = $1frIC(function(object, paths) {
    return object == null ? {} : $kp5nV(object, paths);
});
module.exports = $cad350b3a4d1e4e2$var$pick;

});
parcelRegister("kp5nV", function(module, exports) {

var $fqptw = parcelRequire("fqptw");

var $8avIg = parcelRequire("8avIg");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $edaa51c779a6741c$var$basePick(object, paths) {
    return $fqptw(object, paths, function(value, path) {
        return $8avIg(object, path);
    });
}
module.exports = $edaa51c779a6741c$var$basePick;

});
parcelRegister("fqptw", function(module, exports) {

var $5oMeU = parcelRequire("5oMeU");

var $brerY = parcelRequire("brerY");

var $hLLeA = parcelRequire("hLLeA");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $b3ad0b8a3c96db41$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $5oMeU(object, path);
        if (predicate(value, path)) $brerY(result, $hLLeA(path, object), value);
    }
    return result;
}
module.exports = $b3ad0b8a3c96db41$var$basePickBy;

});


parcelRegister("1frIC", function(module, exports) {

var $Euo5O = parcelRequire("Euo5O");

var $axmYb = parcelRequire("axmYb");

var $jj29P = parcelRequire("jj29P");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $0e8cb184d6489cc8$var$flatRest(func) {
    return $jj29P($axmYb(func, undefined, $Euo5O), func + '');
}
module.exports = $0e8cb184d6489cc8$var$flatRest;

});
parcelRegister("Euo5O", function(module, exports) {

var $auF8s = parcelRequire("auF8s");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $079b4ee268152e61$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $auF8s(array, 1) : [];
}
module.exports = $079b4ee268152e61$var$flatten;

});



parcelRegister("hBYvx", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return $5a5d9245727e1968$export$ae01dedf5c052bb; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $5a5d9245727e1968$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== 'none' ? {
        aspectRatio: ratio,
        objectFit: 'cover'
    } : {};
    return {
        maxWidth: '100%',
        ...aspectRatioCSS
    };
};
const $5a5d9245727e1968$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $1oC0p.useEffect)(()=>{
        videoRef.current?.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $5a5d9245727e1968$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : 'mp4'}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : 'mp4'}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});

parcelRegister("dYPjn", function(module, exports) {
$parcel$export(module.exports, "useModal", function () { return $a2d8ae5ca7d76b71$export$33ffd74ebf07f060; });

var $1oC0p = parcelRequire("1oC0p");

var $bgW5X = parcelRequire("bgW5X");
var $a2d8ae5ca7d76b71$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $1oC0p.useContext)((0, $bgW5X.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});

parcelRegister("lXgpb", function(module, exports) {

var $gHIMV = parcelRequire("gHIMV");

var $dNNx2 = parcelRequire("dNNx2");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $ffbbd5682208087f$var$camelCase = $dNNx2(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $gHIMV(word) : word);
});
module.exports = $ffbbd5682208087f$var$camelCase;

});
parcelRegister("dNNx2", function(module, exports) {

var $5r99q = parcelRequire("5r99q");

var $hGxEi = parcelRequire("hGxEi");

var $cGaAm = parcelRequire("cGaAm");
/** Used to compose unicode capture groups. */ var $a0c645f3644bc61c$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $a0c645f3644bc61c$var$reApos = RegExp($a0c645f3644bc61c$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $a0c645f3644bc61c$var$createCompounder(callback) {
    return function(string) {
        return $5r99q($cGaAm($hGxEi(string).replace($a0c645f3644bc61c$var$reApos, '')), callback, '');
    };
}
module.exports = $a0c645f3644bc61c$var$createCompounder;

});
parcelRegister("5r99q", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $3f56928ff1fa1456$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $3f56928ff1fa1456$var$arrayReduce;

});

parcelRegister("hGxEi", function(module, exports) {

var $iCQu6 = parcelRequire("iCQu6");

var $24uwp = parcelRequire("24uwp");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ce0075e69d454d18$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ce0075e69d454d18$var$rsComboMarksRange = '\\u0300-\\u036f', $ce0075e69d454d18$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ce0075e69d454d18$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ce0075e69d454d18$var$rsComboRange = $ce0075e69d454d18$var$rsComboMarksRange + $ce0075e69d454d18$var$reComboHalfMarksRange + $ce0075e69d454d18$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ce0075e69d454d18$var$rsCombo = '[' + $ce0075e69d454d18$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ce0075e69d454d18$var$reComboMark = RegExp($ce0075e69d454d18$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ce0075e69d454d18$var$deburr(string) {
    string = $24uwp(string);
    return string && string.replace($ce0075e69d454d18$var$reLatin, $iCQu6).replace($ce0075e69d454d18$var$reComboMark, '');
}
module.exports = $ce0075e69d454d18$var$deburr;

});
parcelRegister("iCQu6", function(module, exports) {

var $6V9cT = parcelRequire("6V9cT");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $037fd0776303ae37$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $037fd0776303ae37$var$deburrLetter = $6V9cT($037fd0776303ae37$var$deburredLetters);
module.exports = $037fd0776303ae37$var$deburrLetter;

});
parcelRegister("6V9cT", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $509f35426b22b824$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $509f35426b22b824$var$basePropertyOf;

});



parcelRegister("cGaAm", function(module, exports) {

var $agIzJ = parcelRequire("agIzJ");

var $2fyoH = parcelRequire("2fyoH");

var $24uwp = parcelRequire("24uwp");

var $51QbK = parcelRequire("51QbK");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $93b19e4fcd969484$var$words(string, pattern, guard) {
    string = $24uwp(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $2fyoH(string) ? $51QbK(string) : $agIzJ(string);
    return string.match(pattern) || [];
}
module.exports = $93b19e4fcd969484$var$words;

});
parcelRegister("agIzJ", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $779df9bff564b02d$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $779df9bff564b02d$var$asciiWords(string) {
    return string.match($779df9bff564b02d$var$reAsciiWord) || [];
}
module.exports = $779df9bff564b02d$var$asciiWords;

});

parcelRegister("2fyoH", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $1a37aa184b5f841b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $1a37aa184b5f841b$var$hasUnicodeWord(string) {
    return $1a37aa184b5f841b$var$reHasUnicodeWord.test(string);
}
module.exports = $1a37aa184b5f841b$var$hasUnicodeWord;

});

parcelRegister("51QbK", function(module, exports) {
/** Used to compose unicode character classes. */ var $3a9587500dbb7d28$var$rsAstralRange = '\\ud800-\\udfff', $3a9587500dbb7d28$var$rsComboMarksRange = '\\u0300-\\u036f', $3a9587500dbb7d28$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $3a9587500dbb7d28$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $3a9587500dbb7d28$var$rsComboRange = $3a9587500dbb7d28$var$rsComboMarksRange + $3a9587500dbb7d28$var$reComboHalfMarksRange + $3a9587500dbb7d28$var$rsComboSymbolsRange, $3a9587500dbb7d28$var$rsDingbatRange = '\\u2700-\\u27bf', $3a9587500dbb7d28$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $3a9587500dbb7d28$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $3a9587500dbb7d28$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $3a9587500dbb7d28$var$rsPunctuationRange = '\\u2000-\\u206f', $3a9587500dbb7d28$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $3a9587500dbb7d28$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $3a9587500dbb7d28$var$rsVarRange = '\\ufe0e\\ufe0f', $3a9587500dbb7d28$var$rsBreakRange = $3a9587500dbb7d28$var$rsMathOpRange + $3a9587500dbb7d28$var$rsNonCharRange + $3a9587500dbb7d28$var$rsPunctuationRange + $3a9587500dbb7d28$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $3a9587500dbb7d28$var$rsApos = "['\u2019]", $3a9587500dbb7d28$var$rsBreak = '[' + $3a9587500dbb7d28$var$rsBreakRange + ']', $3a9587500dbb7d28$var$rsCombo = '[' + $3a9587500dbb7d28$var$rsComboRange + ']', $3a9587500dbb7d28$var$rsDigits = '\\d+', $3a9587500dbb7d28$var$rsDingbat = '[' + $3a9587500dbb7d28$var$rsDingbatRange + ']', $3a9587500dbb7d28$var$rsLower = '[' + $3a9587500dbb7d28$var$rsLowerRange + ']', $3a9587500dbb7d28$var$rsMisc = '[^' + $3a9587500dbb7d28$var$rsAstralRange + $3a9587500dbb7d28$var$rsBreakRange + $3a9587500dbb7d28$var$rsDigits + $3a9587500dbb7d28$var$rsDingbatRange + $3a9587500dbb7d28$var$rsLowerRange + $3a9587500dbb7d28$var$rsUpperRange + ']', $3a9587500dbb7d28$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $3a9587500dbb7d28$var$rsModifier = '(?:' + $3a9587500dbb7d28$var$rsCombo + '|' + $3a9587500dbb7d28$var$rsFitz + ')', $3a9587500dbb7d28$var$rsNonAstral = '[^' + $3a9587500dbb7d28$var$rsAstralRange + ']', $3a9587500dbb7d28$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $3a9587500dbb7d28$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $3a9587500dbb7d28$var$rsUpper = '[' + $3a9587500dbb7d28$var$rsUpperRange + ']', $3a9587500dbb7d28$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $3a9587500dbb7d28$var$rsMiscLower = '(?:' + $3a9587500dbb7d28$var$rsLower + '|' + $3a9587500dbb7d28$var$rsMisc + ')', $3a9587500dbb7d28$var$rsMiscUpper = '(?:' + $3a9587500dbb7d28$var$rsUpper + '|' + $3a9587500dbb7d28$var$rsMisc + ')', $3a9587500dbb7d28$var$rsOptContrLower = '(?:' + $3a9587500dbb7d28$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $3a9587500dbb7d28$var$rsOptContrUpper = '(?:' + $3a9587500dbb7d28$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $3a9587500dbb7d28$var$reOptMod = $3a9587500dbb7d28$var$rsModifier + '?', $3a9587500dbb7d28$var$rsOptVar = '[' + $3a9587500dbb7d28$var$rsVarRange + ']?', $3a9587500dbb7d28$var$rsOptJoin = '(?:' + $3a9587500dbb7d28$var$rsZWJ + '(?:' + [
    $3a9587500dbb7d28$var$rsNonAstral,
    $3a9587500dbb7d28$var$rsRegional,
    $3a9587500dbb7d28$var$rsSurrPair
].join('|') + ')' + $3a9587500dbb7d28$var$rsOptVar + $3a9587500dbb7d28$var$reOptMod + ')*', $3a9587500dbb7d28$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $3a9587500dbb7d28$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $3a9587500dbb7d28$var$rsSeq = $3a9587500dbb7d28$var$rsOptVar + $3a9587500dbb7d28$var$reOptMod + $3a9587500dbb7d28$var$rsOptJoin, $3a9587500dbb7d28$var$rsEmoji = '(?:' + [
    $3a9587500dbb7d28$var$rsDingbat,
    $3a9587500dbb7d28$var$rsRegional,
    $3a9587500dbb7d28$var$rsSurrPair
].join('|') + ')' + $3a9587500dbb7d28$var$rsSeq;
/** Used to match complex or compound words. */ var $3a9587500dbb7d28$var$reUnicodeWord = RegExp([
    $3a9587500dbb7d28$var$rsUpper + '?' + $3a9587500dbb7d28$var$rsLower + '+' + $3a9587500dbb7d28$var$rsOptContrLower + '(?=' + [
        $3a9587500dbb7d28$var$rsBreak,
        $3a9587500dbb7d28$var$rsUpper,
        '$'
    ].join('|') + ')',
    $3a9587500dbb7d28$var$rsMiscUpper + '+' + $3a9587500dbb7d28$var$rsOptContrUpper + '(?=' + [
        $3a9587500dbb7d28$var$rsBreak,
        $3a9587500dbb7d28$var$rsUpper + $3a9587500dbb7d28$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $3a9587500dbb7d28$var$rsUpper + '?' + $3a9587500dbb7d28$var$rsMiscLower + '+' + $3a9587500dbb7d28$var$rsOptContrLower,
    $3a9587500dbb7d28$var$rsUpper + '+' + $3a9587500dbb7d28$var$rsOptContrUpper,
    $3a9587500dbb7d28$var$rsOrdUpper,
    $3a9587500dbb7d28$var$rsOrdLower,
    $3a9587500dbb7d28$var$rsDigits,
    $3a9587500dbb7d28$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $3a9587500dbb7d28$var$unicodeWords(string) {
    return string.match($3a9587500dbb7d28$var$reUnicodeWord) || [];
}
module.exports = $3a9587500dbb7d28$var$unicodeWords;

});




parcelRegister("9D78w", function(module, exports) {
$parcel$export(module.exports, "ProductNavBar", function () { return $b545d9db2ee66805$export$6bfdc568e00f9e3d; });
/* product-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $l5ucJ = parcelRequire("l5ucJ");

var $kbpa7 = parcelRequire("kbpa7");

var $aHkxS = parcelRequire("aHkxS");

var $2Df35 = parcelRequire("2Df35");

var $80kL5 = parcelRequire("80kL5");

var $1ka2O = parcelRequire("1ka2O");

var $ldrV1 = parcelRequire("ldrV1");
const $b545d9db2ee66805$var$navigationWrapperCss = null;
const $b545d9db2ee66805$var$navigationBarWrapperCss = null;
const $b545d9db2ee66805$var$navigationBarCss = null;
const $b545d9db2ee66805$var$logoAndLinksCss = null;
const $b545d9db2ee66805$var$keyframeChevron = null;
const $b545d9db2ee66805$var$removeKeyframeChevron = null;
const $b545d9db2ee66805$var$dropdownSlideInAnimation = null;
const $b545d9db2ee66805$var$dropdownSlideOutAnimation = null;
const $b545d9db2ee66805$var$listItemCss = null;
const $b545d9db2ee66805$var$buttonWrapper = null;
const $b545d9db2ee66805$var$linkAndButtonWrapper = null;
const $b545d9db2ee66805$var$buttonStyle = null;
const $b545d9db2ee66805$var$contactSalesButtonStyle = null;
const $b545d9db2ee66805$var$logoDimensions = {
    confluence: 157,
    jiraservicemanagement: 280,
    jira: 80,
    jirasoftware: 80
};
const $b545d9db2ee66805$export$6bfdc568e00f9e3d = (props)=>{
    const intl = (0, $8e22h.default)();
    const isShowFreeHrefButton = props.showFreeHrefButton ?? true;
    const isShowContactSalesHrefButton = props.showContactSalesHrefButton ?? false;
    const showTextWithoutLogo = props.showTextWithoutLogo ?? false;
    const [activeDropdown, setActive] = (0, $1oC0p.useState)(null);
    const [buttonType, setButtonType] = (0, $1oC0p.useState)('secondary');
    const location = (0, $1ka2O.useLocation)();
    (0, $1oC0p.useEffect)(()=>{
        window.addEventListener('scroll', handleScroll);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        activeDropdown,
        props.showFreeHrefButton
    ]);
    const handleScroll = ()=>{
        setButtonType(window.scrollY > 56 ? 'primary' : 'secondary');
    };
    const getItFreeText = intl.formatMessage({
        id: 'productNavBar.get-it-free-button',
        defaultMessage: 'Get it free'
    });
    const getContactSalesText = intl.formatMessage({
        id: 'productNavBar.contact-sales-button',
        defaultMessage: 'Contact sales'
    });
    const dropdownCss = [
        null,
        !activeDropdown && null,
        activeDropdown && null
    ];
    const mobileCategoriesWrapperCss = [
        null,
        activeDropdown === null && null,
        activeDropdown && null,
        !activeDropdown && null
    ];
    const renderSelectionItems = (isMobile)=>{
        const categoriesWrapperCss = [
            !isMobile && null
        ];
        return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            className: (0, $2jatx.default)([
                !isMobile && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _qtt8glyw _18s8119w _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1mjbglyw"
            ]),
            children: props.children && (0, $1oC0p.Children).map(props.children, (child, index)=>child ? /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm"
                    ]),
                    children: /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, {
                        isSelected: child.props.isSelected || (0, $80kL5.isEqualUnlocalizedPathname)(child.props.href, location.pathname),
                        isMobile: isMobile
                    })
                }, index) : null)
        });
    };
    const renderDropdownButton = ()=>{
        if (props.children) return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
            onClick: ()=>setActive(!activeDropdown),
            className: (0, $2jatx.default)([
                "_1e0cglyw _80omtlke _bfhk1j28 _19itglyw _syazftjs _1q5112x7 _1752xy5q _w8l5xy5q _48hmq7pw _1mjb1ule",
                !activeDropdown && "",
                !activeDropdown && "_1px117db",
                activeDropdown && "",
                activeDropdown && "_1px11vwh"
            ]),
            style: {
                "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l5ucJ))), {
                label: ""
            })
        });
        return null;
    };
    const logoWrapperCss = [
        props.logoLinkWrapperWidth && props.logoLinkWrapperWidth === '' && null,
        null
    ];
    const textWrapperCss = null;
    const textCss = null;
    const boxShadowCss = props.productName !== 'confluence' && props.productName !== 'jira' && null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqsw1n9t _1bsb1osq _152tidpf _1pby11wp"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1y6m _11q71afi _1e0c1txw _2lx2vrvc _1bah1h6o",
                    props.productName !== 'confluence' && props.productName !== 'jira' && "_16qsg1bn"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1yb4 _165t1wqb _10jx1fra _1yag119w _1vkh8vuz _13zno7np _em6nh2mm _4ik0kb7n _1gdevrvc _navj1g80 _tnru1wug _15tx119w",
                        "productNavBar"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw"
                            ]),
                            children: [
                                showTextWithoutLogo ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $2jatx.default)([
                                        "_4t3i12am _syazkhc1 _4cvr1h6o _1e0c1txw _2lx2vrvc"
                                    ]),
                                    style: {
                                        "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb166g _k48pbfng"
                                        ]),
                                        children: props.ariaLabel
                                    })
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $2jatx.default)([
                                        props.logoLinkWrapperWidth && props.logoLinkWrapperWidth === '' && "_1bsb2lms",
                                        "_4cvr1h6o _1e0c1txw"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                                        brand: props.productName,
                                        type: "logo",
                                        appearance: "brand",
                                        height: '48',
                                        width: $b545d9db2ee66805$var$logoDimensions[props.productName]
                                    })
                                }),
                                renderDropdownButton(),
                                renderSelectionItems(false)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: [
                                isShowFreeHrefButton && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _ca0qo7ao _u5f3idpf _n3tdo7ao _19bvidpf",
                                        "showFreeHrefButton"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                                        text: getItFreeText,
                                        url: props.freeHref,
                                        type: buttonType,
                                        "aria-label": getItFreeText,
                                        dataEventProps: {
                                            'data-event-container': 'navbar',
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-label': getItFreeText,
                                            'data-label-english': 'Get it free',
                                            'data-product-key': props.dataProductKey,
                                            'data-track-event': `${props.dataProductKey}.get-it-free-button-clicked`
                                        },
                                        onClick: props.onClick,
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pbfng _4t3iviql _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                        ])
                                    })
                                }),
                                isShowContactSalesHrefButton && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: "showContactSalesHrefButton",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                                        text: getContactSalesText,
                                        color: "yellow",
                                        url: props.freeHref,
                                        type: buttonType,
                                        "aria-label": getContactSalesText,
                                        dataEventProps: {
                                            'data-event-container': 'navbar',
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-label': getContactSalesText,
                                            'data-product-key': props.dataProductKey
                                        },
                                        onClick: props.onClick,
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pbfng _4t3iviql _11q71uly _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                        ]),
                                        style: {
                                            "--_1p38jlt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron400'))
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_16jlkb7n _1o9zkb7n _i0dlf1ug _16qsg1bn _c71lidpf _1reo15vq _18m91wug _kqswstnw _1bsb1osq _bfhkg7ng _179rn5xp _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hzio7ao _3n4midpf _ltofo7ao _k7zy1ul9 _1hmtglyw _163ro7ao _dm25glyw",
                    activeDropdown === null && "_1h6d6u2e _mqm2n5xp",
                    activeDropdown && "",
                    activeDropdown && "_c71l8stt _y44vuhag _1h6dkhc1 _mqm2kze7",
                    !activeDropdown && "",
                    !activeDropdown && "_y44v1ovr _1h6d6u2e _mqm2kze7",
                    "mobileCategoriesWrapper"
                ]),
                style: {
                    "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
                    "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300')),
                    "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                },
                children: renderSelectionItems(true)
            })
        ]
    });
};
var $b545d9db2ee66805$export$2e2bcd8739ae039 = $b545d9db2ee66805$export$6bfdc568e00f9e3d;

});

parcelRegister("7Sdq5", function(module, exports) {
$parcel$export(module.exports, "CollectionsCompoundNav", function () { return $61c36fa46e5ad31f$export$c217303c3f69f1be; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $cR2Ov = parcelRequire("cR2Ov");

var $hcVGp = parcelRequire("hcVGp");
const $61c36fa46e5ad31f$export$c217303c3f69f1be = ()=>{
    const intl = (0, $8e22h.default)();
    const teamworkOverviewHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork');
    const teamworkFeaturesHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/features');
    const teamworkGuidesHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/guides');
    const teamworkEnterpriseHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/enterprise');
    const teamworkPricingHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/pricing');
    const teamworkResourcesHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/resources');
    const strategyOverviewHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy');
    const strategyDemosHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/demo-center');
    const strategyPricingHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/pricing');
    const strategyResourcesHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/resources');
    const strategyUseCasesHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/use-cases');
    const strategyCustomersHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/customers');
    const serviceOverviewHref = (0, $jQ0cd.useLocalizedHref)('/collections/service');
    const servicePricingHref = (0, $jQ0cd.useLocalizedHref)('/collections/service/pricing');
    const softwareHref = (0, $jQ0cd.useLocalizedHref)('/collections/software');
    const productHref = (0, $jQ0cd.useLocalizedHref)('/collections/product');
    const collectionsHref = (0, $jQ0cd.useLocalizedHref)('/collections');
    const props = {
        optionalClassName: 'collections-nav',
        compoundSubNavTitle: 'Collections',
        compoundSubNavTitleHref: collectionsHref,
        compoundSubNavLinksProps: [
            {
                globalLinksKey: 'teamwork',
                linkText: 'Teamwork',
                hasSubnav: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.overview',
                                        defaultMessage: 'Overview'
                                    }),
                                    href: teamworkOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.features',
                                        defaultMessage: 'Features'
                                    }),
                                    href: teamworkFeaturesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.guides',
                                        defaultMessage: 'Guides'
                                    }),
                                    href: teamworkGuidesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.enterprise',
                                        defaultMessage: 'Enterprise'
                                    }),
                                    href: teamworkEnterpriseHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.pricing',
                                        defaultMessage: 'Pricing'
                                    }),
                                    href: teamworkPricingHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.resources',
                                        defaultMessage: 'Resources'
                                    }),
                                    href: teamworkResourcesHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'strategy',
                linkText: 'Strategy',
                hasSubnav: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.overview',
                                        defaultMessage: 'Overview'
                                    }),
                                    href: strategyOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.demos',
                                        defaultMessage: 'Demos'
                                    }),
                                    href: strategyDemosHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.pricing',
                                        defaultMessage: 'Pricing'
                                    }),
                                    href: strategyPricingHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.resources',
                                        defaultMessage: 'Resources'
                                    }),
                                    href: strategyResourcesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.useCases',
                                        defaultMessage: 'Use Cases'
                                    }),
                                    href: strategyUseCasesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.customers',
                                        defaultMessage: 'Customers'
                                    }),
                                    href: strategyCustomersHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'service',
                linkText: 'Service',
                hasSubnav: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.overview',
                                        defaultMessage: 'Overview'
                                    }),
                                    href: serviceOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.pricing',
                                        defaultMessage: 'Pricing'
                                    }),
                                    href: servicePricingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'software',
                linkText: 'Software',
                hasSubnav: false,
                href: softwareHref
            },
            {
                globalLinksKey: 'product',
                linkText: 'Product',
                hasSubnav: false,
                href: productHref
            }
        ],
        isShowCta: false
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
        productKey: 'collection',
        compoundNav: props
    });
};

});

parcelRegister("6VSBC", function(module, exports) {
$parcel$export(module.exports, "EnterprisePageProductNav", function () { return $3872cd7d84b2ef7a$export$e36ad2737327f9c; });
$parcel$export(module.exports, "default", function () { return $3872cd7d84b2ef7a$export$2e2bcd8739ae039; });
/* enterprise-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $jQ0cd = parcelRequire("jQ0cd");

var $5uYpV = parcelRequire("5uYpV");

var $iOXki = parcelRequire("iOXki");
const $3872cd7d84b2ef7a$var$logoWrapperStyles = null;
const $3872cd7d84b2ef7a$var$EnterpriseLogo = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1q51v77o _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5uYpV.Logo), {
            brand: "enterprise",
            type: "logo",
            appearance: "brand"
        })
    });
const $3872cd7d84b2ef7a$export$e36ad2737327f9c = ({ isActive: isActive })=>{
    const intl = (0, $8e22h.default)();
    const ctaButtonText = intl.formatMessage({
        id: 'EnterpriseLandingPage.navbar.cta',
        defaultMessage: 'Contact sales'
    });
    const mobileCtaButtonText = intl.formatMessage({
        id: 'EnterpriseLandingPage.navbar.mobile.cta',
        defaultMessage: 'Contact sales'
    });
    const links = [
        {
            globalLinksKey: 'overview',
            linkText: intl.formatMessage({
                id: 'EnterpriseLandingPage.navbar.overview',
                defaultMessage: 'Overview'
            }),
            hasSubnav: false,
            isActive: isActive === 'overview',
            productKey: 'enterprise',
            href: (0, $jQ0cd.useLocalizedHref)('/enterprise')
        },
        {
            globalLinksKey: 'success',
            linkText: intl.formatMessage({
                id: 'EnterpriseLandingPage.navbar.success',
                defaultMessage: 'Success'
            }),
            hasSubnav: false,
            isActive: isActive === 'success',
            productKey: 'enterprise',
            href: (0, $jQ0cd.useLocalizedHref)('/enterprise/success')
        },
        {
            globalLinksKey: 'resources',
            linkText: intl.formatMessage({
                id: 'EnterpriseLandingPage.navbar.resources',
                defaultMessage: 'Resources'
            }),
            hasSubnav: false,
            isActive: isActive === 'resources',
            productKey: 'enterprise',
            href: (0, $jQ0cd.useLocalizedHref)('/enterprise/resources')
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-product-navigation",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogoUrl: (0, $jQ0cd.useLocalizedHref)('/enterprise'),
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($3872cd7d84b2ef7a$var$EnterpriseLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: 'EnterpriseLandingPage.label',
                defaultMessage: 'Enterprise'
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($3872cd7d84b2ef7a$var$EnterpriseLogo, {}),
            productPageNavLinks: links,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-enterprise',
                    mobileLinksProps: links
                }
            ],
            navigationTrynowCtaText: ctaButtonText,
            navigationTrynowCtaUrl: (0, $jQ0cd.useLocalizedHref)('/enterprise/contact?formType=product-features'),
            mobileCtaText: mobileCtaButtonText,
            mobileCtaUrl: (0, $jQ0cd.useLocalizedHref)('/enterprise/contact?formType=product-features')
        })
    });
};
var $3872cd7d84b2ef7a$export$2e2bcd8739ae039 = $3872cd7d84b2ef7a$export$e36ad2737327f9c;

});

parcelRegister("atyps", function(module, exports) {
$parcel$export(module.exports, "BitbucketNav", function () { return $46b40aa87e150696$export$374e7235418bdbdb; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $iOXki = parcelRequire("iOXki");

var $fv5hW = parcelRequire("fv5hW");
const $46b40aa87e150696$var$BitbucketLogoComponent = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "bitbucket",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
};
const $46b40aa87e150696$export$374e7235418bdbdb = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=bitbucket&edition=free');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).BITBUCKET,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const dataCenterHref = (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/enterprise/data-center');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/pricing');
    const links = [
        {
            globalLinksKey: 'whyBitbucket',
            linkText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.whyBitbucket',
                defaultMessage: 'Why Bitbucket'
            }),
            productKey: 'bitbucket',
            hasSubnav: true,
            dropdownType: 'why-bitbucket'
        },
        {
            globalLinksKey: 'self-hosted',
            linkText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.selfhosted',
                defaultMessage: 'Self-Hosted'
            }),
            hasSubnav: false,
            productKey: 'bitbucket',
            href: dataCenterHref
        },
        {
            globalLinksKey: 'pricing',
            linkText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.pricing',
                defaultMessage: 'Pricing'
            }),
            hasSubnav: false,
            productKey: 'bitbucket',
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-BitbucketNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productKey: 'bitbucket',
            productLogoUrl: "/software/bitbucket",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($46b40aa87e150696$var$BitbucketLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.bitbucket-logo',
                defaultMessage: 'Bitbucket logo'
            }),
            mobileCtaText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.getitfree',
                defaultMessage: 'Get it Free'
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.getitfree',
                defaultMessage: 'Get it Free'
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($46b40aa87e150696$var$BitbucketLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: 'whyBitbucket',
                    linkText: intl.formatMessage({
                        id: 'BitbucketPageTemplate.navbar.whyBitbucket',
                        defaultMessage: 'Why Bitbucket'
                    }),
                    containerStyles: {
                        width: 'fit-content',
                        margin: 0
                    },
                    hasSubnav: true,
                    content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fv5hW.WhyBitbucketSubnav), {
                        productKey: 'bitbucket'
                    })
                },
                {
                    globalLinksKey: 'self-hosted',
                    linkText: intl.formatMessage({
                        id: 'BitbucketPageTemplate.navbar.selfhosted',
                        defaultMessage: 'Self-Hosted'
                    }),
                    hasSubnav: false,
                    productKey: 'bitbucket',
                    href: dataCenterHref
                },
                {
                    globalLinksKey: 'pricing',
                    linkText: intl.formatMessage({
                        id: 'BitbucketPageTemplate.navbar.pricing',
                        defaultMessage: 'Pricing'
                    }),
                    hasSubnav: false,
                    productKey: 'bitbucket',
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-bitbucket',
                    mobileLinksProps: links
                }
            ]
        })
    });
};

});
parcelRegister("fv5hW", function(module, exports) {
$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return $e0ef30a4e223c9fa$export$7b115720fff1fb0d; });
/* why-bitbucket-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $8nFt2 = parcelRequire("8nFt2");

var $jgdMW = parcelRequire("jgdMW");

var $dfBhn = parcelRequire("dfBhn");

var $9KOR3 = parcelRequire("9KOR3");
function $e0ef30a4e223c9fa$var$useWhyBitbucketLinks() {
    return {
        features: {
            id: 'solution',
            title: (0, $fnHPc.defineMessage)({
                id: 'bitbucketnav.subnav.whybitbucket.links.solution',
                defaultMessage: 'Solution'
            }),
            items: [
                {
                    id: 'ci-cd',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.work-management',
                        defaultMessage: 'CI/CD'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/pipelines')
                },
                {
                    id: 'cloud-security',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.cloud-security',
                        defaultMessage: 'Cloud Security'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/cloud-security')
                },
                {
                    id: 'dev-sec-ops',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.dev-sec-ops',
                        defaultMessage: 'DevSecOps'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/devsecops')
                },
                {
                    id: 'code-review',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.it-service-management',
                        defaultMessage: 'Code Review'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/code-review')
                },
                {
                    id: 'jira-integrations',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.agile-devops',
                        defaultMessage: 'Jira Integrations'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/jira/bitbucket-integration')
                }
            ]
        },
        plans: {
            id: 'plans',
            title: (0, $fnHPc.defineMessage)({
                id: 'bitbucketnav.subnav.whybitbucket.links.plans',
                defaultMessage: 'Plans'
            }),
            items: [
                {
                    id: 'bitbucket-cloud-premium',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.bitbucket-cloud-premium',
                        defaultMessage: 'Bitbucket Cloud Premium'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/premium')
                }
            ]
        }
    };
}
const $e0ef30a4e223c9fa$export$7b115720fff1fb0d = ({ productKey: productKey = 'bitbucket' })=>{
    const intl = (0, $8e22h.default)();
    const bitbucketLinks = $e0ef30a4e223c9fa$var$useWhyBitbucketLinks();
    const linkColumns = Object.values(bitbucketLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhkg7ng"
                    ]),
                    style: {
                        "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                        numCols: 2,
                        columnGap: "var(--ds-space-500, 40px)",
                        paddingBlock: "var(--ds-space-500, 40px)",
                        paddingInline: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1p1dangw _syaz1pfd _1wyboqnp _ect4z4z1 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _2z0510ma"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1pfd _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1pfd _oavvftjs _oxk4ftjs _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        'data-event': 'clicked',
                                                        'data-event-component': 'linkButton',
                                                        'data-event-container': 'globalNavSubnav',
                                                        'data-product-key': productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("lgKym", function(module, exports) {
$parcel$export(module.exports, "CompassNav", function () { return $73340f47439b5afe$export$78e93448314ae49; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $iOXki = parcelRequire("iOXki");
const $73340f47439b5afe$var$CompassLogoComponent = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "compass",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
};
const $73340f47439b5afe$export$78e93448314ae49 = ()=>{
    const intl = (0, $8e22h.default)();
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/compass/pricing');
    const resourcesHref = (0, $jQ0cd.useLocalizedHref)('/software/compass/resources');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-CompassNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogoUrl: "/software/compass",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($73340f47439b5afe$var$CompassLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: 'CompassPageTemplate.navbar.compass-logo',
                defaultMessage: 'Compass logo'
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($73340f47439b5afe$var$CompassLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: 'features',
                    linkText: intl.formatMessage({
                        id: 'CompassPageTemplate.navbar.features',
                        defaultMessage: 'Features'
                    }),
                    hasSubnav: false,
                    productKey: 'compass',
                    href: (0, $jQ0cd.useLocalizedHref)('/software/compass/features')
                },
                {
                    globalLinksKey: 'pricing',
                    linkText: intl.formatMessage({
                        id: 'CompassPageTemplate.navbar.pricing',
                        defaultMessage: 'Pricing'
                    }),
                    hasSubnav: false,
                    productKey: 'compass',
                    href: pricingHref
                },
                {
                    globalLinksKey: 'resources',
                    linkText: intl.formatMessage({
                        id: 'CompassPageTemplate.navbar.resources',
                        defaultMessage: 'Resources'
                    }),
                    hasSubnav: false,
                    productKey: 'compass',
                    href: resourcesHref
                }
            ],
            isShowTryNowLink: false,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-compass',
                    mobileLinksProps: [
                        {
                            globalLinksKey: 'features',
                            linkText: intl.formatMessage({
                                id: 'CompassPageTemplate.navbar.features',
                                defaultMessage: 'Features'
                            }),
                            hasSubnav: false,
                            productKey: 'compass',
                            href: (0, $jQ0cd.useLocalizedHref)('/software/compass/features')
                        },
                        {
                            globalLinksKey: 'pricing',
                            linkText: intl.formatMessage({
                                id: 'CompassPageTemplate.navbar.pricing',
                                defaultMessage: 'Pricing'
                            }),
                            hasSubnav: false,
                            productKey: 'compass',
                            href: pricingHref
                        },
                        {
                            globalLinksKey: 'resources',
                            linkText: intl.formatMessage({
                                id: 'CompassPageTemplate.navbar.resources',
                                defaultMessage: 'Resources'
                            }),
                            hasSubnav: false,
                            productKey: 'compass',
                            href: resourcesHref
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("g2lQR", function(module, exports) {
$parcel$export(module.exports, "GuardNav", function () { return $97dc5fc3d3238142$export$941339143e9f5522; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $iOXki = parcelRequire("iOXki");
const $97dc5fc3d3238142$var$GuardLogoComponent = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "guard",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
};
const $97dc5fc3d3238142$export$941339143e9f5522 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = 'https://admin.atlassian.com/atlassian-guard';
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const capabilitiesHref = (0, $jQ0cd.useLocalizedHref)('/software/guard/capabilities');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/guard/pricing');
    const guidesHref = (0, $jQ0cd.useLocalizedHref)('/software/guard/guide#getting-started');
    const demoHref = (0, $jQ0cd.useLocalizedHref)('/software/guard/demo');
    const links = [
        {
            globalLinksKey: 'capabilities',
            linkText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.capabilities',
                defaultMessage: 'Capabilities'
            }),
            hasSubnav: false,
            productKey: 'guard',
            href: capabilitiesHref
        },
        {
            globalLinksKey: 'guides',
            linkText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.guides',
                defaultMessage: 'Guides'
            }),
            hasSubnav: false,
            productKey: 'guard',
            href: guidesHref
        },
        {
            globalLinksKey: 'demo',
            linkText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.demo',
                defaultMessage: 'Demo'
            }),
            hasSubnav: false,
            productKey: 'guard',
            href: demoHref
        },
        {
            globalLinksKey: 'pricing',
            linkText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.pricing',
                defaultMessage: 'Pricing'
            }),
            hasSubnav: false,
            productKey: 'guard',
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-GuardNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogoUrl: "/software/guard",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($97dc5fc3d3238142$var$GuardLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.guard-logo',
                defaultMessage: 'Guard logo'
            }),
            mobileCtaText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.tryitfree',
                defaultMessage: 'Try it free'
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.tryitfree',
                defaultMessage: 'Try it free'
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($97dc5fc3d3238142$var$GuardLogoComponent, {}),
            productPageNavLinks: links,
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-guard',
                    mobileLinksProps: links
                }
            ]
        })
    });
};

});

parcelRegister("aYwTu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a060b684c4f472c9$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $iOXki = parcelRequire("iOXki");
const $a060b684c4f472c9$var$JpdLogo = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
};
const $a060b684c4f472c9$var$JiraProductDiscoveryNavV2 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-product-discovery');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const links = [
        {
            globalLinksKey: 'features',
            linkText: intl.formatMessage({
                // this id can be renamed once the above has been fixed as well
                id: 'jiraproductdiscovery.navbar.product-features',
                defaultMessage: 'Features'
            }),
            hasSubnav: false,
            productKey: 'jiraProductDiscovery',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/features')
        },
        {
            globalLinksKey: 'resources',
            linkText: intl.formatMessage({
                id: 'jiraproductdiscovery.navbar.resources',
                defaultMessage: 'Resources'
            }),
            hasSubnav: false,
            productKey: 'jiraProductDiscovery',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/resources')
        },
        {
            globalLinksKey: 'guides',
            linkText: intl.formatMessage({
                id: 'jiraproductdiscovery.navbar.guides',
                defaultMessage: 'Guides'
            }),
            hasSubnav: false,
            productKey: 'jiraProductDiscovery',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/guides/getting-started/introduction')
        },
        {
            globalLinksKey: 'pricing',
            linkText: intl.formatMessage({
                // this id should be renamed, but for Team'24 hotfix we need to keep existing mapping
                id: 'jiraproductdiscovery.navbar.features',
                defaultMessage: 'Pricing'
            }),
            hasSubnav: false,
            productKey: 'jiraProductDiscovery',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/pricing')
        }
    ];
    const ctaText = intl.formatMessage({
        id: 'productNavBar.get-it-free-button',
        defaultMessage: 'Get it free'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
        productLogoUrl: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery'),
        productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($a060b684c4f472c9$var$JpdLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: 'wacJiraProductDiscoveryNavigation.logo-label',
            defaultMessage: 'Jira Product Discovery logo'
        }),
        mobileCtaText: ctaText,
        mobileCtaUrl: signupLink,
        mobileCtaOnClick: openCrossFlow,
        mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($a060b684c4f472c9$var$JpdLogo, {}),
        navigationTrynowCtaText: ctaText,
        navigationTrynowCtaUrl: signupLink,
        navigationTrynowCtaOnClick: openCrossFlow,
        productPageNavLinks: links,
        mobileLinksSections: [
            {
                mobileLinkKey: 'mobile-jira-product-discovery',
                mobileLinksProps: links
            }
        ]
    });
};
$a060b684c4f472c9$var$JiraProductDiscoveryNavV2.displayName = 'JiraProductDiscoveryNavV2';
var $a060b684c4f472c9$export$2e2bcd8739ae039 = $a060b684c4f472c9$var$JiraProductDiscoveryNavV2;

});

parcelRegister("aYVVm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $133256a5190381b7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $b31tm = parcelRequire("b31tm");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $cR2Ov = parcelRequire("cR2Ov");

var $iOXki = parcelRequire("iOXki");

var $iSeHD = parcelRequire("iSeHD");

var $9KOR3 = parcelRequire("9KOR3");
const $133256a5190381b7$var$JiraServiceManagementLogo = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
};
const $133256a5190381b7$var$JiraServiceManagementSoftwareNavV2 = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    const intl = (0, $8e22h.default)();
    const featuresHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/features');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/pricing');
    const itSupportHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/itsm-software');
    const itOperationsHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/it-operations');
    const enterpriseServiceManagementHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/features/enterprise-service-management');
    const customerServiceHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/customer-service-software');
    const hrHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/hr');
    const smallTeamsHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/help-desk-software-small-business-software');
    const premiumHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/premium');
    const enterpriseHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/enterprise');
    const technologyTelecomHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/technology-telecommunications');
    const financialServicesHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/financial-services');
    const retailHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/retail-ecommerce');
    const manufacturingHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/manufacturing');
    const itsmHref = (0, $jQ0cd.useLocalizedHref)('/itsm');
    const guidesHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/product-guide');
    const resourcesHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/resources');
    const solutionsDropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: 'fit-content !important',
            margin: 0,
            transform: 'translateX(-40%)'
        };
    }, []);
    const templatesUrl = (0, $jQ0cd.useLocalizedHref)('/software/jira/templates/service-management');
    const { fireUIEvent: fireUIEvent } = (0, $b31tm.useFireEvent)();
    const viewedUIEvent = (0, $1oC0p.useRef)(false);
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    (0, $1oC0p.useEffect)(()=>{
        if (!viewedUIEvent.current && analyticsClient) {
            viewedUIEvent.current = true;
            fireUIEvent({
                action: 'viewed',
                actionSubject: 'jiraServiceManagementSoftwareNavV2'
            });
        }
    }, [
        analyticsClient,
        fireUIEvent
    ]);
    const links = (0, $1oC0p.useMemo)(()=>[
            {
                globalLinksKey: 'features',
                linkText: intl.formatMessage({
                    id: 'software-jira-service-management.navbar.features',
                    defaultMessage: 'Features'
                }),
                hasSubnav: false,
                productKey: 'jira-servicedesk.ondemand',
                href: featuresHref
            },
            {
                globalLinksKey: 'solutions',
                linkText: intl.formatMessage({
                    id: 'software-jira-service-management.navbar.solutions',
                    defaultMessage: 'Solutions'
                }),
                hasSubnav: true,
                dropdownType: 'solutions',
                productKey: 'jira-servicedesk.ondemand',
                containerPosition: 'relative',
                containerStyles: solutionsDropdownStyles,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: 'software-jira-service-management.navbar.solutions.useCases.header',
                                defaultMessage: 'By use case'
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.itSupport',
                                        defaultMessage: 'IT Support'
                                    }),
                                    href: itSupportHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.itOperations',
                                        defaultMessage: 'IT Operations'
                                    }),
                                    href: itOperationsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.businessTeams',
                                        defaultMessage: 'Business Teams'
                                    }),
                                    href: enterpriseServiceManagementHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.customerService',
                                        defaultMessage: 'Customer Service'
                                    }),
                                    href: customerServiceHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.humanResources',
                                        defaultMessage: 'Human Resources'
                                    }),
                                    href: hrHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: 'software-jira-service-management.navbar.solutions.capability.header',
                                defaultMessage: 'By capability'
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.capability.smallTeams',
                                        defaultMessage: 'Small Teams'
                                    }),
                                    href: smallTeamsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.capability.premium',
                                        defaultMessage: 'Premium'
                                    }),
                                    href: premiumHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.capability.enterprise',
                                        defaultMessage: 'Enterprise'
                                    }),
                                    href: enterpriseHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: 'software-jira-service-management.navbar.solutions.industry.customerService',
                                defaultMessage: 'By industry'
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.industry.technologyTelecom',
                                        defaultMessage: 'Technology & Telecom'
                                    }),
                                    href: technologyTelecomHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.industry.financialServices',
                                        defaultMessage: 'Financial Services'
                                    }),
                                    href: financialServicesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.industry.retail',
                                        defaultMessage: 'Retail'
                                    }),
                                    href: retailHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.manufacturing',
                                        defaultMessage: 'Manufacturing'
                                    }),
                                    href: manufacturingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'resources',
                linkText: intl.formatMessage({
                    id: 'software-jira-service-management.navbar.resources',
                    defaultMessage: 'Resources'
                }),
                hasSubnav: true,
                dropdownType: 'resources',
                productKey: 'jira-servicedesk.ondemand',
                containerPosition: 'relative',
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: 'software-jira-service-management.navbar.resources.type.header',
                                defaultMessage: 'By type'
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.resources.type.itsm',
                                        defaultMessage: 'ITSM'
                                    }),
                                    href: itsmHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.resources.type.guides',
                                        defaultMessage: 'Guides'
                                    }),
                                    href: guidesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.templates',
                                        defaultMessage: 'Templates'
                                    }),
                                    href: templatesUrl
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.resources.type.additionalResources',
                                        defaultMessage: 'Additional Resources'
                                    }),
                                    href: resourcesHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'pricing',
                linkText: intl.formatMessage({
                    id: 'software-jira-service-management.navbar.pricing',
                    defaultMessage: 'Pricing'
                }),
                hasSubnav: false,
                productKey: 'jira-servicedesk.ondemand',
                href: pricingHref
            }
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        customerServiceHref,
        solutionsDropdownStyles,
        enterpriseHref,
        enterpriseServiceManagementHref,
        featuresHref,
        financialServicesHref,
        hrHref,
        intl,
        itOperationsHref,
        itSupportHref,
        itsmHref,
        manufacturingHref,
        premiumHref,
        pricingHref,
        guidesHref,
        resourcesHref,
        retailHref,
        smallTeamsHref,
        technologyTelecomHref,
        templatesUrl
    ]);
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/free');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const productNavOnClick = (0, $1oC0p.useMemo)(()=>productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        openCrossFlow,
        productNavCtaCTAClickFunction
    ]);
    const globalNavItemKeys = (0, $1oC0p.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    const ctaText = intl.formatMessage({
        id: 'productNavBar.get-it-free-button',
        defaultMessage: 'Get it free'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavProvider), {
        globalNavItemKeys: globalNavItemKeys,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($133256a5190381b7$var$JiraServiceManagementLogo, {}),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($133256a5190381b7$var$JiraServiceManagementLogo, {}),
            productLogoUrl: (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management'),
            productLogoAriaLabel: "Jira Service Management",
            productPageNavLinks: links,
            isShowTryNowLink: false,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-jira-service-management',
                    mobileLinksProps: links
                }
            ],
            isIncludeMobileCTA: false,
            mobileCtaText: intl.formatMessage({
                id: 'productNavBar.get-it-free-button',
                defaultMessage: 'Get it free'
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            navigationTrynowCtaText: ctaText,
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            additionalMenuPageObjectsArray: [
                {
                    menuPageKey: 'solutions',
                    menuPageObjects: links.find((link)=>link.globalLinksKey === 'solutions')?.content
                },
                {
                    menuPageKey: 'resources',
                    menuPageObjects: links.find((link)=>link.globalLinksKey === 'resources')?.content
                }
            ]
        })
    });
};
var $133256a5190381b7$export$2e2bcd8739ae039 = $133256a5190381b7$var$JiraServiceManagementSoftwareNavV2;

});

parcelRegister("1K6kz", function(module, exports) {
$parcel$export(module.exports, "LoomNav", function () { return $b0045c9e2971c8ff$export$e9541932877c1f74; });
$parcel$export(module.exports, "default", function () { return $b0045c9e2971c8ff$export$2e2bcd8739ae039; });
/* loom-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $jsxHL = parcelRequire("jsxHL");

var $8nFt2 = parcelRequire("8nFt2");

var $9KOR3 = parcelRequire("9KOR3");

var $iOXki = parcelRequire("iOXki");

var $gWusH = parcelRequire("gWusH");

var $635dy = parcelRequire("635dy");
const $b0045c9e2971c8ff$var$wrapSubnav = (subnav)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "none",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1rjc1jfw _18zr1jfw"
                    ]),
                    children: subnav
                })
            })
        })
    });
};
const $b0045c9e2971c8ff$var$LoomLogoComponent = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "loomcircular",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
};
const $b0045c9e2971c8ff$export$e9541932877c1f74 = ()=>{
    const intl = (0, $8e22h.default)();
    const dropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: 'fit-content !important',
            margin: 0,
            insetBlockStart: '4.25rem',
            transform: 'translateX(-25%)'
        };
    }, []);
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=loom&edition=premium');
    const resourcesHref = (0, $jQ0cd.useLocalizedHref)('/software/loom/resources');
    const guidesHref = (0, $jQ0cd.useLocalizedHref)('/software/loom/resources/guides/getting-started');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/loom/pricing');
    const links = [
        {
            globalLinksKey: 'features',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.features',
                defaultMessage: 'Features'
            }),
            hasSubnav: true,
            content: $b0045c9e2971c8ff$var$wrapSubnav(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $gWusH.LoomFeaturesSubnav), {})),
            containerPosition: 'relative'
        },
        {
            globalLinksKey: 'solutions',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.resources',
                defaultMessage: 'Solutions'
            }),
            hasSubnav: true,
            containerStyles: dropdownStyles,
            content: $b0045c9e2971c8ff$var$wrapSubnav(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $635dy.LoomSolutionsSubnav), {})),
            containerPosition: 'relative'
        },
        {
            globalLinksKey: 'resources',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.useCases',
                defaultMessage: 'Resources'
            }),
            hasSubnav: false,
            href: resourcesHref
        },
        {
            globalLinksKey: 'guides',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.guides',
                defaultMessage: 'Guides'
            }),
            hasSubnav: false,
            href: guidesHref
        },
        {
            globalLinksKey: 'pricing',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.pricing',
                defaultMessage: 'Pricing'
            }),
            hasSubnav: false,
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
        productKey: 'loom',
        productLogoUrl: "/software/loom",
        productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($b0045c9e2971c8ff$var$LoomLogoComponent, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: 'LoomPageTemplate.navbar.loom-logo',
            defaultMessage: 'Loom logo'
        }),
        mobileCtaText: intl.formatMessage({
            id: 'LoomPageTemplate.navbar.getitfree',
            defaultMessage: 'Get it Free'
        }),
        navigationTrynowCtaText: intl.formatMessage({
            id: 'LoomPageTemplate.navbar.getitfree',
            defaultMessage: 'Get it Free'
        }),
        mobileCtaUrl: signupLink,
        mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($b0045c9e2971c8ff$var$LoomLogoComponent, {}),
        productPageNavLinks: links,
        navigationTrynowCtaUrl: signupLink,
        mobileLinksSections: [
            {
                mobileLinkKey: 'mobile-loom',
                mobileLinksProps: links
            }
        ],
        additionalMenuPageObjectsArray: [
            {
                menuPageKey: 'features',
                menuPageObjects: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gWusH.LoomFeaturesSubnav), {})
            },
            {
                menuPageKey: 'solutions',
                menuPageObjects: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $635dy.LoomSolutionsSubnav), {})
            }
        ]
    });
};
var $b0045c9e2971c8ff$export$2e2bcd8739ae039 = $b0045c9e2971c8ff$export$e9541932877c1f74;

});
parcelRegister("gWusH", function(module, exports) {
$parcel$export(module.exports, "LoomFeaturesSubnav", function () { return $d35e5cc4cca0feb2$export$a7a6399eaf95e9b8; });
/* features-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $dfBhn = parcelRequire("dfBhn");
const $d35e5cc4cca0feb2$export$a7a6399eaf95e9b8 = ()=>{
    const intl = (0, $8e22h.default)();
    const productKey = 'loom';
    const loomLinks = {
        features: {
            id: 'features',
            title: (0, $fnHPc.defineMessage)({
                id: 'bitbucketnav.subnav.loomFeatures.links.features',
                defaultMessage: 'Explore Features'
            }),
            items: [
                {
                    id: 'meeting-notes',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.meeting-notes',
                        defaultMessage: 'Meeting Notes'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/ai-meeting')
                },
                {
                    id: 'screen-recorder',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.screen-recorder',
                        defaultMessage: 'Screen Recorder'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/screen-recorder')
                },
                {
                    id: 'screenshots',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.screenshots',
                        defaultMessage: 'Screenshots'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/screenshot')
                },
                {
                    id: 'loom-ai',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.loom-ai',
                        defaultMessage: 'Loom AI'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/ai')
                },
                {
                    id: 'editing',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.editing',
                        defaultMessage: 'Editing'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/editing')
                }
            ]
        }
    };
    const linkColumns = Object.values(loomLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: linkColumns.map((column)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1p1dangw _syazsjoz _1wyboqnp _ect4z4z1 _k48p1fw0 _vwz41j6v"
                        ]),
                        style: {
                            "--_8vca0i": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark0')),
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: intl.formatMessage(column.title)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _umai1ylp"
                        ]),
                        children: column.items.map((link)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_bpsp1nn1 _19tboxwj _43dssjoz _qfs11r31 _s41oglyw _1k6pnqa1 _1caysjoz _1e0c1txw _4cvrh9n0"
                                ]),
                                style: {
                                    "--_8vca0i": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark0'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    type: "anchor",
                                    href: link.href,
                                    text: intl.formatMessage(link.text),
                                    ariaLabel: intl.formatMessage(link.text),
                                    dataEventProps: {
                                        'data-event': 'clicked',
                                        'data-event-component': 'linkButton',
                                        'data-event-container': 'globalNavSubnav',
                                        'data-product-key': productKey
                                    }
                                })
                            }, link.id);
                        })
                    })
                ]
            }, column.id);
        })
    });
};

});

parcelRegister("635dy", function(module, exports) {
$parcel$export(module.exports, "LoomSolutionsSubnav", function () { return $7ae29eaf01c2e45b$export$e7b21fd28cd3f276; });
/* solutions-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $8nFt2 = parcelRequire("8nFt2");

var $jgdMW = parcelRequire("jgdMW");

var $dfBhn = parcelRequire("dfBhn");

var $9KOR3 = parcelRequire("9KOR3");
function $7ae29eaf01c2e45b$var$useLoomSolutionsLinks() {
    return {
        features: {
            id: 'teams',
            title: (0, $fnHPc.defineMessage)({
                id: 'loom-product-nav.solutions.links.solution',
                defaultMessage: 'Teams'
            }),
            items: [
                {
                    id: 'sales',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.sales',
                        defaultMessage: 'Sales'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/sales')
                },
                {
                    id: 'marketing',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.marketing',
                        defaultMessage: 'Marketing'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/marketing')
                },
                {
                    id: 'design',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.design',
                        defaultMessage: 'Design'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/design')
                },
                {
                    id: 'support',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.support',
                        defaultMessage: 'Support'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/support')
                },
                {
                    id: 'productmanagement',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.product-management',
                        defaultMessage: 'Product Management'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/product-management')
                },
                {
                    id: 'engineering',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.engineering',
                        defaultMessage: 'Engineering'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/engineering')
                }
            ]
        },
        usecases: {
            id: 'usecases',
            title: (0, $fnHPc.defineMessage)({
                id: 'loom-product-nav.solutions.links.use-cases',
                defaultMessage: 'Use cases'
            }),
            items: [
                {
                    id: 'loom-jira',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.loom-jira',
                        defaultMessage: 'Loom + Jira'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/loom-jira')
                },
                {
                    id: 'loom-confluence',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.loom-confluence',
                        defaultMessage: 'Loom + Confluence'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/loom-confluence')
                }
            ]
        },
        companysize: {
            id: 'companysize',
            title: (0, $fnHPc.defineMessage)({
                id: 'loom-product-nav.solutions.links.company-size',
                defaultMessage: 'Company Size'
            }),
            items: [
                {
                    id: 'enterprise',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.enterprise',
                        defaultMessage: 'Enterprise'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/enterprise')
                }
            ]
        }
    };
}
const $7ae29eaf01c2e45b$export$e7b21fd28cd3f276 = ({ productKey: productKey = 'loom' })=>{
    const intl = (0, $8e22h.default)();
    const loomSolutionLinks = $7ae29eaf01c2e45b$var$useLoomSolutionsLinks();
    const linkColumns = Object.values(loomSolutionLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhk1afi _fn1q1txw _12nx1bp4 _196i1ylp"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                        numCols: 3,
                        columnGap: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1p1dangw _syaz1pfd _1wyboqnp _ect4z4z1 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _umai1ylp"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1pfd _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1pfd _oavvftjs _oxk4ftjs _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        'data-event': 'clicked',
                                                        'data-event-component': 'linkButton',
                                                        'data-event-container': 'globalNavSubnav',
                                                        'data-product-key': productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("3wzIU", function(module, exports) {
$parcel$export(module.exports, "RovoNav", function () { return $d94e8e579fb0c00d$export$f7b51e35c95f667c; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3o1l4 = parcelRequire("3o1l4");

var $bQjAr = parcelRequire("bQjAr");

var $2WL8B = parcelRequire("2WL8B");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $iOXki = parcelRequire("iOXki");

var $3riD8 = parcelRequire("3riD8");
const $d94e8e579fb0c00d$export$f7b51e35c95f667c = ()=>{
    const intl = (0, $8e22h.default)();
    const navLinks = [
        {
            globalLinksKey: 'features',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.features',
                defaultMessage: 'Features'
            }),
            hasSubnav: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/software/rovo/features')
        },
        {
            globalLinksKey: 'connectors',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.connectors',
                defaultMessage: 'Connectors'
            }),
            hasSubnav: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/software/rovo/connectors')
        },
        {
            globalLinksKey: 'use-cases',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.use-cases',
                defaultMessage: 'Use cases'
            }),
            hasSubnav: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/software/rovo/use-cases')
        },
        {
            globalLinksKey: 'guides',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.guides',
                defaultMessage: 'Guides'
            }),
            hasSubnav: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/software/rovo/guides/end-user-guide/introduction')
        },
        {
            globalLinksKey: 'licensing',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.licensing',
                defaultMessage: 'Licensing'
            }),
            hasSubnav: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/licensing/rovo')
        }
    ];
    const { requestInProgress: requestInProgress } = (0, $3riD8.useLoggedInUser)();
    const { data: userSegments } = (0, $3o1l4.useUserSegments)();
    const isRovoEnabledCohort = (0, $2WL8B.useRovoEnabledCohort)();
    const isRovoInPlanList = userSegments?.[(0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS]?.includes('rovo.ondemand');
    const defaultCTAUrl = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=teamwork-collection&primaryCollectionProduct=rovo.ondemand&edition=premium');
    const isUserLoggedInAndCtasEnabledAndInPlan = isRovoInPlanList;
    const ctaText = intl.formatMessage({
        id: 'RovoPageTemplate.navbar.cta.try-rovo',
        defaultMessage: 'Try Rovo'
    });
    const tryNowCTAUrl = isUserLoggedInAndCtasEnabledAndInPlan ? 'https://home.atlassian.com/chat' : defaultCTAUrl;
    const isShowTryNowLink = !requestInProgress && tryNowCTAUrl && ctaText ? true : false;
    const buttonVariant = isRovoEnabledCohort ? 'secondary' : 'primary';
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    const rovoLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "rovo",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "RovoNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogoUrl: "/software/rovo",
            productLogo: rovoLogo,
            productLogoAriaLabel: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.rovo-logo',
                defaultMessage: 'Rovo logo'
            }),
            mobileLogo: rovoLogo,
            isShowTryNowLink: isShowTryNowLink,
            isIncludeMobileCTA: isShowTryNowLink,
            navigationTrynowCtaText: isShowTryNowLink ? ctaText : undefined,
            navigationTrynowCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            navigationTrynowCtaButtonVariant: buttonVariant,
            mobileCtaText: isShowTryNowLink ? ctaText : undefined,
            mobileCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            mobileCtaButtonVariant: buttonVariant,
            productPageNavLinks: navLinks,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-rovo',
                    mobileLinksProps: navLinks
                }
            ]
        })
    });
};

});

parcelRegister("9xKEy", function(module, exports) {
$parcel$export(module.exports, "ChatWidgetProvider", function () { return $c6548387155117f6$export$a4cac963ae9f34ca; });
$parcel$export(module.exports, "default", function () { return $c6548387155117f6$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jIe84 = parcelRequire("jIe84");
var $ac0eX = parcelRequire("ac0eX");
var $6NMje = parcelRequire("6NMje");
var $aCV3p = parcelRequire("aCV3p");

var $fuLgT = parcelRequire("fuLgT");

var $6e3tU = parcelRequire("6e3tU");

var $7qFQI = parcelRequire("7qFQI");

var $lP7A9 = parcelRequire("lP7A9");

var $kbpa7 = parcelRequire("kbpa7");

var $j2b52 = parcelRequire("j2b52");

var $gx3aw = parcelRequire("gx3aw");

var $3riD8 = parcelRequire("3riD8");

var $kEjoI = parcelRequire("kEjoI");

// Load omni-channel UI only on the client when widget is open to avoid SSR 503 (Tesseract)
const $c6548387155117f6$var$ChatWidgetOmniChannelUI = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("fIsSj")));

// Lazy-load analytics when fetchChatConnectionConfig succeeds (keeps @atlassian/omni-channel out of main bundle)
const $c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("20zL1")));

// Lazy-load analytics when fetchToken fails (same chunk as customer-joined analytics)
const $c6548387155117f6$var$ChatWidgetTokenErrorAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("20zL1")).then((m)=>({
            default: m.ChatWidgetTokenErrorAnalytics
        })));

// Lazy-load analytics when fetchChatConnectionConfig succeeds
const $c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("20zL1")).then((m)=>({
            default: m.ChatWidgetConnectionConfigSuccessAnalytics
        })));

// Lazy-load analytics when fetchToken succeeds (channelPlatformTokenError empty or null)
const $c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("20zL1")).then((m)=>({
            default: m.ChatWidgetTokenSuccessAnalytics
        })));
const $c6548387155117f6$export$8a240b2f27c2948f = (url)=>{
    try {
        const urlObj = new URL(url);
        let pathname = urlObj.pathname.replace(/\/+$/, '');
        if (pathname.startsWith('/wac/')) pathname = pathname.slice(4);
        return pathname.replace(/^\/+/, '');
    } catch  {
        const match = /\/\/[^/]+(\/[^#?]*)/.exec(url);
        if (match?.[1]) {
            let pathname = match[1].replace(/\/+$/, '');
            if (pathname.startsWith('/wac/')) pathname = pathname.slice(4);
            return pathname.replace(/^\/+/, '');
        }
        return '';
    }
};
const $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH = {
    'software/jira/product-discovery': {
        contactFlowId: "39457874-4e30-4774-89a6-e086842bdcb6",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/jira/service-management': {
        contactFlowId: "39457874-4e30-4774-89a6-e086842bdcb6",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/jira': {
        contactFlowId: "1825e6f7-75fc-47e2-b634-98923fa4a3b1",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom': {
        contactFlowId: "dc335c33-9da5-4291-842b-80956f53d2b7",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/loom-confluence': {
        contactFlowId: "7cf56869-3db7-431e-8311-b524e6065934",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/loom-jira': {
        contactFlowId: "199f4750-6436-4b88-a2db-c2b87c1bdaed",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/resources': {
        contactFlowId: "eadd2afc-29bb-4e9c-a0d6-370fd70186eb",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/ai-meeting': {
        contactFlowId: "364f6abb-5628-41c1-bf90-b3ca2486378d",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/editing': {
        contactFlowId: "a4addd51-eb96-46fc-b5a9-3f99c3d923de",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/company/contact/japan': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/jira/service-management': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/jira/pricing': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    ja: {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/confluence': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/confluence/pricing': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/jira/service-management/pricing': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    }
};
const $c6548387155117f6$export$a8ad7472af635967 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    return $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath] ?? {
        contactFlowId: ''
    };
};
const $c6548387155117f6$export$b28607ea792e8283 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && Array.isArray(entry.formKey)) return entry.formKey;
    return [
        ''
    ];
};
const $c6548387155117f6$export$39f87d2399b576ea = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && typeof entry.attributes === 'object' && entry.attributes !== null) return JSON.stringify(entry.attributes, null, 2);
    return '{}';
};
const $c6548387155117f6$export$c452173f1b4082d7 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    return normalizedPath === 'ja' || normalizedPath.startsWith('ja/');
};
const $c6548387155117f6$export$8378cdc69cfc311a = (url)=>{
    try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        // Remove leading and trailing slashes, then split by '/' and filter out empty strings
        const pathParts = pathname.replace(/^\/+|\/+$/g, '').split('/').filter((part)=>part.length > 0);
        // Join with underscores
        return pathParts.join('_');
    } catch  {
        // If URL parsing fails, try to extract path manually
        const match = /\/\/[^\/]+(\/[^?#]*)/.exec(url);
        if (match && match[1]) {
            const pathname = match[1];
            const pathParts = pathname.replace(/^\/+|\/+$/g, '').split('/').filter((part)=>part.length > 0);
            return pathParts.join('_');
        }
        return '';
    }
};
const $c6548387155117f6$export$2b66390f6eecea5c = (payload)=>{
    const transformed = {};
    if (!payload) return transformed;
    Object.entries(payload).forEach(([key, value])=>{
        // Skip attachments
        if (key === 'attachments') return;
        // Skip null or undefined values
        if (value === null || value === undefined) return;
        // Handle arrays - normalize to array of strings
        if (Array.isArray(value)) transformed[key] = value.map((v)=>{
            // If array element is an object (like {userEmail: "value"}), extract the first value
            if (typeof v === 'object' && v !== null && !Array.isArray(v)) {
                const firstValue = Object.values(v)[0];
                return firstValue !== undefined ? String(firstValue) : String(v);
            }
            // Already a string or primitive
            return String(v);
        });
        else transformed[key] = [
            String(value)
        ];
    });
    return transformed;
};
const $c6548387155117f6$export$a40d7197cc58cf92 = (payload)=>{
    return JSON.stringify(payload);
};
const $c6548387155117f6$export$b13b32483d23f773 = (formValues, flowId, analyticsSessionId)=>{
    const metadata = {};
    if (analyticsSessionId) metadata['analyticsSessionId'] = analyticsSessionId;
    // Only include flowId if it has a value
    if (flowId) metadata['flowId'] = flowId;
    if (formValues?.contactEmail) metadata['email'] = formValues.contactEmail;
    return JSON.stringify(metadata);
};
const $c6548387155117f6$export$6999922c2cdd8944 = (chatConnectionConfigResponse)=>{
    const submitRequest = chatConnectionConfigResponse?.channelPlatform_createContact;
    return {
        channelPlatform_submitRequest: submitRequest
    };
};
function $c6548387155117f6$export$c0c7c314cc68764f(config) {
    const contact = config?.channelPlatform_createContact;
    return contact?.value?.contactId;
}
function $c6548387155117f6$export$f0671fd2506d780c(config) {
    const contact = config?.channelPlatform_createContact;
    const value = contact?.value;
    return {
        contactId: value?.contactId,
        participantId: value?.participantId,
        region: value?.region
    };
}
function $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail, isUserLoggedIn) {
    return {
        cst_support_forms_data_fieldDescMap: [
            '{"inquiry_category":"Inquiry Category","email":"Email","raised_obo_by":"Raised on behalf of by","language":"language","customer_working_hours":"Support Business Hours Select"}'
        ],
        customer_email: [
            isUserLoggedIn ? userEmail : ''
        ],
        authenticated: isUserLoggedIn ? null : [
            'No'
        ],
        email: [
            isUserLoggedIn ? userEmail : ''
        ],
        customer_status: [
            'Customer'
        ],
        cst_support_forms_data_formKey: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_formLabel: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_timezone: [
            'GMT+6'
        ],
        referral_url: [
            window.location.href
        ],
        language: [
            'en'
        ],
        is_partner_dc_exception: [
            'Customer not in SFDC'
        ],
        topic: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href)
        ],
        summary: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href).split('_').join(' ')
        ],
        support_channel: [
            'chat'
        ],
        inquiry_category: [
            'access_issues'
        ],
        cst_support_forms_data_contextId: [
            contextId
        ]
    };
}
function $c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasOpenCurrent, clientToken, clientWithToken) {
    return isWidgetOpen && !wasOpenCurrent && !!clientToken && !!clientWithToken;
}
function $c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn) {
    return {
        flowId: $c6548387155117f6$export$a8ad7472af635967($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)).contactFlowId,
        formContext: {
            summary: [
                'Chat Transcript for <email removed for privacy>'
            ],
            details: '',
            contactEmail: isUserLoggedIn ? userEmail ?? '' : '',
            isAuthenticated: isUserLoggedIn
        }
    };
}
function $c6548387155117f6$var$hasCustomerConversations(response) {
    const count = response?.channelPlatform_getCustomerConversations?.conversations?.length ?? 0;
    return count > 0;
}
function $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded) {
    const isChatLoaded = isWidgetOpen && !!clientToken && !!chatConnectionConfig && isCustomerComponentLoaded;
    return {
        isChatLoaded: isChatLoaded,
        showFloatingButton: !isChatLoaded,
        isButtonLoading: isWidgetOpen && (!clientToken || !chatConnectionConfig || !isCustomerComponentLoaded)
    };
}
const $c6548387155117f6$var$ChatFloatingButton = ({ isLoading: isLoading, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "button",
        tabIndex: 0,
        "aria-label": isLoading ? 'Loading chat' : 'Open chat widget',
        style: {
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 1000,
            cursor: isLoading ? 'wait' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '56px',
            height: '56px',
            borderRadius: '50%',
            backgroundColor: (0, $kbpa7.wacToken)('color.primary.blue'),
            color: 'white',
            boxShadow: (0, $lP7A9.default)('elevation.shadow.raised')
        },
        onClick: onClick,
        onKeyDown: onKeyDown,
        children: isLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            size: "medium",
            label: "Loading chat",
            appearance: "invert"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6e3tU))), {
            label: "",
            size: "medium",
            color: "currentColor"
        })
    });
};

function $c6548387155117f6$var$useChatWidgetConnection({ isWidgetOpen: isWidgetOpen, contextId: contextId, userEmail: userEmail, isUserLoggedIn: isUserLoggedIn, setIsCustomerComponentLoaded: setIsCustomerComponentLoaded }) {
    const [clientToken, setClientToken] = (0, $1oC0p.useState)(null);
    const [chatConnectionConfig, setChatConnectionConfig] = (0, $1oC0p.useState)(null);
    const [loading, setLoading] = (0, $1oC0p.useState)(false);
    const [error, setError] = (0, $1oC0p.useState)(null);
    const [channelPlatformTokenError, setChannelPlatformTokenError] = (0, $1oC0p.useState)(null);
    const [customerConversationsResponse, setCustomerConversationsResponse] = (0, $1oC0p.useState)(null);
    const generateAuthHeader = (channelsIdentityHash)=>new (0, $ac0eX.ApolloLink)((operation, forward)=>{
            operation.setContext(({ headers: headers = {} })=>({
                    headers: {
                        ...headers,
                        'Content-Type': 'application/json',
                        'X-Client-Hash': channelsIdentityHash
                    }
                }));
            return forward(operation);
        });
    const client = (0, $1oC0p.useMemo)(()=>{
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: 'include'
        });
        return new (0, $jIe84.ApolloClient)({
            link: link,
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, []);
    const wasWidgetOpenRef = (0, $1oC0p.useRef)(false);
    const clientWithToken = (0, $1oC0p.useMemo)(()=>{
        if (!clientToken) return null;
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: 'include'
        });
        return new (0, $jIe84.ApolloClient)({
            link: (0, $ac0eX.ApolloLink).from([
                generateAuthHeader(clientToken),
                link
            ]),
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, [
        clientToken
    ]);
    const isRefreshed = (0, $1oC0p.useMemo)(()=>$c6548387155117f6$var$hasCustomerConversations(customerConversationsResponse), [
        customerConversationsResponse
    ]);
    const fetchCustomerConversations = (0, $1oC0p.useCallback)(()=>{
        if (!clientWithToken) return;
        const anonymousId = (0, $gx3aw.Cookie).readCookie('ajs_anonymous_id') || '';
        clientWithToken.query({
            query: (0, $kEjoI.getCustomerConversations),
            variables: {
                anonymousId: anonymousId
            }
        }).then((response)=>{
            setCustomerConversationsResponse(response?.data ?? null);
        }).catch((err)=>{
            console.warn('Error fetching customer conversations:', err);
            setCustomerConversationsResponse(null);
        });
    }, [
        clientWithToken
    ]);
    const fetchChatConnectionConfig = (0, $1oC0p.useCallback)(async ()=>{
        if (!clientWithToken) {
            console.warn('Client with token not available yet');
            return;
        }
        setLoading(true);
        const formValues = $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail ?? '', isUserLoggedIn);
        // Dynamic import to avoid pulling @atlassiansox/analytics-web-client
        // (which calls setTimeout at module init) into the SSR bundle.
        const { getAnalyticsWebClient: getAnalyticsWebClient } = await (parcelRequire("ix6JR"));
        const metadataPayload = $c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn);
        const metadata = $c6548387155117f6$export$b13b32483d23f773({
            contactEmail: metadataPayload.formContext['contactEmail']
        }, metadataPayload.flowId, getAnalyticsWebClient().getCurrentSessionId());
        clientWithToken.query({
            query: (0, $kEjoI.getChatConnectionConfigForSalesChannel),
            variables: {
                requestType: 'CHAT',
                payload: $c6548387155117f6$export$2b66390f6eecea5c(formValues),
                metadata: metadata,
                attributes: JSON.parse($c6548387155117f6$export$39f87d2399b576ea($c6548387155117f6$export$8a240b2f27c2948f(window.location.href))) ?? {},
                anonymousId: (0, $gx3aw.Cookie).readCookie('ajs_anonymous_id') || ''
            }
        }).then((response)=>{
            setChatConnectionConfig(response?.data);
            setLoading(false);
        }).catch((err)=>{
            console.error('Error fetching chat connection config:', err);
            setError(err);
            setLoading(false);
        });
    }, [
        clientWithToken,
        contextId,
        isUserLoggedIn,
        userEmail
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if ($c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasWidgetOpenRef.current, clientToken, clientWithToken)) {
            wasWidgetOpenRef.current = true;
            fetchCustomerConversations();
            fetchChatConnectionConfig();
        }
        if (!isWidgetOpen) {
            wasWidgetOpenRef.current = false;
            setIsCustomerComponentLoaded(false);
        }
    }, [
        isWidgetOpen,
        clientToken,
        clientWithToken,
        fetchCustomerConversations,
        fetchChatConnectionConfig,
        setIsCustomerComponentLoaded
    ]);
    const fetchToken = (0, $1oC0p.useCallback)(()=>{
        setLoading(true);
        client.query({
            query: (0, $kEjoI.getChannelPlatformTokenByClientName),
            variables: {
                clientName: 'sales'
            }
        }).then((response)=>{
            const token = response.data?.supportInquiry_channelsIdentityHashByClientName;
            if (token) {
                setClientToken(token);
                setChannelPlatformTokenError(null);
            }
            setLoading(false);
        }).catch((err)=>{
            console.error('Error fetching channel platform token:', err);
            setError(err);
            setLoading(false);
            const errorMessage = err instanceof Error ? err.message : String(err);
            setChannelPlatformTokenError(errorMessage);
        });
    }, [
        client
    ]);
    return {
        clientToken: clientToken,
        chatConnectionConfig: chatConnectionConfig,
        loading: loading,
        error: error,
        channelPlatformTokenError: channelPlatformTokenError,
        client: client,
        clientWithToken: clientWithToken,
        isRefreshed: isRefreshed,
        customerConversationsResponse: customerConversationsResponse,
        setClientToken: setClientToken,
        fetchToken: fetchToken
    };
}
const $c6548387155117f6$export$a4cac963ae9f34ca = ({ children: children })=>{
    const [isWidgetOpen, setIsWidgetOpen] = (0, $1oC0p.useState)(false);
    const [isCustomerComponentLoaded, setIsCustomerComponentLoaded] = (0, $1oC0p.useState)(false);
    const { accountId: aaid, email: userEmail, isUserLoggedIn: isUserLoggedIn } = (0, $3riD8.useLoggedInUser)();
    const contextId = (0, $1oC0p.useMemo)(()=>(0, $fuLgT.default)(), []);
    const connection = $c6548387155117f6$var$useChatWidgetConnection({
        isWidgetOpen: isWidgetOpen,
        contextId: contextId,
        userEmail: userEmail,
        isUserLoggedIn: isUserLoggedIn,
        setIsCustomerComponentLoaded: setIsCustomerComponentLoaded
    });
    const { clientToken: clientToken, chatConnectionConfig: chatConnectionConfig, loading: loading, error: error, channelPlatformTokenError: channelPlatformTokenError, isRefreshed: isRefreshed, customerConversationsResponse: customerConversationsResponse } = connection;
    const surveyModalAttributes = {
        width: '80%',
        height: 500
    };
    const omniChannelEnv = 'production';
    const handleChatButtonClick = ()=>{
        const opening = !isWidgetOpen;
        setIsWidgetOpen(opening);
        if (opening) connection.fetchToken();
    };
    const handleChatButtonKeyDown = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleChatButtonClick();
        }
    };
    const viewState = $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded);
    const showChatPanel = isWidgetOpen && !!chatConnectionConfig && !!clientToken;
    const conversationId = $c6548387155117f6$export$c0c7c314cc68764f(chatConnectionConfig);
    const connectionConfigAttributes = $c6548387155117f6$export$f0671fd2506d780c(chatConnectionConfig);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                children,
                chatConnectionConfig && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics, {
                            conversationId: conversationId
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics, {
                            contactId: connectionConfigAttributes.contactId,
                            participantId: connectionConfigAttributes.participantId,
                            region: connectionConfigAttributes.region
                        })
                    ]
                }),
                channelPlatformTokenError && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenErrorAnalytics, {
                        channelPlatformTokenError: channelPlatformTokenError
                    })
                }),
                clientToken && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics, {
                        clientToken: clientToken,
                        channelPlatformTokenError: channelPlatformTokenError
                    })
                }),
                viewState.showFloatingButton && /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatFloatingButton, {
                    isLoading: viewState.isButtonLoading,
                    onClick: handleChatButtonClick,
                    onKeyDown: handleChatButtonKeyDown
                }),
                showChatPanel && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetOmniChannelUI, {
                        env: omniChannelEnv,
                        clientIdentityHash: clientToken || '',
                        chatContactDetails: $c6548387155117f6$export$6999922c2cdd8944(chatConnectionConfig),
                        accountId: aaid || '',
                        isRefreshed: isRefreshed,
                        customerConversations: customerConversationsResponse,
                        loading: loading,
                        error: error,
                        isUserLoggedIn: isUserLoggedIn,
                        surveyModalAttributes: surveyModalAttributes,
                        onLoaded: ()=>setIsCustomerComponentLoaded(true)
                    })
                })
            ]
        })
    });
};
var $c6548387155117f6$export$2e2bcd8739ae039 = $c6548387155117f6$export$a4cac963ae9f34ca;

});
parcelRegister("6e3tU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4886c0393fe869b5$var$_react = $4886c0393fe869b5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4886c0393fe869b5$var$_baseNew = $4886c0393fe869b5$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $4886c0393fe869b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4886c0393fe869b5$var$CommentIcon = (props)=>/*#__PURE__*/ $4886c0393fe869b5$var$_react.default.createElement($4886c0393fe869b5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$4886c0393fe869b5$var$CommentIcon.displayName = 'CommentIcon';
var $4886c0393fe869b5$var$_default = module.exports.default = $4886c0393fe869b5$var$CommentIcon;

});

parcelRegister("kEjoI", function(module, exports) {
$parcel$export(module.exports, "getChatConnectionConfigForSalesChannel", function () { return $59b9792633dffc77$export$2fedc4b0d22f20b3; });
$parcel$export(module.exports, "getCustomerConversations", function () { return $59b9792633dffc77$export$54e9b7f1aad2199a; });
$parcel$export(module.exports, "getChannelPlatformTokenByClientName", function () { return $59b9792633dffc77$export$c543cd67c9b21e36; });

var $4Wqet = parcelRequire("4Wqet");
const $59b9792633dffc77$export$51e62cbd534f416c = (0, $4Wqet.gql)`
	query channelPlatformTokenGeneration {
		supportInquiry_channelsIdentityHash
	}
`;
const $59b9792633dffc77$export$2fedc4b0d22f20b3 = (0, $4Wqet.gql)`
	query CreateContact(
		$requestType: ChannelPlatformChannelType!
		$payload: JSON
		$metadata: JSON
		$anonymousId: String
		$attributes: JSON
	) {
		channelPlatform_createContact(
			requestType: $requestType
			request: { payload: $payload, metadata: $metadata, attributes: $attributes }
			anonymousId: $anonymousId
		) {
			channel
			value {
				... on ChannelPlatformGetChannelTokenResponse {
					participantId
					participantToken
					region
					contactId
				}
			}
		}
	}
`;
const $59b9792633dffc77$export$54e9b7f1aad2199a = (0, $4Wqet.gql)`
	query CustomerConversations($anonymousId: String) {
		channelPlatform_getCustomerConversations(anonymousId: $anonymousId) {
			conversations
		}
	}
`;
const $59b9792633dffc77$export$f843774d31ce9c0c = (0, $4Wqet.gql)`
	query CreateContact($requestType: ChannelPlatformChannelType!, $payload: JSON, $metadata: JSON) {
		channelPlatform_createContact(
			requestType: $requestType
			request: { payload: $payload, metadata: $metadata }
		) {
			channel
			value {
				... on ChannelPlatformGetChannelTokenResponse {
					participantId
					participantToken
					region
					contactId
				}
			}
		}
	}
`;
const $59b9792633dffc77$export$c543cd67c9b21e36 = (0, $4Wqet.gql)`
	query channelPlatformTokenGenerationByClientName($clientName: String) {
		supportInquiry_channelsIdentityHashByClientName(request: { clientName: $clientName })
	}
`;

});

parcelRegister("fIsSj", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("Oum3S"),
    $eao4m("2TJ5h"),
    $eao4m("kR81y"),
    $eao4m("iIUqB"),
    $eao4m("1Wq12"),
    $eao4m("69gSk"),
    $eao4m("cnHw8"),
    $eao4m("jE0qd"),
    $eao4m("jVFeq"),
    $eao4m("9XBPx"),
    $eao4m("4xgbV"),
    $eao4m("iYBBz"),
    $eao4m("ci8gQ"),
    $eao4m("erzni"),
    $eao4m("kTTjG"),
    $eao4m("gsjcw"),
    $eao4m("ch50F"),
    $eao4m("DSYwq"),
    $eao4m("6Z2Oj"),
    $eao4m("am6H8"),
    $eao4m("76kmj")
]).then(()=>parcelRequire('8Cs4z'));

});

parcelRegister("20zL1", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("jVFeq"),
    $eao4m("9XBPx"),
    $eao4m("hx68B")
]).then(()=>parcelRequire('cJIcN'));

});

parcelRegister("ix6JR", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("4lJtX").then(()=>parcelRequire('k1dhr'));

});


parcelRegister("dTPlE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1e83e1969f37e79$var$_react = $a1e83e1969f37e79$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a1e83e1969f37e79$var$_baseNew = $a1e83e1969f37e79$var$_interopRequireDefault((parcelRequire("jcI35")));
function $a1e83e1969f37e79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1e83e1969f37e79$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a1e83e1969f37e79$var$_react.default.createElement($a1e83e1969f37e79$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a1e83e1969f37e79$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a1e83e1969f37e79$var$_default = module.exports.default = $a1e83e1969f37e79$var$PageLiveDocIcon;

});

parcelRegister("grkXZ", function(module, exports) {
$parcel$export(module.exports, "DropdownSelector", function () { return $7df351058cf48215$export$67ffdcf8cfce0fd; });
/* dropdown-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kKAAc = parcelRequire("kKAAc");
const $7df351058cf48215$var$dropdownSelectorContainerStyle = null;
const $7df351058cf48215$var$labelStyle = null;
const $7df351058cf48215$var$labelStyleSignup = null;
const $7df351058cf48215$export$67ffdcf8cfce0fd = ({ options: options, name: name, id: id, testId: testId, label: label, onChangeHandler: onChangeHandler, defaultValue: defaultValue, cssOverrides: cssOverrides, className: className })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $1oC0p.useState)(false);
    const elementID = id ? id : `${name}-dropdown`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c116y _2lx21bp4 _1bsb1osq",
            className
        ]),
        children: [
            cssOverrides?.labelStyle === 'signup' && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: elementID,
                className: (0, $2jatx.default)([
                    "_syazvwuj _vwz41gnr _6rth1b66 _y3gn1e5h _k48pbfng _1wybdlk8"
                ]),
                children: label
            }),
            !cssOverrides?.labelStyle && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: elementID,
                className: (0, $2jatx.default)([
                    "_syazvwuj _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                ]),
                children: label
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: "select-dropdown-container",
                "data-testid": testId ? testId : elementID,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kKAAc.default), {
                    defaultValue: defaultValue || {
                        label: 'Select...',
                        value: ''
                    },
                    options: options,
                    unstyled: true,
                    inputId: elementID,
                    onChange: (selectedOption)=>{
                        onChangeHandler?.(selectedOption?.value || '');
                    },
                    onMenuOpen: ()=>setIsMenuOpen(true),
                    onMenuClose: ()=>setIsMenuOpen(false),
                    styles: {
                        // @ts-ignore
                        container: (provided)=>({
                                ...provided,
                                appearance: 'none',
                                flexDirection: 'row',
                                fontSize: '1rem',
                                lineHeight: '1.2',
                                textAlign: 'left',
                                ...(cssOverrides || {}).container
                            }),
                        // @ts-ignore
                        singleValue: (provided)=>({
                                ...provided,
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)",
                                ...(cssOverrides || {}).singleValue
                            }),
                        // @ts-ignore
                        placeholder: (provided)=>({
                                ...provided,
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)",
                                ...(cssOverrides || {}).placeholder
                            }),
                        // @ts-ignore
                        valueContainer: (provided)=>({
                                ...provided,
                                paddingLeft: "var(--ds-space-075, 6px)",
                                paddingRight: "var(--ds-space-075, 6px)",
                                ...(cssOverrides || {}).valueContainer
                            }),
                        // @ts-ignore
                        menu: (provided)=>({
                                ...provided,
                                marginTop: "var(--ds-space-050, 4px)",
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                boxShadow: '0px 3px 5px 0px #091E4233',
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                background: '#ffffff',
                                padding: 0,
                                borderRadius: "var(--ds-space-050, 4px)",
                                ...(cssOverrides || {}).menu
                            }),
                        // @ts-ignore
                        control: (provided, state)=>({
                                ...provided,
                                cursor: 'pointer',
                                backgroundColor: isMenuOpen ? '#253858' : '#FAFBFC',
                                color: isMenuOpen ? '#ffffff' : '#172B4D',
                                height: '2.65rem',
                                border: state.isFocused ? `2px solid #4C9AFF` : `2px solid #dfe1e6`,
                                borderRadius: "var(--ds-space-050, 4px)",
                                '&:hover': {
                                    background: isMenuOpen ? undefined : '#F4F5F7'
                                },
                                ...(cssOverrides || {}).control
                            }),
                        // @ts-ignore
                        dropdownIndicator: (provided, state)=>({
                                ...provided,
                                transition: 'all .2s ease',
                                transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : undefined,
                                ...(cssOverrides || {}).dropdownIndicator
                            }),
                        // @ts-ignore
                        indicatorsContainer: (provided)=>({
                                ...provided,
                                paddingTop: "var(--ds-space-075, 6px)",
                                paddingBottom: "var(--ds-space-075, 6px)",
                                paddingLeft: "var(--ds-space-025, 2px)",
                                paddingRight: "var(--ds-space-075, 6px)",
                                ...(cssOverrides || {}).indicatorsContainer
                            }),
                        // @ts-ignore
                        option: (provided, state)=>({
                                ...provided,
                                cursor: 'pointer',
                                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`,
                                whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word',
                                backgroundColor: state.isSelected ? '#B2D4FF' : state.isFocused ? '#EBECF0' : '#FAFBFC',
                                color: state.isSelected ? '#0065FF' : '#172B4D',
                                '&:hover': {
                                    background: state.isSelected ? '#B2D4FF' : '#EBECF0'
                                },
                                '&:active': {
                                    // eslint-disable-next-line local/ensure-wac-token-usage
                                    background: '#DFE1E5'
                                },
                                ...(cssOverrides || {}).option
                            }),
                        // @ts-ignore
                        input: (provided)=>({
                                ...provided,
                                color: 'transparent',
                                ...(cssOverrides || {}).input
                            })
                    }
                })
            })
        ]
    });
};

});

parcelRegister("8cfMz", function(module, exports) {
$parcel$export(module.exports, "getProductCalculationInputs", function () { return $2c139569c5386442$export$915d8a609f55f86e; });

var $hrGO1 = parcelRequire("hrGO1");
const $2c139569c5386442$export$915d8a609f55f86e = (productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    const getNumUnits = (planName, signupUnitLimit)=>{
        let adjNumUnits = 0;
        // following scenarios do not have pricing and should send a zero unit count,
        // the zero pricing will not be displayed and is needed only to retain the
        // correct array order of the pricing requests/responses
        // Free plan has no pricing
        const isFree = planName === (0, $hrGO1.SpecialPlanNames).FREE;
        // Enterprise plans do not have monthly pricing
        const isMonthlyEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && billingCycle === 'MONTHLY';
        // Enterprise plans have a minimum unit count
        const isUnmetUnitCountEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
        const isOverSignupUnitLimit = unitCount > signupUnitLimit;
        if (![
            isFree,
            isMonthlyEnterprise,
            isUnmetUnitCountEnterprise,
            isOverSignupUnitLimit
        ].includes(true)) adjNumUnits = unitCount;
        // keep unit count to general maximum limit
        return Math.min(adjNumUnits, signupUnitLimit);
    };
    const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
            ccpOfferingSKU: offeringSku,
            hamsProductKey: undefined,
            numUnits: getNumUnits(planName, signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT),
            period: billingCycle
        }));
    return planPriceReqs;
};

});

parcelRegister("5CQu1", function(module, exports) {
$parcel$export(module.exports, "calculateProductPricing", function () { return $a686a54aa7deba91$export$6c0aa9d51dade71d; });

var $1mbEv = parcelRequire("1mbEv");
const $a686a54aa7deba91$export$6c0aa9d51dade71d = (ccpPricingData, productCalculationInputs, currencyISOCode, localeISOCode)=>{
    const productPricing = [];
    for (const planCalculationInputs of productCalculationInputs){
        const { ccpOfferingSKU: ccpOfferingSKU, numUnits: numUnits, period: period } = planCalculationInputs;
        const planPricing = (0, $1mbEv.calculatePlanPricing)({
            ccpPricingData: ccpPricingData,
            ccpOfferingSKU: ccpOfferingSKU,
            numUnits: numUnits,
            period: period,
            currencyISOCode: currencyISOCode,
            localeISOCode: localeISOCode
        });
        productPricing.push({
            // @ts-ignore
            offeringSku: ccpOfferingSKU,
            ...planPricing
        });
    }
    return productPricing;
};

});
parcelRegister("1mbEv", function(module, exports) {
$parcel$export(module.exports, "calculatePlanPricing", function () { return $0f584d23bad95648$export$f9574505c9651410; });

var $69Lp1 = parcelRequire("69Lp1");

var $8dsKS = parcelRequire("8dsKS");

var $1RK9J = parcelRequire("1RK9J");

var $aTHox = parcelRequire("aTHox");

var $9Nmuw = parcelRequire("9Nmuw");
const $0f584d23bad95648$var$hamsPricingDataStub = {};
const $0f584d23bad95648$var$hamsProductKeyStub = '';
function $0f584d23bad95648$export$f9574505c9651410(args) {
    const { ccpPricingData: ccpPricingData, ccpOfferingSKU: ccpOfferingSKU, period: period, numUnits: numUnits, currencyISOCode: currencyISOCode, localeISOCode: localeISOCode } = args;
    if (numUnits === 0) return {
        offeringSku: ccpOfferingSKU,
        ...(0, $1RK9J.getFreePriceCalc)(currencyISOCode)
    };
    else {
        let getCcpTiers = undefined;
        if (ccpOfferingSKU === (0, $9Nmuw.rovoDevOfferingSkus).standard || ccpOfferingSKU === (0, $aTHox.bitbucketOfferingSkus).standard || ccpOfferingSKU === (0, $aTHox.bitbucketOfferingSkus).premium) // rovodev-standard price-plans contain both user and rovodev-credits charge-items
        // bitbucket-standard and bitbucket-premium price-plans contain both user and bitbucket-credits charge-items as well
        // so, we need to get the plan with the user charge-item
        // todo: GWP-8253 move out of reusable calc logic
        getCcpTiers = (pricingPlans)=>pricingPlans.items.find((item)=>item.chargeElement === 'user');
        const pricingTiers = (0, $69Lp1.extractPricingTiersFromEntry)(ccpPricingData, $0f584d23bad95648$var$hamsPricingDataStub, period, currencyISOCode, ccpOfferingSKU, $0f584d23bad95648$var$hamsProductKeyStub, getCcpTiers);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            return {
                offeringSku: ccpOfferingSKU,
                ...(0, $1RK9J.getFreePriceCalc)(currencyISOCode)
            };
        } else return {
            offeringSku: ccpOfferingSKU,
            ...(0, $8dsKS.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode)
        };
    }
}

});


parcelRegister("d6iWh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02761af2cf514ed8$var$_react = $02761af2cf514ed8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $02761af2cf514ed8$var$_baseNew = $02761af2cf514ed8$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $02761af2cf514ed8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02761af2cf514ed8$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $02761af2cf514ed8$var$_react.default.createElement($02761af2cf514ed8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$02761af2cf514ed8$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $02761af2cf514ed8$var$_default = module.exports.default = $02761af2cf514ed8$var$InformationCircleIcon;

});

parcelRegister("cNamI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f93e34be6622a1cb8208e9984b09a45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $950219ff5e98641d$var$_react = $950219ff5e98641d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $950219ff5e98641d$var$_baseNew = $950219ff5e98641d$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $950219ff5e98641d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $950219ff5e98641d$var$LightbulbIcon = (props)=>/*#__PURE__*/ $950219ff5e98641d$var$_react.default.createElement($950219ff5e98641d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$950219ff5e98641d$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $950219ff5e98641d$var$_default = module.exports.default = $950219ff5e98641d$var$LightbulbIcon;

});

parcelRegister("5tLnS", function(module, exports) {
$parcel$export(module.exports, "useDeferSiteNamingContinueUrl", function () { return $202faeefc4f73a47$export$a0ddbbade87631d7; });

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $fcO7r = parcelRequire("fcO7r");

var $gZgIU = parcelRequire("gZgIU");

var $7GVWk = parcelRequire("7GVWk");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");
// The experiment targets Jira Software only — matches the `useLoggedOutJira`
// cohort in the experiment manifest. If we ever expand to JSM / JPD, add
// their product keys here and update the experiment's cohort accordingly.
const $202faeefc4f73a47$var$JIRA_PRODUCT_KEYS = [
    (0, $fcO7r.ProductKey).JIRA_SOFTWARE
];
const $202faeefc4f73a47$export$a0ddbbade87631d7 = ()=>{
    const { product: product, edition: edition } = (0, $7GVWk.useUserContext)();
    const { locale: locale } = (0, $8e22h.default)();
    const deferSiteNamingExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).d1d6DeferSiteNaming);
    const isEnrolledInVariant = deferSiteNamingExperiment.type === 'enrolled' && deferSiteNamingExperiment.value;
    // Fire the Statsig exposure for BOTH arms (control and variant) here, at the
    // signup form. This is the single divergence point where the user is still
    // logged out and therefore still satisfies the experiment's `useLoggedOutJira`
    // cohort, so `useExperiment` reports `enrolled` and `fireExposure()` actually
    // emits. It is the ONLY place the exposure can fire correctly: every
    // downstream divergent surface — the control site-naming page
    // (`LoggedInJiraNewUser`) and the variant `DeferSiteNamingGate` on the
    // confirmation page — renders AFTER account creation, where the user is
    // logged in, the cohort no longer holds, and `fireExposure()` silently
    // no-ops. The ref guard keeps this to a single fire across Strict Mode
    // double-invokes and re-renders.
    const hasFiredExposureRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (hasFiredExposureRef.current) return;
        if (deferSiteNamingExperiment.type !== 'enrolled') return;
        hasFiredExposureRef.current = true;
        deferSiteNamingExperiment.fireExposure();
    }, [
        deferSiteNamingExperiment
    ]);
    return (0, $1oC0p.useCallback)(()=>{
        // Bail early for control, non-enrolled, missing product, or non-Jira products.
        // Keeping `product` in the predicate gives TS the narrowing it needs below.
        if (!isEnrolledInVariant || !product || !$202faeefc4f73a47$var$JIRA_PRODUCT_KEYS.includes(product.key)) return undefined;
        return (0, $gZgIU.getDeferSiteNamingConfirmationPageUrl)({
            productKey: product.key,
            edition: edition ?? 'free',
            locale: locale
        });
    }, [
        product,
        edition,
        isEnrolledInVariant,
        locale
    ]);
};

});

parcelRegister("8kWtd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4df587d0c3f1832e97f8caba30d1552>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $611d8beea2f13157$var$_react = $611d8beea2f13157$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $611d8beea2f13157$var$_baseNew = $611d8beea2f13157$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $611d8beea2f13157$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeTextSummary".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for summarizing content with Atlassian Intelligence & Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $611d8beea2f13157$var$AiGenerativeTextSummaryIcon = (props)=>/*#__PURE__*/ $611d8beea2f13157$var$_react.default.createElement($611d8beea2f13157$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v1.5H1zm0 4.166h14v1.5H1zm10.796 4.328a.75.75 0 0 1 1.41 0l.615 1.687 1.686.615a.75.75 0 0 1 0 1.41l-1.686.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.687-.615a.75.75 0 0 1 0-1.41l1.687-.615zM1 9.333h7v1.5H1zm0 4.166h5v1.5H1z" clip-rule="evenodd"/>`
    }, props));
$611d8beea2f13157$var$AiGenerativeTextSummaryIcon.displayName = 'AiGenerativeTextSummaryIcon';
var $611d8beea2f13157$var$_default = module.exports.default = $611d8beea2f13157$var$AiGenerativeTextSummaryIcon;

});

parcelRegister("a7Xqx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75f8a7cd1e999c53$var$_react = $75f8a7cd1e999c53$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $75f8a7cd1e999c53$var$_baseNew = $75f8a7cd1e999c53$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $75f8a7cd1e999c53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75f8a7cd1e999c53$var$BacklogIcon = (props)=>/*#__PURE__*/ $75f8a7cd1e999c53$var$_react.default.createElement($75f8a7cd1e999c53$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$75f8a7cd1e999c53$var$BacklogIcon.displayName = 'BacklogIcon';
var $75f8a7cd1e999c53$var$_default = module.exports.default = $75f8a7cd1e999c53$var$BacklogIcon;

});

parcelRegister("aVTcD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83cc862a6ce0fb1f7d8883d625af8c63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f5a0c5cabda2415$var$_react = $7f5a0c5cabda2415$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7f5a0c5cabda2415$var$_baseNew = $7f5a0c5cabda2415$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $7f5a0c5cabda2415$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f5a0c5cabda2415$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $7f5a0c5cabda2415$var$_react.default.createElement($7f5a0c5cabda2415$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$7f5a0c5cabda2415$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $7f5a0c5cabda2415$var$_default = module.exports.default = $7f5a0c5cabda2415$var$BookWithBookmarkIcon;

});

parcelRegister("5II9n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35a8ca9f503841cffe12f1ff6d6bb3be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42a34f1e2299b39e$var$_react = $42a34f1e2299b39e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $42a34f1e2299b39e$var$_baseNew = $42a34f1e2299b39e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $42a34f1e2299b39e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Camera".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: upload photo in Trello, photos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42a34f1e2299b39e$var$CameraIcon = (props)=>/*#__PURE__*/ $42a34f1e2299b39e$var$_react.default.createElement($42a34f1e2299b39e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.4.8A.75.75 0 0 1 6 .5h4a.75.75 0 0 1 .6.3l1.275 1.7h1.375A2.75 2.75 0 0 1 16 5.25V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.25A2.75 2.75 0 0 1 2.75 2.5h1.375zM6.375 2 5.1 3.7a.75.75 0 0 1-.6.3H2.75c-.69 0-1.25.56-1.25 1.25V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V5.25c0-.69-.56-1.25-1.25-1.25H11.5a.75.75 0 0 1-.6-.3L9.625 2zM8 6.5A1.75 1.75 0 1 0 8 10a1.75 1.75 0 0 0 0-3.5M4.75 8.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0" clip-rule="evenodd"/>`
    }, props));
$42a34f1e2299b39e$var$CameraIcon.displayName = 'CameraIcon';
var $42a34f1e2299b39e$var$_default = module.exports.default = $42a34f1e2299b39e$var$CameraIcon;

});

parcelRegister("loQfN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4a862ad906af43648c20a01ac989d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9445f6570be1c0c$var$_react = $f9445f6570be1c0c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f9445f6570be1c0c$var$_baseNew = $f9445f6570be1c0c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f9445f6570be1c0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f9445f6570be1c0c$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $f9445f6570be1c0c$var$_react.default.createElement($f9445f6570be1c0c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h1.5v7.94l3.22-3.22a.75.75 0 0 1 1.06 0L8.5 7.44l3.94-3.94H10V2h4.25a.75.75 0 0 1 .75.75V7h-1.5V4.56L9.03 9.03a.75.75 0 0 1-1.06 0L6.25 7.31 2.5 11.06V13a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$f9445f6570be1c0c$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $f9445f6570be1c0c$var$_default = module.exports.default = $f9445f6570be1c0c$var$ChartTrendIcon;

});

parcelRegister("dO8Do", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0d6a48064846045$var$_react = $a0d6a48064846045$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a0d6a48064846045$var$_baseNew = $a0d6a48064846045$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $a0d6a48064846045$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0d6a48064846045$var$DecisionIcon = (props)=>/*#__PURE__*/ $a0d6a48064846045$var$_react.default.createElement($a0d6a48064846045$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$a0d6a48064846045$var$DecisionIcon.displayName = 'DecisionIcon';
var $a0d6a48064846045$var$_default = module.exports.default = $a0d6a48064846045$var$DecisionIcon;

});

parcelRegister("3FUL0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84a07eff465bcaaea8db49f0fc7877da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ad13a3cc41068cb$var$_react = $2ad13a3cc41068cb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2ad13a3cc41068cb$var$_baseNew = $2ad13a3cc41068cb$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $2ad13a3cc41068cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ad13a3cc41068cb$var$DepartmentIcon = (props)=>/*#__PURE__*/ $2ad13a3cc41068cb$var$_react.default.createElement($2ad13a3cc41068cb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$2ad13a3cc41068cb$var$DepartmentIcon.displayName = 'DepartmentIcon';
var $2ad13a3cc41068cb$var$_default = module.exports.default = $2ad13a3cc41068cb$var$DepartmentIcon;

});

parcelRegister("3OOxO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c7d3fa40e32f890$var$_react = $2c7d3fa40e32f890$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2c7d3fa40e32f890$var$_baseNew = $2c7d3fa40e32f890$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $2c7d3fa40e32f890$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2c7d3fa40e32f890$var$EditIcon = (props)=>/*#__PURE__*/ $2c7d3fa40e32f890$var$_react.default.createElement($2c7d3fa40e32f890$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$2c7d3fa40e32f890$var$EditIcon.displayName = 'EditIcon';
var $2c7d3fa40e32f890$var$_default = module.exports.default = $2c7d3fa40e32f890$var$EditIcon;

});

parcelRegister("2JPM3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0744cae5af6a1635a1b9234b867386>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1fe7f200582e6f72$var$_react = $1fe7f200582e6f72$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1fe7f200582e6f72$var$_baseNew = $1fe7f200582e6f72$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $1fe7f200582e6f72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1fe7f200582e6f72$var$EmojiIcon = (props)=>/*#__PURE__*/ $1fe7f200582e6f72$var$_react.default.createElement($1fe7f200582e6f72$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$1fe7f200582e6f72$var$EmojiIcon.displayName = 'EmojiIcon';
var $1fe7f200582e6f72$var$_default = module.exports.default = $1fe7f200582e6f72$var$EmojiIcon;

});

parcelRegister("6pmKv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4aa6b95fb2f2f167$var$_react = $4aa6b95fb2f2f167$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4aa6b95fb2f2f167$var$_baseNew = $4aa6b95fb2f2f167$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $4aa6b95fb2f2f167$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4aa6b95fb2f2f167$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $4aa6b95fb2f2f167$var$_react.default.createElement($4aa6b95fb2f2f167$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$4aa6b95fb2f2f167$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $4aa6b95fb2f2f167$var$_default = module.exports.default = $4aa6b95fb2f2f167$var$EyeOpenIcon;

});

parcelRegister("6j91P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $497b855083b7f301$var$_react = $497b855083b7f301$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $497b855083b7f301$var$_baseNew = $497b855083b7f301$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $497b855083b7f301$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $497b855083b7f301$var$FeedbackIcon = (props)=>/*#__PURE__*/ $497b855083b7f301$var$_react.default.createElement($497b855083b7f301$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$497b855083b7f301$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $497b855083b7f301$var$_default = module.exports.default = $497b855083b7f301$var$FeedbackIcon;

});

parcelRegister("2RA08", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $215c7517353ffee6$var$_react = $215c7517353ffee6$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $215c7517353ffee6$var$_baseNew = $215c7517353ffee6$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $215c7517353ffee6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $215c7517353ffee6$var$FileIcon = (props)=>/*#__PURE__*/ $215c7517353ffee6$var$_react.default.createElement($215c7517353ffee6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$215c7517353ffee6$var$FileIcon.displayName = 'FileIcon';
var $215c7517353ffee6$var$_default = module.exports.default = $215c7517353ffee6$var$FileIcon;

});

parcelRegister("9A47Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b192fbc7db5453924997563ea93d01df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f9aad8d62c1233e$var$_react = $6f9aad8d62c1233e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6f9aad8d62c1233e$var$_baseNew = $6f9aad8d62c1233e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $6f9aad8d62c1233e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Files".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: documents, files. Do not use to represent pages — use the dedicated 'Pages' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f9aad8d62c1233e$var$FilesIcon = (props)=>/*#__PURE__*/ $6f9aad8d62c1233e$var$_react.default.createElement($6f9aad8d62c1233e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 11a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4.25c0-.52-.208-1.02-.578-1.385L9.072.543A1.88 1.88 0 0 0 7.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h3v2.75c0 .414.336.75.75.75h2.75v6a.5.5 0 0 1-.5.5zm5.93-8H8.5V2.087z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7 16h4.75A3.25 3.25 0 0 0 15 12.75V5h-1.5v7.75a1.75 1.75 0 0 1-1.75 1.75H7z" clip-rule="evenodd"/>`
    }, props));
$6f9aad8d62c1233e$var$FilesIcon.displayName = 'FilesIcon';
var $6f9aad8d62c1233e$var$_default = module.exports.default = $6f9aad8d62c1233e$var$FilesIcon;

});

parcelRegister("49zFb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43a7428702b82788297fb999fe29f0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3063aaa999ab433f$var$_react = $3063aaa999ab433f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3063aaa999ab433f$var$_baseNew = $3063aaa999ab433f$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3063aaa999ab433f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3063aaa999ab433f$var$InformationIcon = (props)=>/*#__PURE__*/ $3063aaa999ab433f$var$_react.default.createElement($3063aaa999ab433f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$3063aaa999ab433f$var$InformationIcon.displayName = 'InformationIcon';
var $3063aaa999ab433f$var$_default = module.exports.default = $3063aaa999ab433f$var$InformationIcon;

});

parcelRegister("eAAXu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9f118b18787d1b2$var$_react = $a9f118b18787d1b2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a9f118b18787d1b2$var$_baseNew = $a9f118b18787d1b2$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $a9f118b18787d1b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9f118b18787d1b2$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $a9f118b18787d1b2$var$_react.default.createElement($a9f118b18787d1b2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$a9f118b18787d1b2$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $a9f118b18787d1b2$var$_default = module.exports.default = $a9f118b18787d1b2$var$ListBulletedIcon;

});

parcelRegister("6hGO6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bbccaea74398c387e69395dfeae5f34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4935892ffc4dede5$var$_react = $4935892ffc4dede5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4935892ffc4dede5$var$_baseNew = $4935892ffc4dede5$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $4935892ffc4dede5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4935892ffc4dede5$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $4935892ffc4dede5$var$_react.default.createElement($4935892ffc4dede5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$4935892ffc4dede5$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $4935892ffc4dede5$var$_default = module.exports.default = $4935892ffc4dede5$var$PeopleGroupIcon;

});

parcelRegister("kvde0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2b2be59784c9b52b8b3b5b23f53d5b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eed0f61411f9d686$var$_react = $eed0f61411f9d686$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $eed0f61411f9d686$var$_baseNew = $eed0f61411f9d686$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $eed0f61411f9d686$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eed0f61411f9d686$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $eed0f61411f9d686$var$_react.default.createElement($eed0f61411f9d686$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m14.877 2.03-4 4a.75.75 0 0 1-1.051.01L8.98 8.262l1.04-1.08 1.316 1.267 3.48-3.48zM3.75 10.5a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.52a3.75 3.75 0 0 1 3.75 3.75V15h-1.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$eed0f61411f9d686$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $eed0f61411f9d686$var$_default = module.exports.default = $eed0f61411f9d686$var$PersonAddedIcon;

});

parcelRegister("7V9HC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34e6857b52d4ec156a688609aa0810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c4561fcacc10609$var$_react = $5c4561fcacc10609$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5c4561fcacc10609$var$_baseNew = $5c4561fcacc10609$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $5c4561fcacc10609$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c4561fcacc10609$var$PhoneIcon = (props)=>/*#__PURE__*/ $5c4561fcacc10609$var$_react.default.createElement($5c4561fcacc10609$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$5c4561fcacc10609$var$PhoneIcon.displayName = 'PhoneIcon';
var $5c4561fcacc10609$var$_default = module.exports.default = $5c4561fcacc10609$var$PhoneIcon;

});

parcelRegister("gHoFv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c283cc1eb873ea6d$var$_react = $c283cc1eb873ea6d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c283cc1eb873ea6d$var$_baseNew = $c283cc1eb873ea6d$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $c283cc1eb873ea6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c283cc1eb873ea6d$var$RoadmapIcon = (props)=>/*#__PURE__*/ $c283cc1eb873ea6d$var$_react.default.createElement($c283cc1eb873ea6d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$c283cc1eb873ea6d$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $c283cc1eb873ea6d$var$_default = module.exports.default = $c283cc1eb873ea6d$var$RoadmapIcon;

});

parcelRegister("2Qv7t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $212893c4a5d4c950$var$_react = $212893c4a5d4c950$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $212893c4a5d4c950$var$_baseNew = $212893c4a5d4c950$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $212893c4a5d4c950$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $212893c4a5d4c950$var$StarStarredIcon = (props)=>/*#__PURE__*/ $212893c4a5d4c950$var$_react.default.createElement($212893c4a5d4c950$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$212893c4a5d4c950$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $212893c4a5d4c950$var$_default = module.exports.default = $212893c4a5d4c950$var$StarStarredIcon;

});

parcelRegister("5R44a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44350e76e967080f$var$_react = $44350e76e967080f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $44350e76e967080f$var$_baseNew = $44350e76e967080f$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $44350e76e967080f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $44350e76e967080f$var$TeamsIcon = (props)=>/*#__PURE__*/ $44350e76e967080f$var$_react.default.createElement($44350e76e967080f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$44350e76e967080f$var$TeamsIcon.displayName = 'TeamsIcon';
var $44350e76e967080f$var$_default = module.exports.default = $44350e76e967080f$var$TeamsIcon;

});

parcelRegister("aUEBX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7c2be3f7c9d9cc79e629bb0768f3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f1ea2e2c453dc33$var$_react = $7f1ea2e2c453dc33$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7f1ea2e2c453dc33$var$_baseNew = $7f1ea2e2c453dc33$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $7f1ea2e2c453dc33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Timeline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for timelines in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f1ea2e2c453dc33$var$TimelineIcon = (props)=>/*#__PURE__*/ $7f1ea2e2c453dc33$var$_react.default.createElement($7f1ea2e2c453dc33$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11 2.5H1V1h10zm4 4.167H5v-1.5h10zm-4 4.167H1v-1.5h10zM15 15H5v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$7f1ea2e2c453dc33$var$TimelineIcon.displayName = 'TimelineIcon';
var $7f1ea2e2c453dc33$var$_default = module.exports.default = $7f1ea2e2c453dc33$var$TimelineIcon;

});

parcelRegister("djIg7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c615014b011664b243a37531e093f861>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b1f619c052c2afa$var$_react = $9b1f619c052c2afa$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9b1f619c052c2afa$var$_baseNew = $9b1f619c052c2afa$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $9b1f619c052c2afa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b1f619c052c2afa$var$WarningIcon = (props)=>/*#__PURE__*/ $9b1f619c052c2afa$var$_react.default.createElement($9b1f619c052c2afa$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$9b1f619c052c2afa$var$WarningIcon.displayName = 'WarningIcon';
var $9b1f619c052c2afa$var$_default = module.exports.default = $9b1f619c052c2afa$var$WarningIcon;

});

parcelRegister("eZVel", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d727d3cc18de179b7b728d0be1f533d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aeb327f65461dbf8$var$_react = $aeb327f65461dbf8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $aeb327f65461dbf8$var$_baseNew = $aeb327f65461dbf8$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $aeb327f65461dbf8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aeb327f65461dbf8$var$RefreshIcon = (props)=>/*#__PURE__*/ $aeb327f65461dbf8$var$_react.default.createElement($aeb327f65461dbf8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$aeb327f65461dbf8$var$RefreshIcon.displayName = 'RefreshIcon';
var $aeb327f65461dbf8$var$_default = module.exports.default = $aeb327f65461dbf8$var$RefreshIcon;

});

parcelRegister("iNnWi", function(module, exports) {
$parcel$export(module.exports, "getProductSoftwareDevelopmentModalImage", function () { return $3283639d1ff6b124$export$6954fe49bbdabc54; });
$parcel$export(module.exports, "getProductMarketingModalImage", function () { return $3283639d1ff6b124$export$cc19a82b226e3f08; });
$parcel$export(module.exports, "getUpdatedProductItModalImage", function () { return $3283639d1ff6b124$export$f31d1f714b55f0fb; });
$parcel$export(module.exports, "getProductDesignModalImage", function () { return $3283639d1ff6b124$export$e0ab49165f0180f7; });
$parcel$export(module.exports, "getProductOperationsModalImage", function () { return $3283639d1ff6b124$export$51a8246da0eeafec; });
$parcel$export(module.exports, "getDoubleFeatureFirstImage", function () { return $3283639d1ff6b124$export$af7f348492750745; });
$parcel$export(module.exports, "getDoubleFeatureSecondImage", function () { return $3283639d1ff6b124$export$51c1e8c9994962ad; });
$parcel$export(module.exports, "getCollaborateFirstImage", function () { return $3283639d1ff6b124$export$7a98b35c48983fe6; });
$parcel$export(module.exports, "getCollaborateSecondImage", function () { return $3283639d1ff6b124$export$3ff8286854e1bb40; });
$parcel$export(module.exports, "getCollaborateThirdImage", function () { return $3283639d1ff6b124$export$54ce02c1025509fa; });
$parcel$export(module.exports, "getCollaborateFourthImage", function () { return $3283639d1ff6b124$export$ea3cb1bf26550cc6; });
$parcel$export(module.exports, "getHeroCardOperationsImage", function () { return $3283639d1ff6b124$export$a27f10b8f2dbe6ec; });
$parcel$export(module.exports, "getHeroCardDesignImage", function () { return $3283639d1ff6b124$export$d2a58a00fc2c43; });
$parcel$export(module.exports, "getHeroCardItImage", function () { return $3283639d1ff6b124$export$e7e5a083e5974d8d; });
$parcel$export(module.exports, "getHeroCardMarketingImage", function () { return $3283639d1ff6b124$export$bf236abab7f9a91d; });
$parcel$export(module.exports, "getHeroCardSoftwareDevelopmentImage", function () { return $3283639d1ff6b124$export$44d7a932d2767a7a; });
$parcel$export(module.exports, "getStaggeredDoubleFeautureSecondImage", function () { return $3283639d1ff6b124$export$2d0f6370ca103766; });
$parcel$export(module.exports, "getStaggeredDoubleFeautureFirstImage", function () { return $3283639d1ff6b124$export$78335ebe3bbd9065; });
$parcel$export(module.exports, "getAiVideo", function () { return $3283639d1ff6b124$export$944f00714b8c3d98; });
$parcel$export(module.exports, "getAiImage", function () { return $3283639d1ff6b124$export$2e497ec5a3f0e9f7; });
$parcel$export(module.exports, "getAiVideoJSM", function () { return $3283639d1ff6b124$export$e88a1961b910936; });
$parcel$export(module.exports, "getAiImageJSM", function () { return $3283639d1ff6b124$export$be405a6adaf81ee7; });
/* eslint-disable @typescript-eslint/no-non-null-assertion */ const $3283639d1ff6b124$var$aiVideoJSMProductTourMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ov2b53oh3ly6rgucw1do7w4xoni4d6qh.mp4'
};
const $3283639d1ff6b124$var$aiImageJSMProductTourMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3cd8m6q81i47wxm8nt733jv5h885h064.webp'
};
const $3283639d1ff6b124$var$aiVideoMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/c57sisavif7febh3gsegy4vp55lm66v1.mp4'
};
const $3283639d1ff6b124$var$aiImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3mo3s2f6q0xfbg75wj1fqyjayo6ta246.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l3mu66v75b212vhbp3v18217neb26r30.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/25qwhvk4ue212kn22s30d38la4p58d81.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4hhj8m4kmqh5es882153t0um1s327867.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d5t1854qx65olc52p81k78p5336547sl.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8mj2v25vh521026wl1f7wv3a7ts63cb0.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/avkee2xvjgp258dmf71tt5u060cr0bj4.webp'
};
const $3283639d1ff6b124$var$staggaredDoubleFeautureFirstImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ex8536t33720160jkps31diiavoq7wa6.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t67x4j1qeis0c6330we56e5op7j58040.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4863jx76lcis60cobj438qq2f76r6110.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q5q45b8nf7dwl071122e311n0x2c8i6o.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qd37iok4pb43q380hyxv8ran8iegwopd.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qyc8q4674b85g13bsliagfc2sv2nt1l7.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8c4y5koi0roj2a5gl14ya60101g867dp.webp'
};
const $3283639d1ff6b124$var$staggaredDoubleFeautureSecondImageMap = {
    en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/new-staggered-double-feature-2.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ye325r1c82vwe80p17v707876sor0v57.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/kc48608o743ijn83hfsc7248o0855n33.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/r0138653i47tn4bd3ms25o67277wb4en.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/25a73j3b325y5433sgkc4056k8u2bgs2.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qyc8q4674b85g13bsliagfc2sv2nt1l7.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/rulhdo87w10h368w5k071a7544kfdi34.webp'
};
const $3283639d1ff6b124$var$heroCardSoftwareDevelopmentImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ue25kj6kn4wq0wn1qg02q56fyop66rj8.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t1p200v6f4ug14ngayoyim42cy1618bc.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/684fjfuywyexc1a23u572wcj05fi84y0.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m51m5bb51aj4548p81jssu7w660ro0f8.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l01f0tas2w10qap5g6u81tcq516vg37x.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/smh5n4ctme1r523d1g3uf7lm60130o04.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0j22k38v760owv56755oje0p37yeo711.webp'
};
const $3283639d1ff6b124$var$heroCardMarketingImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m5hssc3g11uo84qx614br11443b744l3.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/63wxf44y8ut01ncxb0vo3g1762p76oe7.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5u4x162411psnh2s22l4le4184aj4al3.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/30rrl683rurgws20103f520tec8a0b4r.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q5gymh0604qp2b2vy2fiwymo6bcj5x47.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6hq32u063ywsjill83o7v2a283g6jtq3.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p3hnqjlr54wg1w56adkc254mb756ye22.webp'
};
const $3283639d1ff6b124$var$heroCardItImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b00tc08w5880bt2xx078p24e142u0561.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/01oj3p2mmd1srk878al477q26840m1yv.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fj108jc842621v46n6djd408300vcfod.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vvuv40v0ibe0c2jh7xqdy3le0ev673np.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/tg55er46478ged8wg75q0muh70l03xp4.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/w2vr012658o07r84oikfd3vmw1728e31.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/sqst050suh056l837i652ato1382b4p0.webp'
};
const $3283639d1ff6b124$var$heroCardDesignImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/n831bpy2hv077jl7q3uvymb57bx0js6d.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t7m1271fl2r40704e4u5i1r07b28bv3a.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3v68u503i5xkawuuf45g6uq85syu7h05.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/686564sowva47fegxg4y73oi8o6d77s6.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/rvj516a70mqo3hu0lgv2si7h0w08015i.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l0u14221yq50dk1khv04lunbo6k271fd.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/66sjkv3q65r33272rgr0y35m72726ekc.webp'
};
const $3283639d1ff6b124$var$heroCardOperationsImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6w08m6f83182557c4n2gdqd5lc8bxgux.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7t8ueumf388d67yap32075jv4n0w83lq.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/360yo8kpm3rl16l3d714vx8puhjs3a8x.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p6ioacvwp466w8lh28582w86io78kv75.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2hx5h0y3380nx822w58k37ou7lt382a0.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b75eb832avo555l01i0tf77yfr23ai80.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2y560886wr2048l0r4hxs6w5ym64doj7.webp'
};
const $3283639d1ff6b124$var$collaborateFirstImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1u8phig8g50c70bnq25c6x5htq6b253w.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/25udrh4pt816l1xn2s76v5fbk866h103.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/71x7642o01xexq1j3j36318p8hp3l4a7.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6g6278kp6hdn68of821401s82qbd3dc8.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/df3a577s74j71s4q86w3fw2xh7r0kpxv.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/khf18qf74wmj0l07o8wh834t2h473ofn.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/26i42bqsjw1p6528lnf58602d7sjyksj.webp'
};
const $3283639d1ff6b124$var$collaborateSecondImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/30ref08c2xjhdi3bypsd4l534o6343k6.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/u53361562rpcil174kh548pmj47wk23r.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3it6mj67uqnn1kqqec0fili26xy1ad5a.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/h78h53re850ksk5b2u6mi3840u213jr7.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/cuikrei76g1lf48du36620j33lfkbaav.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/orake1uc43tel34v10d2lgp47pnkv65h.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/yykayg74usu65600v256n3sqnv6x6yov.webp'
};
const $3283639d1ff6b124$var$collaborateThirdImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2tqg4ls4336u276d4f6y7rennjd1t742.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/866dvbo07ft271755xa204dm1p4ej1sa.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vai65atabw3lwv7w0abi8w748gf3725m.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/c3b3d36p064m286t2w140a75imlk0b76.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s8038n5n37vkf1w3c75iy7y1o7871a43.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hi58ex76esr013c8kr8xys2p036873w2.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5r0r46q12refy5k44k760k6g3tyiy7l0.webp'
};
const $3283639d1ff6b124$var$collaborateFourthImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/j7ib7le01l6x411v5h42l87m64l0f611.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m88b68g3r0vsqpmoe60kf2sps5717w22.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6wox43k7ynt50p8w10bx6yj464ohbi68.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/01076d8sr5n4102kr7mgk302120o1421.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pxrvm8q420v080r6nk43l87l6j1jr5j7.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/34301480xcnvb0qv17v074o405q67r30.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o80f05nbv41b7i2ug006675p00r6027r.webp'
};
const $3283639d1ff6b124$var$doubleFeatureFirstImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/754lk6c6s3xkb50hyimkf4aujig8h7e8.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/85025n6sg53gb1o54gw52sa0a8l5252y.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/kp1g7ob05s14rv38xrl478bak8j1enwc.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6c3xt34m70oh8712kl7p3225la77fb25.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/e717x180w2841fge4313e207b27f0jlp.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/52w7e23sbeuy32p6y3n06w7e2082yhxu.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v74q0j753uk82d464054gqr5u568dw5w.webp'
};
const $3283639d1ff6b124$var$doubleFeatureSecondImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m8lju6a7edoja1ey3g865yj77rgt2n6j.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/iddw2873d71vdyu0wrmasn218jn87a7f.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3e6ib72c51x05342cv48k07a0wo1jx7v.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x64it50wnwrpqm50wye4140q63lm47y7.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/63apc7jibfy0ms6ntjv1486rcen53oc4.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3761m3b1ktjte0puv5f23r67n0be6rg5.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/837mvx5jali362e7a7504m853u81l73w.webp'
};
const $3283639d1ff6b124$var$productSoftwareDevelopmentModalImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/41y0vfa38q60m5384dg7sa765mf4ro28.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pr2e520p47gw100v5eep6831u755nm23.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m5070g810735714b11i5081065621m4s.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/46du0bd600v7yneguim2p18s2bmx38vt.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/365d4k835x4xj45a5wf6r7u3i865283g.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6smuygao6ka5l72ud1e80j6cw33a5107.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0k440p3esv0l6u5c6dvgv2660166u7m4.webp'
};
const $3283639d1ff6b124$var$productMarketingModalImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i58e36nty6p6km3a64v20ow565ecq126.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hxx6isxs3m277360y8iub0e65pn6so78.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/j21lvt288m01q3m7g6f0l3d1bhjmdb24.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7u5oc32sv0yh6q1vdh2u60jnq8dwy2vk.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/61nt5bt5l4sebtma1l3a7e6w400dae0g.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ibp320cjl61b0rd8873ra2o332j266j4.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wkx7n8q12fn88166l3y207e5f53xd646.webp'
};
const $3283639d1ff6b124$var$productItModalImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/75ous6w840rg1doie0203543yt22qnpa.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/r52381x63k34ljy2v248746pixvx76e5.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d7q26epsti24r540gfcd4c5c1173cmc8.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/330645peuxhlid3577lr71073dm5ieyl.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xpyktqf5jil6xah1xd7u54g8f08vi74j.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7a7kgk12347go142kr1euulv6058uak6.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p70x4xyevviso1is348gj5yuci5735pk.webp'
};
const $3283639d1ff6b124$var$updatedProductItModalImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/whjwswo26s750yn06387a0s80ehy3e52.webp'
};
const $3283639d1ff6b124$var$productDesignModalImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b2x4amce3w8mn2b213mtx3r31n44403q.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/44u783fxt66o02mxf5lr7kbw1xty380i.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/08smrtsr040biq47toh66t6us66q1o00.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7y78rlqj681mf1jlh7o65l525s6m7eya.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1a3lwr5vav0fd2a3yp4ouw244u1d1u36.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/57dmhof07485d05q2cdubfx65vxs85ah.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/u11mi1pyr7ncq1ur1b2x20y0774185ru.webp'
};
const $3283639d1ff6b124$var$productOperationsModalImageMap = {
    en: 'https://dam-cdn.atl.orangelogic.com/AssetLink/rf4b8d0jn3u85g7rn8uf8481a1n1t8l5.webp',
    fr: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q4hr0hm0ooqt42r0156010yevq5v3646.webp',
    es: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m5p21md0n60ec14qju78yfq7517sase0.webp',
    ja: 'https://dam-cdn.atl.orangelogic.com/AssetLink/n1w6347fgj1icy62w6gmak63ty1i66rq.webp',
    ru: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7v5df3xyd24e02x68l71pi0vrpsi1h86.webp',
    br: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v1e777xn7wd21g22ytpg5t44d055li82.webp',
    de: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0eo1cu114id26b7ed48g46igo4j11pma.webp'
};
const $3283639d1ff6b124$export$6954fe49bbdabc54 = (locale)=>{
    return $3283639d1ff6b124$var$productSoftwareDevelopmentModalImageMap[locale] || $3283639d1ff6b124$var$productSoftwareDevelopmentModalImageMap['en'];
};
const $3283639d1ff6b124$export$cc19a82b226e3f08 = (locale)=>{
    return $3283639d1ff6b124$var$productMarketingModalImageMap[locale] || $3283639d1ff6b124$var$productMarketingModalImageMap['en'];
};
const $3283639d1ff6b124$export$fa7e84d2d2c567a7 = (locale)=>{
    return $3283639d1ff6b124$var$productItModalImageMap[locale] || $3283639d1ff6b124$var$productItModalImageMap['en'];
};
const $3283639d1ff6b124$export$f31d1f714b55f0fb = (locale)=>{
    return $3283639d1ff6b124$var$updatedProductItModalImageMap[locale] || $3283639d1ff6b124$var$updatedProductItModalImageMap['en'];
};
const $3283639d1ff6b124$export$e0ab49165f0180f7 = (locale)=>{
    return $3283639d1ff6b124$var$productDesignModalImageMap[locale] || $3283639d1ff6b124$var$productDesignModalImageMap['en'];
};
const $3283639d1ff6b124$export$51a8246da0eeafec = (locale)=>{
    return $3283639d1ff6b124$var$productOperationsModalImageMap[locale] || $3283639d1ff6b124$var$productOperationsModalImageMap['en'];
};
const $3283639d1ff6b124$export$af7f348492750745 = (locale)=>{
    return $3283639d1ff6b124$var$doubleFeatureFirstImageMap[locale] || $3283639d1ff6b124$var$doubleFeatureFirstImageMap['en'];
};
const $3283639d1ff6b124$export$51c1e8c9994962ad = (locale)=>{
    return $3283639d1ff6b124$var$doubleFeatureSecondImageMap[locale] || $3283639d1ff6b124$var$doubleFeatureSecondImageMap['en'];
};
const $3283639d1ff6b124$export$7a98b35c48983fe6 = (locale)=>{
    return $3283639d1ff6b124$var$collaborateFirstImageMap[locale] || $3283639d1ff6b124$var$collaborateFirstImageMap['en'];
};
const $3283639d1ff6b124$export$3ff8286854e1bb40 = (locale)=>{
    return $3283639d1ff6b124$var$collaborateSecondImageMap[locale] || $3283639d1ff6b124$var$collaborateSecondImageMap['en'];
};
const $3283639d1ff6b124$export$54ce02c1025509fa = (locale)=>{
    return $3283639d1ff6b124$var$collaborateThirdImageMap[locale] || $3283639d1ff6b124$var$collaborateThirdImageMap['en'];
};
const $3283639d1ff6b124$export$ea3cb1bf26550cc6 = (locale)=>{
    return $3283639d1ff6b124$var$collaborateFourthImageMap[locale] || $3283639d1ff6b124$var$collaborateFourthImageMap['en'];
};
const $3283639d1ff6b124$export$a27f10b8f2dbe6ec = (locale)=>{
    return $3283639d1ff6b124$var$heroCardOperationsImageMap[locale] || $3283639d1ff6b124$var$heroCardOperationsImageMap['en'];
};
const $3283639d1ff6b124$export$d2a58a00fc2c43 = (locale)=>{
    return $3283639d1ff6b124$var$heroCardDesignImageMap[locale] || $3283639d1ff6b124$var$heroCardDesignImageMap['en'];
};
const $3283639d1ff6b124$export$e7e5a083e5974d8d = (locale)=>{
    return $3283639d1ff6b124$var$heroCardItImageMap[locale] || $3283639d1ff6b124$var$heroCardItImageMap['en'];
};
const $3283639d1ff6b124$export$bf236abab7f9a91d = (locale)=>{
    return $3283639d1ff6b124$var$heroCardMarketingImageMap[locale] || $3283639d1ff6b124$var$heroCardMarketingImageMap['en'];
};
const $3283639d1ff6b124$export$44d7a932d2767a7a = (locale)=>{
    return $3283639d1ff6b124$var$heroCardSoftwareDevelopmentImageMap[locale] || $3283639d1ff6b124$var$heroCardSoftwareDevelopmentImageMap['en'];
};
const $3283639d1ff6b124$export$2d0f6370ca103766 = (locale)=>{
    return $3283639d1ff6b124$var$staggaredDoubleFeautureSecondImageMap[locale] || $3283639d1ff6b124$var$staggaredDoubleFeautureSecondImageMap['en'];
};
const $3283639d1ff6b124$export$78335ebe3bbd9065 = (locale)=>{
    return $3283639d1ff6b124$var$staggaredDoubleFeautureFirstImageMap[locale] || $3283639d1ff6b124$var$staggaredDoubleFeautureFirstImageMap['en'];
};
const $3283639d1ff6b124$export$944f00714b8c3d98 = (locale)=>{
    return $3283639d1ff6b124$var$aiVideoMap[locale] || $3283639d1ff6b124$var$aiVideoMap['en'];
};
const $3283639d1ff6b124$export$2e497ec5a3f0e9f7 = (locale)=>{
    return $3283639d1ff6b124$var$aiImageMap[locale] || $3283639d1ff6b124$var$aiImageMap['en'];
};
const $3283639d1ff6b124$export$e88a1961b910936 = (locale)=>{
    return $3283639d1ff6b124$var$aiVideoJSMProductTourMap[locale] || $3283639d1ff6b124$var$aiVideoJSMProductTourMap['en'];
};
const $3283639d1ff6b124$export$be405a6adaf81ee7 = (locale)=>{
    return $3283639d1ff6b124$var$aiImageJSMProductTourMap[locale] || $3283639d1ff6b124$var$aiImageJSMProductTourMap['en'];
};

});

parcelRegister("1pbCD", function(module, exports) {
$parcel$export(module.exports, "Intelligence", function () { return $7ed9ae281286c3c7$export$f080dd2dfaa7a195; });

var $7VQPk = parcelRequire("7VQPk");
const $7ed9ae281286c3c7$export$f080dd2dfaa7a195 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    id: "Group 626186",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M37.3027 23.8756C37.3027 22.4546 38.4547 21.3027 39.8757 21.3027H44.5842C46.0052 21.3027 47.1572 22.4546 47.1572 23.8756C47.1572 25.2967 46.0052 26.4486 44.5842 26.4486H39.8757C38.4547 26.4486 37.3027 25.2967 37.3027 23.8756Z",
                            fill: "url(#paint0_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_2",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0007 0.718933C25.4217 0.718933 26.5737 1.87089 26.5737 3.2919V8.00043C26.5737 9.42144 25.4217 10.5734 24.0007 10.5734C22.5797 10.5734 21.4277 9.42144 21.4277 8.00043V3.2919C21.4277 1.87089 22.5797 0.718933 24.0007 0.718933Z",
                            fill: "url(#paint1_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_3",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0.84375 23.8756C0.84375 22.4546 1.99571 21.3027 3.41672 21.3027H8.12525C9.54626 21.3027 10.6982 22.4546 10.6982 23.8756C10.6982 25.2967 9.54626 26.4486 8.12525 26.4486H3.41672C1.99571 26.4486 0.84375 25.2967 0.84375 23.8756Z",
                            fill: "url(#paint2_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_4",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0007 37.1779C25.4217 37.1779 26.5737 38.3298 26.5737 39.7508V44.4594C26.5737 45.8804 25.4217 47.0323 24.0007 47.0323C22.5797 47.0323 21.4277 45.8804 21.4277 44.4594V39.7508C21.4277 38.3298 22.5797 37.1779 24.0007 37.1779Z",
                            fill: "url(#paint3_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_5",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M29.9001 29.7752C30.9049 28.7703 32.534 28.7703 33.5388 29.7752L43.8307 40.067C44.8355 41.0718 44.8355 42.7009 43.8307 43.7058C42.8259 44.7106 41.1968 44.7106 40.192 43.7058L29.9001 33.4139C28.8953 32.4091 28.8953 30.78 29.9001 29.7752Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_6",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M43.8307 4.04548C44.8355 5.05028 44.8355 6.6794 43.8307 7.6842L33.5388 17.9761C32.534 18.9809 30.9049 18.9809 29.9001 17.9761C28.8953 16.9713 28.8953 15.3422 29.9001 14.3373L40.192 4.04548C41.1968 3.04067 42.8259 3.04067 43.8307 4.04548Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_7",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M4.16962 4.04548C5.17443 3.04067 6.80354 3.04067 7.80835 4.04548L18.1002 14.3373C19.105 15.3422 19.105 16.9713 18.1002 17.9761C17.0954 18.9809 15.4663 18.9809 14.4615 17.9761L4.16962 7.6842C3.16481 6.6794 3.16481 5.05028 4.16962 4.04548Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_8",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M18.1002 29.7752C19.105 30.78 19.105 32.4091 18.1002 33.4139L7.80835 43.7058C6.80354 44.7106 5.17443 44.7106 4.16962 43.7058C3.16481 42.7009 3.16481 41.0718 4.16962 40.067L14.4615 29.7752C15.4663 28.7703 17.0954 28.7703 18.1002 29.7752Z",
                            fill: "white"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint0_linear_2487_5195",
                            x1: "47.1571",
                            y1: "23.8756",
                            x2: "38.1517",
                            y2: "23.8756",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.270833",
                                    stopColor: "#9BC6FF"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint1_linear_2487_5195",
                            x1: "25.2872",
                            y1: "0.718933",
                            x2: "25.2872",
                            y2: "9.72432",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.1875",
                                    stopColor: "#9BC6FF"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint2_linear_2487_5195",
                            x1: "10.6981",
                            y1: "23.8756",
                            x2: "1.69272",
                            y2: "23.8756",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "white"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.791667",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint3_linear_2487_5195",
                            x1: "25.2872",
                            y1: "36.7404",
                            x2: "25.2872",
                            y2: "47.0323",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "white"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.802083",
                                    stopColor: "#A6CCFE"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});


var $3NQOU = parcelRequire("3NQOU");

var $dXL3R = parcelRequire("dXL3R");
(0, $3NQOU.init)((0, $dXL3R.JiraSoftwarePage));


//# sourceMappingURL=jira-software-page.f8e67c09.js.map
